//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AboutUsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    get(): Observable<AboutUsDto> {
        let url_ = this.baseUrl + "/api/services/app/AboutUs/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AboutUsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AboutUsDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AboutUsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AboutUsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param primaryTitle (optional) 
     * @param primaryTitleAr (optional) 
     * @param secondaryTitle (optional) 
     * @param secondaryTitleAr (optional) 
     * @param description (optional) 
     * @param descriptionAr (optional) 
     * @param imageFile (optional) 
     * @param id (optional) 
     * @return OK
     */
    update(primaryTitle: string | undefined, primaryTitleAr: string | undefined, secondaryTitle: string | undefined, secondaryTitleAr: string | undefined, description: string | undefined, descriptionAr: string | undefined, imageFile: FileParameter | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AboutUs/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (primaryTitle === null || primaryTitle === undefined)
            throw new Error("The parameter 'primaryTitle' cannot be null.");
        else
            content_.append("PrimaryTitle", primaryTitle.toString());
        if (primaryTitleAr === null || primaryTitleAr === undefined)
            throw new Error("The parameter 'primaryTitleAr' cannot be null.");
        else
            content_.append("PrimaryTitleAr", primaryTitleAr.toString());
        if (secondaryTitle === null || secondaryTitle === undefined)
            throw new Error("The parameter 'secondaryTitle' cannot be null.");
        else
            content_.append("SecondaryTitle", secondaryTitle.toString());
        if (secondaryTitleAr === null || secondaryTitleAr === undefined)
            throw new Error("The parameter 'secondaryTitleAr' cannot be null.");
        else
            content_.append("SecondaryTitleAr", secondaryTitleAr.toString());
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("Description", description.toString());
        if (descriptionAr === null || descriptionAr === undefined)
            throw new Error("The parameter 'descriptionAr' cannot be null.");
        else
            content_.append("DescriptionAr", descriptionAr.toString());
        if (imageFile === null || imageFile === undefined)
            throw new Error("The parameter 'imageFile' cannot be null.");
        else
            content_.append("ImageFile", imageFile.data, imageFile.fileName ? imageFile.fileName : "ImageFile");
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getForUpdate(): Observable<GetAboutUsForUpdateDto> {
        let url_ = this.baseUrl + "/api/services/app/AboutUs/GetForUpdate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAboutUsForUpdateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAboutUsForUpdateDto>;
        }));
    }

    protected processGetForUpdate(response: HttpResponseBase): Observable<GetAboutUsForUpdateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAboutUsForUpdateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    signUpCompany(body: SignUpCompanyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SignUpCompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignUpCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignUpCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSignUpCompany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    signUpEmployee(body: SignUpEmployeeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SignUpEmployee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignUpEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignUpEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSignUpEmployee(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sendVerifyUserCode(email: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendVerifyUserCode?";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendVerifyUserCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVerifyUserCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendVerifyUserCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    verifyUserAccount(code: string, email: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/VerifyUserAccount?";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyUserAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyUserAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVerifyUserAccount(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    forgetPassword(email: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ForgetPassword?";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processForgetPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    resetPassword(body: ResetPasswordWebsiteDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdvertisementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param title (optional) 
     * @param titleAr (optional) 
     * @param description (optional) 
     * @param descriptionAr (optional) 
     * @param order (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isActive (optional) 
     * @param image (optional) 
     * @param linkUrl (optional) 
     * @param buttonLinkText (optional) 
     * @param buttonLinkTextAr (optional) 
     * @return OK
     */
    create(title: string | undefined, titleAr: string | undefined, description: string | undefined, descriptionAr: string | undefined, order: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, isActive: boolean | undefined, image: FileParameter | undefined, linkUrl: string | undefined, buttonLinkText: string | undefined, buttonLinkTextAr: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Advertisement/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (title === null || title === undefined)
            throw new Error("The parameter 'title' cannot be null.");
        else
            content_.append("Title", title.toString());
        if (titleAr === null || titleAr === undefined)
            throw new Error("The parameter 'titleAr' cannot be null.");
        else
            content_.append("TitleAr", titleAr.toString());
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("Description", description.toString());
        if (descriptionAr === null || descriptionAr === undefined)
            throw new Error("The parameter 'descriptionAr' cannot be null.");
        else
            content_.append("DescriptionAr", descriptionAr.toString());
        if (order === null || order === undefined)
            throw new Error("The parameter 'order' cannot be null.");
        else
            content_.append("Order", order.toString());

        if (startDate != null || startDate != undefined)
            content_.append("StartDate", startDate.toJSON());
        

        if (endDate != null || endDate != undefined)
            content_.append("EndDate", endDate.toJSON());

        // if (startDate === null || startDate === undefined)
        //     throw new Error("The parameter 'startDate' cannot be null.");
        // else
        //     content_.append("StartDate", startDate.toJSON());
        // if (endDate === null || endDate === undefined)
        //     throw new Error("The parameter 'endDate' cannot be null.");
        // else
        //     content_.append("EndDate", endDate.toJSON());
        if (isActive === null || isActive === undefined)
            throw new Error("The parameter 'isActive' cannot be null.");
        else
            content_.append("IsActive", isActive.toString());
        if (image === null || image === undefined)
            throw new Error("The parameter 'image' cannot be null.");
        else
            content_.append("Image", image.data, image.fileName ? image.fileName : "Image");
        if (linkUrl === null || linkUrl === undefined)
            throw new Error("The parameter 'linkUrl' cannot be null.");
        else
            content_.append("LinkUrl", linkUrl.toString());
        if (buttonLinkText === null || buttonLinkText === undefined)
            throw new Error("The parameter 'buttonLinkText' cannot be null.");
        else
            content_.append("ButtonLinkText", buttonLinkText.toString());
        if (buttonLinkTextAr === null || buttonLinkTextAr === undefined)
            throw new Error("The parameter 'buttonLinkTextAr' cannot be null.");
        else
            content_.append("ButtonLinkTextAr", buttonLinkTextAr.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Advertisement/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getListForGuestUser(skipCount: number | undefined, maxResultCount: number | undefined): Observable<AdvertisementGuestUserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Advertisement/GetListForGuestUser?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListForGuestUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListForGuestUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdvertisementGuestUserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdvertisementGuestUserDtoPagedResultDto>;
        }));
    }

    protected processGetListForGuestUser(response: HttpResponseBase): Observable<AdvertisementGuestUserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdvertisementGuestUserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param title (optional) 
     * @param titleAr (optional) 
     * @param description (optional) 
     * @param descriptionAr (optional) 
     * @param order (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isActive (optional) 
     * @param image (optional) 
     * @param linkUrl (optional) 
     * @param buttonLinkText (optional) 
     * @param buttonLinkTextAr (optional) 
     * @param id (optional) 
     * @return OK
     */
    update(title: string | undefined, titleAr: string | undefined, description: string | undefined, descriptionAr: string | undefined, order: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, isActive: boolean | undefined, image: FileParameter | undefined, linkUrl: string | undefined, buttonLinkText: string | undefined, buttonLinkTextAr: string | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Advertisement/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (title === null || title === undefined)
            throw new Error("The parameter 'title' cannot be null.");
        else
            content_.append("Title", title.toString());
        if (titleAr === null || titleAr === undefined)
            throw new Error("The parameter 'titleAr' cannot be null.");
        else
            content_.append("TitleAr", titleAr.toString());
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("Description", description.toString());
        if (descriptionAr === null || descriptionAr === undefined)
            throw new Error("The parameter 'descriptionAr' cannot be null.");
        else
            content_.append("DescriptionAr", descriptionAr.toString());
        if (order === null || order === undefined)
            throw new Error("The parameter 'order' cannot be null.");
        else
            content_.append("Order", order.toString());

        if (startDate != null || startDate != undefined)
            content_.append("StartDate", startDate.toJSON());

        if (endDate != null || endDate != undefined)
            content_.append("EndDate", endDate.toJSON());


        // if (startDate === null || startDate === undefined)
        //     throw new Error("The parameter 'startDate' cannot be null.");
        // else
        //     content_.append("StartDate", startDate.toJSON());
        // if (endDate === null || endDate === undefined)
        //     throw new Error("The parameter 'endDate' cannot be null.");
        // else
        //     content_.append("EndDate", endDate.toJSON());
        if (isActive === null || isActive === undefined)
            throw new Error("The parameter 'isActive' cannot be null.");
        else
            content_.append("IsActive", isActive.toString());
        if (image === null || image === undefined)
            throw new Error("The parameter 'image' cannot be null.");
        else
            content_.append("Image", image.data, image.fileName ? image.fileName : "Image");
        if (linkUrl === null || linkUrl === undefined)
            throw new Error("The parameter 'linkUrl' cannot be null.");
        else
            content_.append("LinkUrl", linkUrl.toString());
        if (buttonLinkText === null || buttonLinkText === undefined)
            throw new Error("The parameter 'buttonLinkText' cannot be null.");
        else
            content_.append("ButtonLinkText", buttonLinkText.toString());
        if (buttonLinkTextAr === null || buttonLinkTextAr === undefined)
            throw new Error("The parameter 'buttonLinkTextAr' cannot be null.");
        else
            content_.append("ButtonLinkTextAr", buttonLinkTextAr.toString());
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    get(id: number): Observable<AdvertisementByIdDto> {
        let url_ = this.baseUrl + "/api/services/app/Advertisement/Get?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdvertisementByIdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdvertisementByIdDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AdvertisementByIdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdvertisementByIdDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllByAdmin(skipCount: number | undefined, maxResultCount: number | undefined): Observable<AdvertisementDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Advertisement/GetAllByAdmin?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdvertisementDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdvertisementDtoPagedResultDto>;
        }));
    }

    protected processGetAllByAdmin(response: HttpResponseBase): Observable<AdvertisementDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdvertisementDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AffiliateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    create(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Affiliate/Create";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AffiliateApplicantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AffiliateApplicant/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param isVerified (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(userId: number | undefined, isVerified: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AffiliateApplicantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AffiliateApplicant/GetAll?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (isVerified === null)
            throw new Error("The parameter 'isVerified' cannot be null.");
        else if (isVerified !== undefined)
            url_ += "IsVerified=" + encodeURIComponent("" + isVerified) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AffiliateApplicantDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AffiliateApplicantDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AffiliateApplicantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AffiliateApplicantDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateCityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/City/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/City/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param countryId (optional) 
     * @param filter (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllByAdmin(countryId: number | undefined, filter: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CityForAdminDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/City/GetAllByAdmin?";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "CountryId=" + encodeURIComponent("" + countryId) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CityForAdminDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CityForAdminDtoPagedResultDto>;
        }));
    }

    protected processGetAllByAdmin(response: HttpResponseBase): Observable<CityForAdminDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityForAdminDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    get(id: number): Observable<CityByIdDto> {
        let url_ = this.baseUrl + "/api/services/app/City/Get?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CityByIdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CityByIdDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CityByIdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityByIdDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getList(countryId: number, filter: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CityDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/City/GetList?";
        if (countryId === undefined || countryId === null)
            throw new Error("The parameter 'countryId' must be defined and cannot be null.");
        else
            url_ += "CountryId=" + encodeURIComponent("" + countryId) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CityDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CityDtoPagedResultDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<CityDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: UpdateCityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/City/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CompanyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getCompanyAccountInfo(): Observable<CompanyUserAccountDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCompanyAccountInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyAccountInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyAccountInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyUserAccountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyUserAccountDto>;
        }));
    }

    protected processGetCompanyAccountInfo(response: HttpResponseBase): Observable<CompanyUserAccountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyUserAccountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getMainInfoForUpdate(): Observable<GetMainInfoCompanyForUpdateDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetMainInfoForUpdate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMainInfoForUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMainInfoForUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMainInfoCompanyForUpdateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMainInfoCompanyForUpdateDto>;
        }));
    }

    protected processGetMainInfoForUpdate(response: HttpResponseBase): Observable<GetMainInfoCompanyForUpdateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMainInfoCompanyForUpdateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getSecondInfoForUpdate(): Observable<GetSecondInfoCompanyForUpdateDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetSecondInfoForUpdate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSecondInfoForUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSecondInfoForUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSecondInfoCompanyForUpdateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSecondInfoCompanyForUpdateDto>;
        }));
    }

    protected processGetSecondInfoForUpdate(response: HttpResponseBase): Observable<GetSecondInfoCompanyForUpdateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSecondInfoCompanyForUpdateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sendChangeAccountEmailCode(email: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Company/SendChangeAccountEmailCode?";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendChangeAccountEmailCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendChangeAccountEmailCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendChangeAccountEmailCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateMainAccountInfo(body: UpdateCompanyUserAccountDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Company/UpdateMainAccountInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMainAccountInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMainAccountInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMainAccountInfo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param imageFile (optional) 
     * @param deleteProfilePicture (optional) 
     * @param name (optional) 
     * @param country (optional) 
     * @param city (optional) 
     * @param address (optional) 
     * @param phone (optional) 
     * @param email (optional) 
     * @param webSite (optional) 
     * @return OK
     */
    updateMainByCompany(imageFile: FileParameter | undefined, deleteProfilePicture: boolean | undefined, name: string | undefined, country: string | undefined, city: string | undefined, address: string | undefined, phone: string | undefined, email: string | undefined, webSite: string | undefined): Observable<CompletedCompanyProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/UpdateMainByCompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (imageFile === null || imageFile === undefined)
            throw new Error("The parameter 'imageFile' cannot be null.");
        else
            content_.append("ImageFile", imageFile.data, imageFile.fileName ? imageFile.fileName : "ImageFile");
        if (deleteProfilePicture === null || deleteProfilePicture === undefined)
            throw new Error("The parameter 'deleteProfilePicture' cannot be null.");
        else
            content_.append("DeleteProfilePicture", deleteProfilePicture.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (country === null || country === undefined)
            throw new Error("The parameter 'country' cannot be null.");
        else
            content_.append("Country", country.toString());
        if (city === null || city === undefined)
            throw new Error("The parameter 'city' cannot be null.");
        else
            content_.append("City", city.toString());
        if (address === null || address === undefined)
            throw new Error("The parameter 'address' cannot be null.");
        else
            content_.append("Address", address.toString());
        if (phone === null || phone === undefined)
            throw new Error("The parameter 'phone' cannot be null.");
        else
            content_.append("Phone", phone.toString());
        if (email === null || email === undefined)
            throw new Error("The parameter 'email' cannot be null.");
        else
            content_.append("Email", email.toString());
        if (webSite === null || webSite === undefined)
            throw new Error("The parameter 'webSite' cannot be null.");
        else
            content_.append("WebSite", webSite.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMainByCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMainByCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompletedCompanyProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompletedCompanyProfileDto>;
        }));
    }

    protected processUpdateMainByCompany(response: HttpResponseBase): Observable<CompletedCompanyProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompletedCompanyProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateSecondByCompany(body: UpdateSecondInfoCompanyDto | undefined): Observable<CompletedCompanyProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/UpdateSecondByCompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSecondByCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSecondByCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompletedCompanyProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompletedCompanyProfileDto>;
        }));
    }

    protected processUpdateSecondByCompany(response: HttpResponseBase): Observable<CompletedCompanyProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompletedCompanyProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updatePassword(body: UpdateCompanyPasswordDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Company/UpdatePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCompanyDetails(): Observable<CompanyDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCompanyDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDetailsDto>;
        }));
    }

    protected processGetCompanyDetails(response: HttpResponseBase): Observable<CompanyDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    deleteAccount(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Company/DeleteAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAccount(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCompanyStatus(): Observable<CompanyStatus> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCompanyStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyStatus>;
        }));
    }

    protected processGetCompanyStatus(response: HttpResponseBase): Observable<CompanyStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param oldFirebaseToken (optional) 
     * @return OK
     */
    logout(oldFirebaseToken: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Company/Logout?";
        if (oldFirebaseToken === null)
            throw new Error("The parameter 'oldFirebaseToken' cannot be null.");
        else if (oldFirebaseToken !== undefined)
            url_ += "oldFirebaseToken=" + encodeURIComponent("" + oldFirebaseToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param image (optional) 
     * @return OK
     */
    uploadImageProfile(image: FileParameter | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Company/UploadImageProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (image === null || image === undefined)
            throw new Error("The parameter 'image' cannot be null.");
        else
            content_.append("image", image.data, image.fileName ? image.fileName : "image");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadImageProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadImageProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadImageProfile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CompanyAdminServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param isConfirmedAccounts (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllCompaniesSubscribes(filter: string | undefined, isConfirmedAccounts: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CompanyByAdminDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyAdmin/GetAllCompaniesSubscribes?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (isConfirmedAccounts === null)
            throw new Error("The parameter 'isConfirmedAccounts' cannot be null.");
        else if (isConfirmedAccounts !== undefined)
            url_ += "IsConfirmedAccounts=" + encodeURIComponent("" + isConfirmedAccounts) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCompaniesSubscribes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCompaniesSubscribes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyByAdminDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyByAdminDtoPagedResultDto>;
        }));
    }

    protected processGetAllCompaniesSubscribes(response: HttpResponseBase): Observable<CompanyByAdminDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyByAdminDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    approveCompany(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyAdmin/ApproveCompany?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApproveCompany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    rejectCompany(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyAdmin/RejectCompany?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRejectCompany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    unRejectCompany(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyAdmin/UnRejectCompany?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnRejectCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnRejectCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnRejectCompany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    deleteCompany(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyAdmin/DeleteCompany?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCompany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    unDeleteCompany(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyAdmin/UnDeleteCompany?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnDeleteCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnDeleteCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnDeleteCompany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCompanyDetails(id: number): Observable<CompanyDetailsByAdminDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyAdmin/GetCompanyDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDetailsByAdminDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDetailsByAdminDto>;
        }));
    }

    protected processGetCompanyDetails(response: HttpResponseBase): Observable<CompanyDetailsByAdminDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDetailsByAdminDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    setCompanyToShowOrUnUnShowInHomePage(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyAdmin/SetCompanyToShowOrUnUnShowInHomePage?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetCompanyToShowOrUnUnShowInHomePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCompanyToShowOrUnUnShowInHomePage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetCompanyToShowOrUnUnShowInHomePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    exportAsExcel(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyAdmin/ExportAsExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAsExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAsExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportAsExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            //return _observableOf(null as any);
            return _observableOf(responseBlob);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    setOrUnSetCompanyToVerified(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyAdmin/SetOrUnSetCompanyToVerified?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetOrUnSetCompanyToVerified(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetOrUnSetCompanyToVerified(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetOrUnSetCompanyToVerified(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CompanyEmployeeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param companyPackageId (optional) 
     * @return OK
     */
    purchaseCv(companyPackageId: number | undefined, jobId: number, employeeId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CompanyEmployee/PurchaseCv?";
        if (companyPackageId === null)
            throw new Error("The parameter 'companyPackageId' cannot be null.");
        else if (companyPackageId !== undefined)
            url_ += "companyPackageId=" + encodeURIComponent("" + companyPackageId) + "&";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined and cannot be null.");
        else
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined and cannot be null.");
        else
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPurchaseCv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPurchaseCv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processPurchaseCv(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CompanyGuestUserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param country (optional) 
     * @param city (optional) 
     * @param industries (optional) 
     * @param pageSortingType (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllCompanies(filter: string | undefined, country: string | undefined, city: string | undefined, industries: number[] | undefined, pageSortingType: PageSortingType | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CompanyGuestUserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyGuestUser/GetAllCompanies?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (country === null)
            throw new Error("The parameter 'country' cannot be null.");
        else if (country !== undefined)
            url_ += "Country=" + encodeURIComponent("" + country) + "&";
        if (city === null)
            throw new Error("The parameter 'city' cannot be null.");
        else if (city !== undefined)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (industries === null)
            throw new Error("The parameter 'industries' cannot be null.");
        else if (industries !== undefined)
            industries && industries.forEach(item => { url_ += "Industries=" + encodeURIComponent("" + item) + "&"; });
        if (pageSortingType === null)
            throw new Error("The parameter 'pageSortingType' cannot be null.");
        else if (pageSortingType !== undefined)
            url_ += "PageSortingType=" + encodeURIComponent("" + pageSortingType) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyGuestUserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyGuestUserDtoPagedResultDto>;
        }));
    }

    protected processGetAllCompanies(response: HttpResponseBase): Observable<CompanyGuestUserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyGuestUserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllCompaniesInHomePage(): Observable<CompanyGuestUserInHomePageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CompanyGuestUser/GetAllCompaniesInHomePage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCompaniesInHomePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCompaniesInHomePage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyGuestUserInHomePageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyGuestUserInHomePageDto[]>;
        }));
    }

    protected processGetAllCompaniesInHomePage(response: HttpResponseBase): Observable<CompanyGuestUserInHomePageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CompanyGuestUserInHomePageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCompanyDetails(companyId: number): Observable<CompanyDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyGuestUser/GetCompanyDetails?";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined and cannot be null.");
        else
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDetailsDto>;
        }));
    }

    protected processGetCompanyDetails(response: HttpResponseBase): Observable<CompanyDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CompanyIndustryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createList(body: CreateListCompanyIndustryDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyIndustry/CreateList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyIndustry/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getList(skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultCompanyIndustryDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyIndustry/GetList?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultCompanyIndustryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultCompanyIndustryDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<PagedResultCompanyIndustryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultCompanyIndustryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getListForCompanyProfile(): Observable<CompanyIndustryForGuestUserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CompanyIndustry/GetListForCompanyProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListForCompanyProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListForCompanyProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyIndustryForGuestUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyIndustryForGuestUserDto[]>;
        }));
    }

    protected processGetListForCompanyProfile(response: HttpResponseBase): Observable<CompanyIndustryForGuestUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CompanyIndustryForGuestUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getListForGuestUser(companyId: number, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CompanyIndustryForGuestUserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyIndustry/GetListForGuestUser?";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined and cannot be null.");
        else
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListForGuestUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListForGuestUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyIndustryForGuestUserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyIndustryForGuestUserDtoPagedResultDto>;
        }));
    }

    protected processGetListForGuestUser(response: HttpResponseBase): Observable<CompanyIndustryForGuestUserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyIndustryForGuestUserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CompanyPackageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getListActivatedPackages(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CompanyPackageDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyPackage/GetListActivatedPackages?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListActivatedPackages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListActivatedPackages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyPackageDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyPackageDtoPagedResultDto>;
        }));
    }

    protected processGetListActivatedPackages(response: HttpResponseBase): Observable<CompanyPackageDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyPackageDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getListActivatedPackagesForSelect(isForPublishJob: boolean, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CompanyPackageForSelectDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyPackage/GetListActivatedPackagesForSelect?";
        if (isForPublishJob === undefined || isForPublishJob === null)
            throw new Error("The parameter 'isForPublishJob' must be defined and cannot be null.");
        else
            url_ += "IsForPublishJob=" + encodeURIComponent("" + isForPublishJob) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListActivatedPackagesForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListActivatedPackagesForSelect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyPackageForSelectDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyPackageForSelectDtoPagedResultDto>;
        }));
    }

    protected processGetListActivatedPackagesForSelect(response: HttpResponseBase): Observable<CompanyPackageForSelectDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyPackageForSelectDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getListActivatedPackagesIds(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/CompanyPackage/GetListActivatedPackagesIds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListActivatedPackagesIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListActivatedPackagesIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetListActivatedPackagesIds(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    renewalPackage(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyPackage/RenewalPackage?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenewalPackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenewalPackage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRenewalPackage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    requestPackage(packageId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyPackage/RequestPackage?";
        if (packageId === undefined || packageId === null)
            throw new Error("The parameter 'packageId' must be defined and cannot be null.");
        else
            url_ += "packageId=" + encodeURIComponent("" + packageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestPackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestPackage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestPackage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    resendAfterRejectPackage(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyPackage/ResendAfterRejectPackage?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendAfterRejectPackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendAfterRejectPackage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResendAfterRejectPackage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CompanyPackageAdminServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllCompanyPackagesSubscribes(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CompanyPackageByAdminDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyPackageAdmin/GetAllCompanyPackagesSubscribes?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCompanyPackagesSubscribes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCompanyPackagesSubscribes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyPackageByAdminDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyPackageByAdminDtoPagedResultDto>;
        }));
    }

    protected processGetAllCompanyPackagesSubscribes(response: HttpResponseBase): Observable<CompanyPackageByAdminDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyPackageByAdminDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    approvePackage(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyPackageAdmin/ApprovePackage?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprovePackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprovePackage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApprovePackage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    rejectPackage(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyPackageAdmin/RejectPackage?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectPackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectPackage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRejectPackage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    unRejectPackage(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyPackageAdmin/UnRejectPackage?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnRejectPackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnRejectPackage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnRejectPackage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CompanySocialMediaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createList(body: CreateListCompanySocialMediaDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanySocialMedia/CreateList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanySocialMedia/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getList(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CompanySocialMediaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanySocialMedia/GetList?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanySocialMediaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanySocialMediaDtoPagedResultDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<CompanySocialMediaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanySocialMediaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changeUiTheme(body: ChangeUiThemeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUiTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUiTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ContactInfoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    get(): Observable<ContactInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ContactInfo/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactInfoDto[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ContactInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ContactInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param contactsInfo (optional) 
     * @return OK
     */
    update(contactsInfo: UpdateContactInfoDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ContactInfo/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contactsInfo === null || contactsInfo === undefined)
            throw new Error("The parameter 'contactsInfo' cannot be null.");
        else
            //contactsInfo.forEach(item_ => content_.append("ContactsInfo", item_.toString()));
        {
            contactsInfo.forEach((item_, index) => {
                Object.entries(item_).forEach(([key, value]: any, i) => {
                    if (value !== null && value !== undefined) {
                        content_.append(`ContactsInfo[${index}].${key}`, value);
                    }

                });
            });
        }


        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getForUpdate(): Observable<GetContactInfoForUpdateDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ContactInfo/GetForUpdate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetContactInfoForUpdateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetContactInfoForUpdateDto[]>;
        }));
    }

    protected processGetForUpdate(response: HttpResponseBase): Observable<GetContactInfoForUpdateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetContactInfoForUpdateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CountryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateCountryDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Country/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Country/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllCountriesInHomePage(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CountryGuestUserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Country/GetAllCountriesInHomePage?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCountriesInHomePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCountriesInHomePage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryGuestUserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryGuestUserDtoPagedResultDto>;
        }));
    }

    protected processGetAllCountriesInHomePage(response: HttpResponseBase): Observable<CountryGuestUserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryGuestUserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllByAdmin(filter: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CountryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Country/GetAllByAdmin?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryDtoPagedResultDto>;
        }));
    }

    protected processGetAllByAdmin(response: HttpResponseBase): Observable<CountryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    get(id: number): Observable<CountryByIdDto> {
        let url_ = this.baseUrl + "/api/services/app/Country/Get?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryByIdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryByIdDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CountryByIdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryByIdDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getList(filter: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CountryForSelectDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Country/GetList?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryForSelectDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryForSelectDtoPagedResultDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<CountryForSelectDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryForSelectDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: UpdateCountryDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Country/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EmployeeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getEmployeeAccountInfo(): Observable<EmployeeUserAccountDto> {
        let url_ = this.baseUrl + "/api/services/app/Employee/GetEmployeeAccountInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeAccountInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeAccountInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeUserAccountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeUserAccountDto>;
        }));
    }

    protected processGetEmployeeAccountInfo(response: HttpResponseBase): Observable<EmployeeUserAccountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeUserAccountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getEmployeeDetails(): Observable<EmployeeDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/Employee/GetEmployeeDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeDetailsDto>;
        }));
    }

    protected processGetEmployeeDetails(response: HttpResponseBase): Observable<EmployeeDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getMainInfoForUpdate(): Observable<GetMainInfoEmployeeForUpdateDto> {
        let url_ = this.baseUrl + "/api/services/app/Employee/GetMainInfoForUpdate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMainInfoForUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMainInfoForUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMainInfoEmployeeForUpdateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMainInfoEmployeeForUpdateDto>;
        }));
    }

    protected processGetMainInfoForUpdate(response: HttpResponseBase): Observable<GetMainInfoEmployeeForUpdateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMainInfoEmployeeForUpdateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getSecondInfoForUpdate(): Observable<GetSecondInfoEmployeeForUpdateDto> {
        let url_ = this.baseUrl + "/api/services/app/Employee/GetSecondInfoForUpdate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSecondInfoForUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSecondInfoForUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSecondInfoEmployeeForUpdateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSecondInfoEmployeeForUpdateDto>;
        }));
    }

    protected processGetSecondInfoForUpdate(response: HttpResponseBase): Observable<GetSecondInfoEmployeeForUpdateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSecondInfoEmployeeForUpdateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param imageFile (optional) 
     * @param deleteProfilePicture (optional) 
     * @param firstName (optional) 
     * @param lastName (optional) 
     * @param birthDate (optional) 
     * @param nationality (optional) 
     * @param country (optional) 
     * @param city (optional) 
     * @return OK
     */
    updateMainByEmployee(imageFile: FileParameter | undefined, deleteProfilePicture: boolean | undefined, firstName: string | undefined, lastName: string | undefined, birthDate: moment.Moment | undefined, nationality: string | undefined, country: string | undefined, city: string | undefined): Observable<CompletedEmployeeProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/Employee/UpdateMainByEmployee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (imageFile === null || imageFile === undefined)
            throw new Error("The parameter 'imageFile' cannot be null.");
        else
            content_.append("ImageFile", imageFile.data, imageFile.fileName ? imageFile.fileName : "ImageFile");
        if (deleteProfilePicture === null || deleteProfilePicture === undefined)
            throw new Error("The parameter 'deleteProfilePicture' cannot be null.");
        else
            content_.append("DeleteProfilePicture", deleteProfilePicture.toString());
        if (firstName === null || firstName === undefined)
            throw new Error("The parameter 'firstName' cannot be null.");
        else
            content_.append("FirstName", firstName.toString());
        if (lastName === null || lastName === undefined)
            throw new Error("The parameter 'lastName' cannot be null.");
        else
            content_.append("LastName", lastName.toString());
        if (birthDate === null || birthDate === undefined)
            throw new Error("The parameter 'birthDate' cannot be null.");
        else
            content_.append("BirthDate", birthDate.toJSON());
        if (nationality === null || nationality === undefined)
            throw new Error("The parameter 'nationality' cannot be null.");
        else
            content_.append("Nationality", nationality.toString());
        if (country === null || country === undefined)
            throw new Error("The parameter 'country' cannot be null.");
        else
            content_.append("Country", country.toString());
        if (city === null || city === undefined)
            throw new Error("The parameter 'city' cannot be null.");
        else
            content_.append("City", city.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMainByEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMainByEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompletedEmployeeProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompletedEmployeeProfileDto>;
        }));
    }

    protected processUpdateMainByEmployee(response: HttpResponseBase): Observable<CompletedEmployeeProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompletedEmployeeProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateSecondByEmployee(body: UpdateSecondInfoEmployeeDto | undefined): Observable<CompletedEmployeeProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/Employee/UpdateSecondByEmployee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSecondByEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSecondByEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompletedEmployeeProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompletedEmployeeProfileDto>;
        }));
    }

    protected processUpdateSecondByEmployee(response: HttpResponseBase): Observable<CompletedEmployeeProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompletedEmployeeProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateMainAccountInfo(body: UpdateEmployeeUserAccountDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employee/UpdateMainAccountInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMainAccountInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMainAccountInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMainAccountInfo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sendChangeAccountEmailCode(email: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employee/SendChangeAccountEmailCode?";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendChangeAccountEmailCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendChangeAccountEmailCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendChangeAccountEmailCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updatePassword(body: UpdateEmployeePasswordDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employee/UpdatePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getEmployeeDetailsForCompany(id: number): Observable<EmployeeDetailsForCompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Employee/GetEmployeeDetailsForCompany?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeDetailsForCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeDetailsForCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeDetailsForCompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeDetailsForCompanyDto>;
        }));
    }

    protected processGetEmployeeDetailsForCompany(response: HttpResponseBase): Observable<EmployeeDetailsForCompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDetailsForCompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    deleteAccount(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employee/DeleteAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAccount(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param oldFirebaseToken (optional) 
     * @return OK
     */
    logout(oldFirebaseToken: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employee/Logout?";
        if (oldFirebaseToken === null)
            throw new Error("The parameter 'oldFirebaseToken' cannot be null.");
        else if (oldFirebaseToken !== undefined)
            url_ += "oldFirebaseToken=" + encodeURIComponent("" + oldFirebaseToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    downloadCv(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employee/DownloadCv";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadCv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadCv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadCv(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    downloadCvForCompany(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employee/DownloadCvForCompany?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadCvForCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadCvForCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadCvForCompany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cvFile (optional) 
     * @return OK
     */
    autoCompleteProfileFromCv(cvFile: FileParameter | undefined): Observable<EmployeeCompletedCVDto> {
        let url_ = this.baseUrl + "/api/services/app/Employee/AutoCompleteProfileFromCv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (cvFile === null || cvFile === undefined)
            throw new Error("The parameter 'cvFile' cannot be null.");
        else
            content_.append("cvFile", cvFile.data, cvFile.fileName ? cvFile.fileName : "cvFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAutoCompleteProfileFromCv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAutoCompleteProfileFromCv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeCompletedCVDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeCompletedCVDto>;
        }));
    }

    protected processAutoCompleteProfileFromCv(response: HttpResponseBase): Observable<EmployeeCompletedCVDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeCompletedCVDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param image (optional) 
     * @return OK
     */
    uploadImageProfile(image: FileParameter | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Employee/UploadImageProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (image === null || image === undefined)
            throw new Error("The parameter 'image' cannot be null.");
        else
            content_.append("image", image.data, image.fileName ? image.fileName : "image");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadImageProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadImageProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadImageProfile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EmployeeAdminServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param isConfirmedAccounts (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | undefined, isConfirmedAccounts: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<EmployeeByAdminDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeAdmin/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (isConfirmedAccounts === null)
            throw new Error("The parameter 'isConfirmedAccounts' cannot be null.");
        else if (isConfirmedAccounts !== undefined)
            url_ += "IsConfirmedAccounts=" + encodeURIComponent("" + isConfirmedAccounts) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeByAdminDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeByAdminDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<EmployeeByAdminDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeByAdminDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getEmployeeDetails(id: number): Observable<EmployeeDetailsByAdminDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeAdmin/GetEmployeeDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeDetailsByAdminDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeDetailsByAdminDto>;
        }));
    }

    protected processGetEmployeeDetails(response: HttpResponseBase): Observable<EmployeeDetailsByAdminDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDetailsByAdminDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EmployeeAppliedJobServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    applyOrUnApplyJobByEmployee(jobId: number, companyId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeAppliedJob/ApplyOrUnApplyJobByEmployee?";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined and cannot be null.");
        else
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined and cannot be null.");
        else
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplyOrUnApplyJobByEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplyOrUnApplyJobByEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApplyOrUnApplyJobByEmployee(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllAppliedJobIdsForEmployee(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeAppliedJob/GetAllAppliedJobIdsForEmployee";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAppliedJobIdsForEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAppliedJobIdsForEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetAllAppliedJobIdsForEmployee(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllAppliedJobsForEmployee(skipCount: number | undefined, maxResultCount: number | undefined): Observable<JobAppliedByEmployeeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeAppliedJob/GetAllAppliedJobsForEmployee?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAppliedJobsForEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAppliedJobsForEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobAppliedByEmployeeDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobAppliedByEmployeeDtoPagedResultDto>;
        }));
    }

    protected processGetAllAppliedJobsForEmployee(response: HttpResponseBase): Observable<JobAppliedByEmployeeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobAppliedByEmployeeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pageSortingType (optional) 
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllAppliedToJobEmployees(jobId: number, pageSortingType: PageSortingType | undefined, keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<EmployeeAppliedJobDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeAppliedJob/GetAllAppliedToJobEmployees?";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined and cannot be null.");
        else
            url_ += "JobId=" + encodeURIComponent("" + jobId) + "&";
        if (pageSortingType === null)
            throw new Error("The parameter 'pageSortingType' cannot be null.");
        else if (pageSortingType !== undefined)
            url_ += "PageSortingType=" + encodeURIComponent("" + pageSortingType) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAppliedToJobEmployees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAppliedToJobEmployees(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeAppliedJobDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeAppliedJobDtoPagedResultDto>;
        }));
    }

    protected processGetAllAppliedToJobEmployees(response: HttpResponseBase): Observable<EmployeeAppliedJobDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeAppliedJobDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EmployeeAttachmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param attachFile (optional) 
     * @return OK
     */
    create(attachFile: FileParameter | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeAttachment/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (attachFile === null || attachFile === undefined)
            throw new Error("The parameter 'attachFile' cannot be null.");
        else
            content_.append("AttachFile", attachFile.data, attachFile.fileName ? attachFile.fileName : "AttachFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getList(skipCount: number | undefined, maxResultCount: number | undefined): Observable<EmployeeAttachmentDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeAttachment/GetList?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeAttachmentDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeAttachmentDtoPagedResultDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<EmployeeAttachmentDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeAttachmentDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeAttachment/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    downloadAttachement(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeAttachment/DownloadAttachement?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAttachement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAttachement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadAttachement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EmployeeCertificateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateEmployeeCertificateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeCertificate/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createList(body: CreateListEmployeeCertificateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeCertificate/CreateList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeCertificate/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getList(skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultEmployeeCertificateDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeCertificate/GetList?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultEmployeeCertificateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultEmployeeCertificateDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<PagedResultEmployeeCertificateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultEmployeeCertificateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getListForCompany(employeeId: number): Observable<EmployeeCertificateDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeCertificate/GetListForCompany?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined and cannot be null.");
        else
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListForCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListForCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeCertificateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeCertificateDto[]>;
        }));
    }

    protected processGetListForCompany(response: HttpResponseBase): Observable<EmployeeCertificateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EmployeeCertificateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getListForEmployeeProfile(): Observable<EmployeeCertificateDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeCertificate/GetListForEmployeeProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListForEmployeeProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListForEmployeeProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeCertificateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeCertificateDto[]>;
        }));
    }

    protected processGetListForEmployeeProfile(response: HttpResponseBase): Observable<EmployeeCertificateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EmployeeCertificateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: UpdateEmployeeCertificateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeCertificate/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EmployeeExperienceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateEmployeeExperienceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeExperience/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createList(body: CreateListEmployeeExperienceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeExperience/CreateList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeExperience/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getList(skipCount: number | undefined, maxResultCount: number | undefined): Observable<EmployeeExperienceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeExperience/GetList?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeExperienceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeExperienceDtoPagedResultDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<EmployeeExperienceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeExperienceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getListForCompany(employeeId: number): Observable<EmployeeExperienceForEmployeeProfileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeExperience/GetListForCompany?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined and cannot be null.");
        else
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListForCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListForCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeExperienceForEmployeeProfileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeExperienceForEmployeeProfileDto[]>;
        }));
    }

    protected processGetListForCompany(response: HttpResponseBase): Observable<EmployeeExperienceForEmployeeProfileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EmployeeExperienceForEmployeeProfileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getListForEmployeeProfile(): Observable<EmployeeExperienceForEmployeeProfileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeExperience/GetListForEmployeeProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListForEmployeeProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListForEmployeeProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeExperienceForEmployeeProfileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeExperienceForEmployeeProfileDto[]>;
        }));
    }

    protected processGetListForEmployeeProfile(response: HttpResponseBase): Observable<EmployeeExperienceForEmployeeProfileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EmployeeExperienceForEmployeeProfileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: UpdateEmployeeExperienceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeExperience/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EmployeeLanguageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createList(body: CreateListEmployeeLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeLanguage/CreateList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeLanguage/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getList(skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultEmployeeLanguageDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeLanguage/GetList?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultEmployeeLanguageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultEmployeeLanguageDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<PagedResultEmployeeLanguageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultEmployeeLanguageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getListForCompany(employeeId: number, skipCount: number | undefined, maxResultCount: number | undefined): Observable<EmployeeLanguageForEmployeeProfileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeLanguage/GetListForCompany?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined and cannot be null.");
        else
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListForCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListForCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeLanguageForEmployeeProfileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeLanguageForEmployeeProfileDto[]>;
        }));
    }

    protected processGetListForCompany(response: HttpResponseBase): Observable<EmployeeLanguageForEmployeeProfileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EmployeeLanguageForEmployeeProfileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getListForEmployeeProfile(): Observable<EmployeeLanguageForEmployeeProfileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeLanguage/GetListForEmployeeProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListForEmployeeProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListForEmployeeProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeLanguageForEmployeeProfileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeLanguageForEmployeeProfileDto[]>;
        }));
    }

    protected processGetListForEmployeeProfile(response: HttpResponseBase): Observable<EmployeeLanguageForEmployeeProfileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EmployeeLanguageForEmployeeProfileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EmployeeSavedJobServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAllSavedJobIds(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSavedJob/GetAllSavedJobIds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSavedJobIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSavedJobIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetAllSavedJobIds(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllSavedJobsForEmployee(skipCount: number | undefined, maxResultCount: number | undefined): Observable<EmployeeSavedJobDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSavedJob/GetAllSavedJobsForEmployee?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSavedJobsForEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSavedJobsForEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeSavedJobDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeSavedJobDtoPagedResultDto>;
        }));
    }

    protected processGetAllSavedJobsForEmployee(response: HttpResponseBase): Observable<EmployeeSavedJobDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeSavedJobDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    saveOrUnSaveJob(jobId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSavedJob/SaveOrUnSaveJob?";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined and cannot be null.");
        else
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveOrUnSaveJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveOrUnSaveJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveOrUnSaveJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EmployeeSkillServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createList(body: CreateListEmployeeSkillDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSkill/CreateList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSkill/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getList(skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultEmployeeSkillDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSkill/GetList?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultEmployeeSkillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultEmployeeSkillDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<PagedResultEmployeeSkillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultEmployeeSkillDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getListForCompany(employeeId: number): Observable<EmployeeSkillForEmployeeProfileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSkill/GetListForCompany?";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined and cannot be null.");
        else
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListForCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListForCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeSkillForEmployeeProfileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeSkillForEmployeeProfileDto[]>;
        }));
    }

    protected processGetListForCompany(response: HttpResponseBase): Observable<EmployeeSkillForEmployeeProfileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EmployeeSkillForEmployeeProfileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getListForEmployeeProfile(): Observable<EmployeeSkillForEmployeeProfileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSkill/GetListForEmployeeProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListForEmployeeProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListForEmployeeProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeSkillForEmployeeProfileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeSkillForEmployeeProfileDto[]>;
        }));
    }

    protected processGetListForEmployeeProfile(response: HttpResponseBase): Observable<EmployeeSkillForEmployeeProfileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EmployeeSkillForEmployeeProfileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EmployeeSocialMediaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createList(body: CreateListEmployeeSocialMediaDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSocialMedia/CreateList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSocialMedia/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getList(skipCount: number | undefined, maxResultCount: number | undefined): Observable<EmployeeSocialMediaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeSocialMedia/GetList?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeSocialMediaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeSocialMediaDtoPagedResultDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<EmployeeSocialMediaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeSocialMediaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HomeSliderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAllByAdmin(): Observable<HomeSliderForAdminDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HomeSlider/GetAllByAdmin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HomeSliderForAdminDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HomeSliderForAdminDto[]>;
        }));
    }

    protected processGetAllByAdmin(response: HttpResponseBase): Observable<HomeSliderForAdminDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(HomeSliderForAdminDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getForUpdate(id: number): Observable<HomeSliderByIdDto> {
        let url_ = this.baseUrl + "/api/services/app/HomeSlider/GetForUpdate?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HomeSliderByIdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HomeSliderByIdDto>;
        }));
    }

    protected processGetForUpdate(response: HttpResponseBase): Observable<HomeSliderByIdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HomeSliderByIdDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getHomeSlide(type: HomeSliderType): Observable<HomeSliderDto> {
        let url_ = this.baseUrl + "/api/services/app/HomeSlider/GetHomeSlide?";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHomeSlide(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHomeSlide(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HomeSliderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HomeSliderDto>;
        }));
    }

    protected processGetHomeSlide(response: HttpResponseBase): Observable<HomeSliderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HomeSliderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param title (optional) 
     * @param titleAr (optional) 
     * @param description (optional) 
     * @param descriptionAr (optional) 
     * @param imageFile (optional) 
     * @param id (optional) 
     * @return OK
     */
    update(title: string | undefined, titleAr: string | undefined, description: string | undefined, descriptionAr: string | undefined, imageFile: FileParameter | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HomeSlider/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (title === null || title === undefined)
            throw new Error("The parameter 'title' cannot be null.");
        else
            content_.append("Title", title.toString());
        if (titleAr === null || titleAr === undefined)
            throw new Error("The parameter 'titleAr' cannot be null.");
        else
            content_.append("TitleAr", titleAr.toString());
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("Description", description.toString());
        if (descriptionAr === null || descriptionAr === undefined)
            throw new Error("The parameter 'descriptionAr' cannot be null.");
        else
            content_.append("DescriptionAr", descriptionAr.toString());
        if (imageFile === null || imageFile === undefined)
            throw new Error("The parameter 'imageFile' cannot be null.");
        else
            content_.append("ImageFile", imageFile.data, imageFile.fileName ? imageFile.fileName : "ImageFile");
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IndustryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param name (optional) 
     * @param nameAr (optional) 
     * @param imageFile (optional) 
     * @param order (optional) 
     * @param showInHomePage (optional) 
     * @return OK
     */
    create(name: string | undefined, nameAr: string | undefined, imageFile: FileParameter | undefined, order: number | undefined, showInHomePage: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Industry/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (nameAr === null || nameAr === undefined)
            throw new Error("The parameter 'nameAr' cannot be null.");
        else
            content_.append("NameAr", nameAr.toString());
        if (imageFile === null || imageFile === undefined)
            throw new Error("The parameter 'imageFile' cannot be null.");
        else
            content_.append("ImageFile", imageFile.data, imageFile.fileName ? imageFile.fileName : "ImageFile");
        if (order === null || order === undefined)
            throw new Error("The parameter 'order' cannot be null.");
        else
            content_.append("Order", order.toString());
        if (showInHomePage === null || showInHomePage === undefined)
            throw new Error("The parameter 'showInHomePage' cannot be null.");
        else
            content_.append("ShowInHomePage", showInHomePage.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Industry/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    get(id: number): Observable<IndustryByIdDto> {
        let url_ = this.baseUrl + "/api/services/app/Industry/Get?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IndustryByIdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IndustryByIdDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<IndustryByIdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IndustryByIdDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getList(filter: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<IndustryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Industry/GetList?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IndustryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IndustryDtoPagedResultDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<IndustryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IndustryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @param nameAr (optional) 
     * @param imageFile (optional) 
     * @param order (optional) 
     * @param showInHomePage (optional) 
     * @param id (optional) 
     * @return OK
     */
    update(name: string | undefined, nameAr: string | undefined, imageFile: FileParameter | undefined, order: number | undefined, showInHomePage: boolean | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Industry/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (nameAr === null || nameAr === undefined)
            throw new Error("The parameter 'nameAr' cannot be null.");
        else
            content_.append("NameAr", nameAr.toString());
        if (imageFile === null || imageFile === undefined)
            throw new Error("The parameter 'imageFile' cannot be null.");
        else
            content_.append("ImageFile", imageFile.data, imageFile.fileName ? imageFile.fileName : "ImageFile");
        if (order === null || order === undefined)
            throw new Error("The parameter 'order' cannot be null.");
        else
            content_.append("Order", order.toString());
        if (showInHomePage === null || showInHomePage === undefined)
            throw new Error("The parameter 'showInHomePage' cannot be null.");
        else
            content_.append("ShowInHomePage", showInHomePage.toString());
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllByAdmin(filter: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<IndustryForAdminDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Industry/GetAllByAdmin?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IndustryForAdminDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IndustryForAdminDtoPagedResultDto>;
        }));
    }

    protected processGetAllByAdmin(response: HttpResponseBase): Observable<IndustryForAdminDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IndustryForAdminDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IndustryGuestUserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param pageSortingType (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllIndustries(filter: string | undefined, pageSortingType: PageSortingType | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<IndustryGuestUserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/IndustryGuestUser/GetAllIndustries?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (pageSortingType === null)
            throw new Error("The parameter 'pageSortingType' cannot be null.");
        else if (pageSortingType !== undefined)
            url_ += "PageSortingType=" + encodeURIComponent("" + pageSortingType) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllIndustries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllIndustries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IndustryGuestUserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IndustryGuestUserDtoPagedResultDto>;
        }));
    }

    protected processGetAllIndustries(response: HttpResponseBase): Observable<IndustryGuestUserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IndustryGuestUserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllIndustriesInHomePage(): Observable<IndustryGuestUserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/IndustryGuestUser/GetAllIndustriesInHomePage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllIndustriesInHomePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllIndustriesInHomePage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IndustryGuestUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IndustryGuestUserDto[]>;
        }));
    }

    protected processGetAllIndustriesInHomePage(response: HttpResponseBase): Observable<IndustryGuestUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(IndustryGuestUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class JobAdminServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    approveJob(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/JobAdmin/ApproveJob?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApproveJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllJobsSubscribes(skipCount: number | undefined, maxResultCount: number | undefined): Observable<JobForAdminDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/JobAdmin/GetAllJobsSubscribes?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllJobsSubscribes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllJobsSubscribes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobForAdminDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobForAdminDtoPagedResultDto>;
        }));
    }

    protected processGetAllJobsSubscribes(response: HttpResponseBase): Observable<JobForAdminDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobForAdminDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getJobDetails(id: number): Observable<JobDetailsForAdminDto> {
        let url_ = this.baseUrl + "/api/services/app/JobAdmin/GetJobDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobDetailsForAdminDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobDetailsForAdminDto>;
        }));
    }

    protected processGetJobDetails(response: HttpResponseBase): Observable<JobDetailsForAdminDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobDetailsForAdminDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    rejectJob(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/JobAdmin/RejectJob?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRejectJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    setJobAsRecommendedOrUnRecommended(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/JobAdmin/SetJobAsRecommendedOrUnRecommended?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetJobAsRecommendedOrUnRecommended(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetJobAsRecommendedOrUnRecommended(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetJobAsRecommendedOrUnRecommended(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    unRejectJob(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/JobAdmin/UnRejectJob?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnRejectJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnRejectJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnRejectJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class JobCompanyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    closeJob(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/JobCompany/CloseJob?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloseJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloseJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCloseJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createJobByCompany(body: CreateJobByCompanyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/JobCompany/CreateJobByCompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateJobByCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateJobByCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateJobByCompany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param status (optional) 
     * @param pageSortingType (optional) 
     * @param filter (optional) 
     * @param countryId (optional) 
     * @param cityId (optional) 
     * @param industryId (optional) 
     * @param jobPositionId (optional) 
     * @param jobType (optional) 
     * @param workPlaceType (optional) 
     * @param positionLevel (optional) 
     * @param lastUpdateJobFilter (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllJobsForCompany(status: JobStatus | undefined, pageSortingType: PageSortingType | undefined, filter: string | undefined, countryId: number | undefined, cityId: number | undefined, industryId: number | undefined, jobPositionId: number | undefined, jobType: JobType | undefined, workPlaceType: WorkPlaceType | undefined, positionLevel: PositionLevel | undefined, lastUpdateJobFilter: LastPublishJob | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<JobForCompanyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/JobCompany/GetAllJobsForCompany?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (pageSortingType === null)
            throw new Error("The parameter 'pageSortingType' cannot be null.");
        else if (pageSortingType !== undefined)
            url_ += "PageSortingType=" + encodeURIComponent("" + pageSortingType) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "CountryId=" + encodeURIComponent("" + countryId) + "&";
        if (cityId === null)
            throw new Error("The parameter 'cityId' cannot be null.");
        else if (cityId !== undefined)
            url_ += "CityId=" + encodeURIComponent("" + cityId) + "&";
        if (industryId === null)
            throw new Error("The parameter 'industryId' cannot be null.");
        else if (industryId !== undefined)
            url_ += "IndustryId=" + encodeURIComponent("" + industryId) + "&";
        if (jobPositionId === null)
            throw new Error("The parameter 'jobPositionId' cannot be null.");
        else if (jobPositionId !== undefined)
            url_ += "JobPositionId=" + encodeURIComponent("" + jobPositionId) + "&";
        if (jobType === null)
            throw new Error("The parameter 'jobType' cannot be null.");
        else if (jobType !== undefined)
            url_ += "JobType=" + encodeURIComponent("" + jobType) + "&";
        if (workPlaceType === null)
            throw new Error("The parameter 'workPlaceType' cannot be null.");
        else if (workPlaceType !== undefined)
            url_ += "WorkPlaceType=" + encodeURIComponent("" + workPlaceType) + "&";
        if (positionLevel === null)
            throw new Error("The parameter 'positionLevel' cannot be null.");
        else if (positionLevel !== undefined)
            url_ += "PositionLevel=" + encodeURIComponent("" + positionLevel) + "&";
        if (lastUpdateJobFilter === null)
            throw new Error("The parameter 'lastUpdateJobFilter' cannot be null.");
        else if (lastUpdateJobFilter !== undefined)
            url_ += "LastUpdateJobFilter=" + encodeURIComponent("" + lastUpdateJobFilter) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllJobsForCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllJobsForCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobForCompanyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobForCompanyDtoPagedResultDto>;
        }));
    }

    protected processGetAllJobsForCompany(response: HttpResponseBase): Observable<JobForCompanyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobForCompanyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getJobDetails(id: number): Observable<JobDetailsForCompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/JobCompany/GetJobDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobDetailsForCompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobDetailsForCompanyDto>;
        }));
    }

    protected processGetJobDetails(response: HttpResponseBase): Observable<JobDetailsForCompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobDetailsForCompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getJobForUpdate(id: number): Observable<GetJobForUpdateByCompany> {
        let url_ = this.baseUrl + "/api/services/app/JobCompany/GetJobForUpdate?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobForUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobForUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetJobForUpdateByCompany>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetJobForUpdateByCompany>;
        }));
    }

    protected processGetJobForUpdate(response: HttpResponseBase): Observable<GetJobForUpdateByCompany> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJobForUpdateByCompany.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param companyPackageId (optional) 
     * @return OK
     */
    publishJob(id: number, companyPackageId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/JobCompany/PublishJob?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (companyPackageId === null)
            throw new Error("The parameter 'companyPackageId' cannot be null.");
        else if (companyPackageId !== undefined)
            url_ += "companyPackageId=" + encodeURIComponent("" + companyPackageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPublishJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    renewalJob(id: number, companyPackageId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/JobCompany/RenewalJob?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (companyPackageId === undefined || companyPackageId === null)
            throw new Error("The parameter 'companyPackageId' must be defined and cannot be null.");
        else
            url_ += "companyPackageId=" + encodeURIComponent("" + companyPackageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenewalJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenewalJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRenewalJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateJobByCompany(body: UpdateJobByCompanyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/JobCompany/UpdateJobByCompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJobByCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJobByCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateJobByCompany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class JobGuestUserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param filterByLocationName (optional) 
     * @param countryId (optional) 
     * @param cityId (optional) 
     * @param industryId (optional) 
     * @param jobPositionId (optional) 
     * @param jobType (optional) 
     * @param workPlaceType (optional) 
     * @param positionLevel (optional) 
     * @param lastUpdateJobFilter (optional) 
     * @param pageSortingType (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllJobs(filter: string | undefined, filterByLocationName: string | undefined, countryId: number | undefined, cityId: number | undefined, industryId: number | undefined, jobPositionId: number | undefined, jobType: JobType | undefined, workPlaceType: WorkPlaceType | undefined, positionLevel: PositionLevel | undefined, lastUpdateJobFilter: LastPublishJob | undefined, pageSortingType: PageSortingType | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<JobGuestUserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/JobGuestUser/GetAllJobs?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (filterByLocationName === null)
            throw new Error("The parameter 'filterByLocationName' cannot be null.");
        else if (filterByLocationName !== undefined)
            url_ += "FilterByLocationName=" + encodeURIComponent("" + filterByLocationName) + "&";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "CountryId=" + encodeURIComponent("" + countryId) + "&";
        if (cityId === null)
            throw new Error("The parameter 'cityId' cannot be null.");
        else if (cityId !== undefined)
            url_ += "CityId=" + encodeURIComponent("" + cityId) + "&";
        if (industryId === null)
            throw new Error("The parameter 'industryId' cannot be null.");
        else if (industryId !== undefined)
            url_ += "IndustryId=" + encodeURIComponent("" + industryId) + "&";
        if (jobPositionId === null)
            throw new Error("The parameter 'jobPositionId' cannot be null.");
        else if (jobPositionId !== undefined)
            url_ += "JobPositionId=" + encodeURIComponent("" + jobPositionId) + "&";
        if (jobType === null)
            throw new Error("The parameter 'jobType' cannot be null.");
        else if (jobType !== undefined)
            url_ += "JobType=" + encodeURIComponent("" + jobType) + "&";
        if (workPlaceType === null)
            throw new Error("The parameter 'workPlaceType' cannot be null.");
        else if (workPlaceType !== undefined)
            url_ += "WorkPlaceType=" + encodeURIComponent("" + workPlaceType) + "&";
        if (positionLevel === null)
            throw new Error("The parameter 'positionLevel' cannot be null.");
        else if (positionLevel !== undefined)
            url_ += "PositionLevel=" + encodeURIComponent("" + positionLevel) + "&";
        if (lastUpdateJobFilter === null)
            throw new Error("The parameter 'lastUpdateJobFilter' cannot be null.");
        else if (lastUpdateJobFilter !== undefined)
            url_ += "LastUpdateJobFilter=" + encodeURIComponent("" + lastUpdateJobFilter) + "&";
        if (pageSortingType === null)
            throw new Error("The parameter 'pageSortingType' cannot be null.");
        else if (pageSortingType !== undefined)
            url_ += "PageSortingType=" + encodeURIComponent("" + pageSortingType) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllJobs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllJobs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobGuestUserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobGuestUserDtoPagedResultDto>;
        }));
    }

    protected processGetAllJobs(response: HttpResponseBase): Observable<JobGuestUserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobGuestUserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllJobsForCompany(companyId: number, skipCount: number | undefined, maxResultCount: number | undefined): Observable<JobGuestUserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/JobGuestUser/GetAllJobsForCompany?";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined and cannot be null.");
        else
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllJobsForCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllJobsForCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobGuestUserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobGuestUserDtoPagedResultDto>;
        }));
    }

    protected processGetAllJobsForCompany(response: HttpResponseBase): Observable<JobGuestUserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobGuestUserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllRecentJobsInHomePage(): Observable<JobGuestUserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/JobGuestUser/GetAllRecentJobsInHomePage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRecentJobsInHomePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRecentJobsInHomePage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobGuestUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobGuestUserDto[]>;
        }));
    }

    protected processGetAllRecentJobsInHomePage(response: HttpResponseBase): Observable<JobGuestUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(JobGuestUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param countryId (optional) 
     * @param cityId (optional) 
     * @param industryId (optional) 
     * @param jobPositionId (optional) 
     * @param jobType (optional) 
     * @param workPlaceType (optional) 
     * @param positionLevel (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllRecommendedJobs(filter: string | undefined, countryId: number | undefined, cityId: number | undefined, industryId: number | undefined, jobPositionId: number | undefined, jobType: JobType | undefined, workPlaceType: WorkPlaceType | undefined, positionLevel: PositionLevel | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RecommendedJobDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/JobGuestUser/GetAllRecommendedJobs?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "CountryId=" + encodeURIComponent("" + countryId) + "&";
        if (cityId === null)
            throw new Error("The parameter 'cityId' cannot be null.");
        else if (cityId !== undefined)
            url_ += "CityId=" + encodeURIComponent("" + cityId) + "&";
        if (industryId === null)
            throw new Error("The parameter 'industryId' cannot be null.");
        else if (industryId !== undefined)
            url_ += "IndustryId=" + encodeURIComponent("" + industryId) + "&";
        if (jobPositionId === null)
            throw new Error("The parameter 'jobPositionId' cannot be null.");
        else if (jobPositionId !== undefined)
            url_ += "JobPositionId=" + encodeURIComponent("" + jobPositionId) + "&";
        if (jobType === null)
            throw new Error("The parameter 'jobType' cannot be null.");
        else if (jobType !== undefined)
            url_ += "JobType=" + encodeURIComponent("" + jobType) + "&";
        if (workPlaceType === null)
            throw new Error("The parameter 'workPlaceType' cannot be null.");
        else if (workPlaceType !== undefined)
            url_ += "WorkPlaceType=" + encodeURIComponent("" + workPlaceType) + "&";
        if (positionLevel === null)
            throw new Error("The parameter 'positionLevel' cannot be null.");
        else if (positionLevel !== undefined)
            url_ += "PositionLevel=" + encodeURIComponent("" + positionLevel) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRecommendedJobs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRecommendedJobs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecommendedJobDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecommendedJobDtoPagedResultDto>;
        }));
    }

    protected processGetAllRecommendedJobs(response: HttpResponseBase): Observable<RecommendedJobDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecommendedJobDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllRecommendedJobsInHomePage(): Observable<RecommendedJobDto[]> {
        let url_ = this.baseUrl + "/api/services/app/JobGuestUser/GetAllRecommendedJobsInHomePage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRecommendedJobsInHomePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRecommendedJobsInHomePage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecommendedJobDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecommendedJobDto[]>;
        }));
    }

    protected processGetAllRecommendedJobsInHomePage(response: HttpResponseBase): Observable<RecommendedJobDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RecommendedJobDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getJobDetails(id: number): Observable<JobDetailsForGuestUserDto> {
        let url_ = this.baseUrl + "/api/services/app/JobGuestUser/GetJobDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobDetailsForGuestUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobDetailsForGuestUserDto>;
        }));
    }

    protected processGetJobDetails(response: HttpResponseBase): Observable<JobDetailsForGuestUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobDetailsForGuestUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class JobLanguageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createList(body: CreateListJobLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/JobLanguage/CreateList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/JobLanguage/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getList(jobId: number, skipCount: number | undefined, maxResultCount: number | undefined): Observable<JobLanguageDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/JobLanguage/GetList?";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined and cannot be null.");
        else
            url_ += "JobId=" + encodeURIComponent("" + jobId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobLanguageDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobLanguageDtoPagedResultDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<JobLanguageDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobLanguageDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getListForGuestUser(jobId: number, skipCount: number | undefined, maxResultCount: number | undefined): Observable<JobLanguageForGuestUserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/JobLanguage/GetListForGuestUser?";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined and cannot be null.");
        else
            url_ += "JobId=" + encodeURIComponent("" + jobId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListForGuestUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListForGuestUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobLanguageForGuestUserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobLanguageForGuestUserDtoPagedResultDto>;
        }));
    }

    protected processGetListForGuestUser(response: HttpResponseBase): Observable<JobLanguageForGuestUserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobLanguageForGuestUserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getListForJobProfileByCompany(jobId: number, skipCount: number | undefined, maxResultCount: number | undefined): Observable<JobLanguageForGuestUserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/JobLanguage/GetListForJobProfileByCompany?";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined and cannot be null.");
        else
            url_ += "JobId=" + encodeURIComponent("" + jobId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListForJobProfileByCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListForJobProfileByCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobLanguageForGuestUserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobLanguageForGuestUserDtoPagedResultDto>;
        }));
    }

    protected processGetListForJobProfileByCompany(response: HttpResponseBase): Observable<JobLanguageForGuestUserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobLanguageForGuestUserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class JobPositionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateJobPositionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/JobPosition/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/JobPosition/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param industryId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllByAdmin(filter: string | undefined, industryId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<JobPositionForAdminDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/JobPosition/GetAllByAdmin?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (industryId === null)
            throw new Error("The parameter 'industryId' cannot be null.");
        else if (industryId !== undefined)
            url_ += "IndustryId=" + encodeURIComponent("" + industryId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobPositionForAdminDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobPositionForAdminDtoPagedResultDto>;
        }));
    }

    protected processGetAllByAdmin(response: HttpResponseBase): Observable<JobPositionForAdminDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobPositionForAdminDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    get(id: number): Observable<JobPositionByIdDto> {
        let url_ = this.baseUrl + "/api/services/app/JobPosition/Get?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobPositionByIdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobPositionByIdDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<JobPositionByIdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobPositionByIdDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param industryId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getList(filter: string | undefined, industryId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<JobPositionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/JobPosition/GetList?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (industryId === null)
            throw new Error("The parameter 'industryId' cannot be null.");
        else if (industryId !== undefined)
            url_ += "IndustryId=" + encodeURIComponent("" + industryId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobPositionDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobPositionDtoPagedResultDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<JobPositionDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobPositionDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: UpdateJobPositionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/JobPosition/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class JobSkillServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createList(body: CreateListJobSkillDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/JobSkill/CreateList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/JobSkill/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getList(jobId: number, skipCount: number | undefined, maxResultCount: number | undefined): Observable<JobSkillDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/JobSkill/GetList?";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined and cannot be null.");
        else
            url_ += "JobId=" + encodeURIComponent("" + jobId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobSkillDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobSkillDtoPagedResultDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<JobSkillDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobSkillDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getListForGuestUser(jobId: number, skipCount: number | undefined, maxResultCount: number | undefined): Observable<JobSkillForGuestUserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/JobSkill/GetListForGuestUser?";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined and cannot be null.");
        else
            url_ += "JobId=" + encodeURIComponent("" + jobId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListForGuestUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListForGuestUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobSkillForGuestUserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobSkillForGuestUserDtoPagedResultDto>;
        }));
    }

    protected processGetListForGuestUser(response: HttpResponseBase): Observable<JobSkillForGuestUserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobSkillForGuestUserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getListForJobProfileByCompany(jobId: number, skipCount: number | undefined, maxResultCount: number | undefined): Observable<JobSkillForGuestUserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/JobSkill/GetListForJobProfileByCompany?";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined and cannot be null.");
        else
            url_ += "JobId=" + encodeURIComponent("" + jobId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListForJobProfileByCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListForJobProfileByCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobSkillForGuestUserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobSkillForGuestUserDtoPagedResultDto>;
        }));
    }

    protected processGetListForJobProfileByCompany(response: HttpResponseBase): Observable<JobSkillForGuestUserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobSkillForGuestUserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MessageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateMessageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Message/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateNotificationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined): Observable<NotificationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<NotificationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllForReceiver(skipCount: number | undefined, maxResultCount: number | undefined): Observable<NotificationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetAllForReceiver?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForReceiver(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForReceiver(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationDtoPagedResultDto>;
        }));
    }

    protected processGetAllForReceiver(response: HttpResponseBase): Observable<NotificationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getUnReadedNotifications(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUnReadedNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnReadedNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnReadedNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetUnReadedNotifications(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllReveivers(type: NotificationReceiverType, keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<NotificationReceiversDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetAllReveivers?";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReveivers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReveivers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationReceiversDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationReceiversDtoPagedResultDto>;
        }));
    }

    protected processGetAllReveivers(response: HttpResponseBase): Observable<NotificationReceiversDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationReceiversDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    deleteAllBefore30Days(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/DeleteAllBefore30Days";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAllBefore30Days(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllBefore30Days(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAllBefore30Days(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PackageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param name (optional) 
     * @param description (optional) 
     * @param nameAr (optional) 
     * @param descriptionAr (optional) 
     * @param imageFile (optional) 
     * @param price (optional) 
     * @param isFree (optional) 
     * @param durationType (optional) 
     * @param durationTime (optional) 
     * @param jobPublishDurationType (optional) 
     * @param jobPublishDurationTime (optional) 
     * @param openCvCount (optional) 
     * @param publishJobsCount (optional) 
     * @return OK
     */
    create(name: string | undefined, description: string | undefined, nameAr: string | undefined, descriptionAr: string | undefined, imageFile: FileParameter | undefined, price: number | undefined, isFree: boolean | undefined, durationType: DurationType | undefined, durationTime: number | undefined, jobPublishDurationType: JobPublishDurationType | undefined, jobPublishDurationTime: number | undefined, openCvCount: number | undefined, publishJobsCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Package/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("Description", description.toString());
        if (nameAr === null || nameAr === undefined)
            throw new Error("The parameter 'nameAr' cannot be null.");
        else
            content_.append("NameAr", nameAr.toString());
        if (descriptionAr === null || descriptionAr === undefined)
            throw new Error("The parameter 'descriptionAr' cannot be null.");
        else
            content_.append("DescriptionAr", descriptionAr.toString());
        if (imageFile === null || imageFile === undefined)
            throw new Error("The parameter 'imageFile' cannot be null.");
        else
            content_.append("ImageFile", imageFile.data, imageFile.fileName ? imageFile.fileName : "ImageFile");
        if (price === null || price === undefined)
            throw new Error("The parameter 'price' cannot be null.");
        else
            content_.append("Price", price.toString());
        if (isFree === null || isFree === undefined)
            throw new Error("The parameter 'isFree' cannot be null.");
        else
            content_.append("IsFree", isFree.toString());
        if (durationType === null || durationType === undefined)
            throw new Error("The parameter 'durationType' cannot be null.");
        else
            content_.append("DurationType", durationType.toString());
        if (durationTime === null || durationTime === undefined)
            throw new Error("The parameter 'durationTime' cannot be null.");
        else
            content_.append("DurationTime", durationTime.toString());
        if (jobPublishDurationType === null || jobPublishDurationType === undefined)
            throw new Error("The parameter 'jobPublishDurationType' cannot be null.");
        else
            content_.append("jobPublishDurationType", jobPublishDurationType.toString());
        if (jobPublishDurationTime === null || jobPublishDurationTime === undefined)
            throw new Error("The parameter 'jobPublishDurationTime' cannot be null.");
        else
            content_.append("jobPublishDurationTime", jobPublishDurationTime.toString());
        if (openCvCount === null || openCvCount === undefined)
            throw new Error("The parameter 'openCvCount' cannot be null.");
        else
            content_.append("OpenCvCount", openCvCount.toString());
        if (publishJobsCount === null || publishJobsCount === undefined)
            throw new Error("The parameter 'publishJobsCount' cannot be null.");
        else
            content_.append("PublishJobsCount", publishJobsCount.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Package/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllByAdmin(skipCount: number | undefined, maxResultCount: number | undefined): Observable<PackageDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Package/GetAllByAdmin?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageDtoPagedResultDto>;
        }));
    }

    protected processGetAllByAdmin(response: HttpResponseBase): Observable<PackageDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @param description (optional) 
     * @param nameAr (optional) 
     * @param descriptionAr (optional) 
     * @param imageFile (optional) 
     * @param price (optional) 
     * @param isFree (optional) 
     * @param durationType (optional) 
     * @param durationTime (optional) 
     * @param jobPublishDurationType (optional) 
     * @param jobPublishDurationTime (optional) 
     * @param openCvCount (optional) 
     * @param publishJobsCount (optional) 
     * @param id (optional) 
     * @return OK
     */
    update(name: string | undefined, description: string | undefined, nameAr: string | undefined, descriptionAr: string | undefined, imageFile: FileParameter | undefined, price: number | undefined, isFree: boolean | undefined, durationType: DurationType2 | undefined, durationTime: number | undefined, jobPublishDurationType: JobPublishDurationType2 | undefined, jobPublishDurationTime: number | undefined, openCvCount: number | undefined, publishJobsCount: number | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Package/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("Description", description.toString());
        if (nameAr === null || nameAr === undefined)
            throw new Error("The parameter 'nameAr' cannot be null.");
        else
            content_.append("NameAr", nameAr.toString());
        if (descriptionAr === null || descriptionAr === undefined)
            throw new Error("The parameter 'descriptionAr' cannot be null.");
        else
            content_.append("DescriptionAr", descriptionAr.toString());
        if (imageFile === null || imageFile === undefined)
            throw new Error("The parameter 'imageFile' cannot be null.");
        else
            content_.append("ImageFile", imageFile.data, imageFile.fileName ? imageFile.fileName : "ImageFile");
        if (price === null || price === undefined)
            throw new Error("The parameter 'price' cannot be null.");
        else
            content_.append("Price", price.toString());
        if (isFree === null || isFree === undefined)
            throw new Error("The parameter 'isFree' cannot be null.");
        else
            content_.append("IsFree", isFree.toString());
        if (durationType === null || durationType === undefined)
            throw new Error("The parameter 'durationType' cannot be null.");
        else
            content_.append("DurationType", durationType.toString());
        if (durationTime === null || durationTime === undefined)
            throw new Error("The parameter 'durationTime' cannot be null.");
        else
            content_.append("DurationTime", durationTime.toString());
        if (jobPublishDurationType === null || jobPublishDurationType === undefined)
            throw new Error("The parameter 'jobPublishDurationType' cannot be null.");
        else
            content_.append("jobPublishDurationType", jobPublishDurationType.toString());
        if (jobPublishDurationTime === null || jobPublishDurationTime === undefined)
            throw new Error("The parameter 'jobPublishDurationTime' cannot be null.");
        else
            content_.append("jobPublishDurationTime", jobPublishDurationTime.toString());
        if (openCvCount === null || openCvCount === undefined)
            throw new Error("The parameter 'openCvCount' cannot be null.");
        else
            content_.append("OpenCvCount", openCvCount.toString());
        if (publishJobsCount === null || publishJobsCount === undefined)
            throw new Error("The parameter 'publishJobsCount' cannot be null.");
        else
            content_.append("PublishJobsCount", publishJobsCount.toString());
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAllByCompany(skipCount: number | undefined, maxResultCount: number | undefined): Observable<PackageByCompanyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Package/GetAllByCompany?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageByCompanyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageByCompanyDtoPagedResultDto>;
        }));
    }

    protected processGetAllByCompany(response: HttpResponseBase): Observable<PackageByCompanyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageByCompanyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    get(id: number): Observable<PackageByIdDto> {
        let url_ = this.baseUrl + "/api/services/app/Package/Get?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageByIdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageByIdDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PackageByIdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageByIdDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateRoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param permission (optional) 
     * @return OK
     */
    getRoles(permission: string | undefined): Observable<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission === null)
            throw new Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleListDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleListDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleListDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: RoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllPermissions(): Observable<PermissionDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionDtoListResultDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<PermissionDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SettingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getSettings(): Observable<SettingDto> {
        let url_ = this.baseUrl + "/api/services/app/Setting/GetSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SettingDto>;
        }));
    }

    protected processGetSettings(response: HttpResponseBase): Observable<SettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateSettings(body: SettingDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Setting/UpdateSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SkillServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateSkillDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Skill/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Skill/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    get(id: number): Observable<SkillByIdDto> {
        let url_ = this.baseUrl + "/api/services/app/Skill/Get?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SkillByIdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SkillByIdDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SkillByIdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SkillByIdDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param industryId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getList(filter: string | undefined, industryId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SkillDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Skill/GetList?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (industryId === null)
            throw new Error("The parameter 'industryId' cannot be null.");
        else if (industryId !== undefined)
            url_ += "IndustryId=" + encodeURIComponent("" + industryId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SkillDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SkillDtoPagedResultDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<SkillDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SkillDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: UpdateSkillDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Skill/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateTenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: TenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    authenticateCompany(body: AuthenticateCompanyOrEmployeeModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/AuthenticateCompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticateCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticateCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticateCompany(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    authenticateEmployee(body: AuthenticateCompanyOrEmployeeModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/AuthenticateEmployee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticateEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticateEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticateEmployee(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: UserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    activate(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deActivate(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeActivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getRoles(): Observable<RoleDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changePassword(body: ChangePasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    resetPassword(body: ResetPasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AboutUsDto implements IAboutUsDto {
    primaryTitle: string | undefined;
    secondaryTitle: string | undefined;
    description: string | undefined;
    image: string | undefined;

    constructor(data?: IAboutUsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryTitle = _data["primaryTitle"];
            this.secondaryTitle = _data["secondaryTitle"];
            this.description = _data["description"];
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): AboutUsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AboutUsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryTitle"] = this.primaryTitle;
        data["secondaryTitle"] = this.secondaryTitle;
        data["description"] = this.description;
        data["image"] = this.image;
        return data;
    }

    clone(): AboutUsDto {
        const json = this.toJSON();
        let result = new AboutUsDto();
        result.init(json);
        return result;
    }
}

export interface IAboutUsDto {
    primaryTitle: string | undefined;
    secondaryTitle: string | undefined;
    description: string | undefined;
    image: string | undefined;
}

export class AdvertisementByIdDto implements IAdvertisementByIdDto {
    id: number;
    title: string | undefined;
    titleAr: string | undefined;
    description: string | undefined;
    descriptionAr: string | undefined;
    order: number | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    isActive: boolean;
    imageUrl: string | undefined;
    linkUrl: string | undefined;
    buttonLinkText: string | undefined;
    buttonLinkTextAr: string | undefined;

    constructor(data?: IAdvertisementByIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.titleAr = _data["titleAr"];
            this.description = _data["description"];
            this.descriptionAr = _data["descriptionAr"];
            this.order = _data["order"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.imageUrl = _data["imageUrl"];
            this.linkUrl = _data["linkUrl"];
            this.buttonLinkText = _data["buttonLinkText"];
            this.buttonLinkTextAr = _data["buttonLinkTextAr"];
        }
    }

    static fromJS(data: any): AdvertisementByIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertisementByIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["titleAr"] = this.titleAr;
        data["description"] = this.description;
        data["descriptionAr"] = this.descriptionAr;
        data["order"] = this.order;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["imageUrl"] = this.imageUrl;
        data["linkUrl"] = this.linkUrl;
        data["buttonLinkText"] = this.buttonLinkText;
        data["buttonLinkTextAr"] = this.buttonLinkTextAr;
        return data;
    }

    clone(): AdvertisementByIdDto {
        const json = this.toJSON();
        let result = new AdvertisementByIdDto();
        result.init(json);
        return result;
    }
}

export interface IAdvertisementByIdDto {
    id: number;
    title: string | undefined;
    titleAr: string | undefined;
    description: string | undefined;
    descriptionAr: string | undefined;
    order: number | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    isActive: boolean;
    imageUrl: string | undefined;
    linkUrl: string | undefined;
    buttonLinkText: string | undefined;
    buttonLinkTextAr: string | undefined;
}

export class AdvertisementDto implements IAdvertisementDto {
    id: number;
    title: string | undefined;
    description: string | undefined;
    order: number | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    isActive: boolean | undefined;
    buttonLinkText: string | undefined;

    constructor(data?: IAdvertisementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.order = _data["order"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.buttonLinkText = _data["buttonLinkText"];
        }
    }

    static fromJS(data: any): AdvertisementDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertisementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["order"] = this.order;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["buttonLinkText"] = this.buttonLinkText;
        return data;
    }

    clone(): AdvertisementDto {
        const json = this.toJSON();
        let result = new AdvertisementDto();
        result.init(json);
        return result;
    }
}

export interface IAdvertisementDto {
    id: number;
    title: string | undefined;
    description: string | undefined;
    order: number | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    isActive: boolean | undefined;
    buttonLinkText: string | undefined;
}

export class AdvertisementDtoPagedResultDto implements IAdvertisementDtoPagedResultDto {
    items: AdvertisementDto[] | undefined;
    totalCount: number;

    constructor(data?: IAdvertisementDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AdvertisementDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AdvertisementDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertisementDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AdvertisementDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AdvertisementDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAdvertisementDtoPagedResultDto {
    items: AdvertisementDto[] | undefined;
    totalCount: number;
}

export class AdvertisementGuestUserDto implements IAdvertisementGuestUserDto {
    title: string | undefined;
    description: string | undefined;
    imageUrl: string | undefined;
    linkUrl: string | undefined;
    buttonLinkText: string | undefined;

    constructor(data?: IAdvertisementGuestUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.linkUrl = _data["linkUrl"];
            this.buttonLinkText = _data["buttonLinkText"];
        }
    }

    static fromJS(data: any): AdvertisementGuestUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertisementGuestUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["linkUrl"] = this.linkUrl;
        data["buttonLinkText"] = this.buttonLinkText;
        return data;
    }

    clone(): AdvertisementGuestUserDto {
        const json = this.toJSON();
        let result = new AdvertisementGuestUserDto();
        result.init(json);
        return result;
    }
}

export interface IAdvertisementGuestUserDto {
    title: string | undefined;
    description: string | undefined;
    imageUrl: string | undefined;
    linkUrl: string | undefined;
    buttonLinkText: string | undefined;
}

export class AdvertisementGuestUserDtoPagedResultDto implements IAdvertisementGuestUserDtoPagedResultDto {
    items: AdvertisementGuestUserDto[] | undefined;
    totalCount: number;

    constructor(data?: IAdvertisementGuestUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AdvertisementGuestUserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AdvertisementGuestUserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertisementGuestUserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AdvertisementGuestUserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AdvertisementGuestUserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAdvertisementGuestUserDtoPagedResultDto {
    items: AdvertisementGuestUserDto[] | undefined;
    totalCount: number;
}

export class AffiliateApplicantDto implements IAffiliateApplicantDto {
    id: number;
    affiliateName: string | undefined;
    affiliateType: UserType;
    affiliateApplicantName: string | undefined;
    affiliateApplicantType: UserType;
    isVerified: boolean;

    constructor(data?: IAffiliateApplicantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.affiliateName = _data["affiliateName"];
            this.affiliateType = _data["affiliateType"];
            this.affiliateApplicantName = _data["affiliateApplicantName"];
            this.affiliateApplicantType = _data["affiliateApplicantType"];
            this.isVerified = _data["isVerified"];
        }
    }

    static fromJS(data: any): AffiliateApplicantDto {
        data = typeof data === 'object' ? data : {};
        let result = new AffiliateApplicantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["affiliateName"] = this.affiliateName;
        data["affiliateType"] = this.affiliateType;
        data["affiliateApplicantName"] = this.affiliateApplicantName;
        data["affiliateApplicantType"] = this.affiliateApplicantType;
        data["isVerified"] = this.isVerified;
        return data;
    }

    clone(): AffiliateApplicantDto {
        const json = this.toJSON();
        let result = new AffiliateApplicantDto();
        result.init(json);
        return result;
    }
}

export interface IAffiliateApplicantDto {
    id: number;
    affiliateName: string | undefined;
    affiliateType: UserType;
    affiliateApplicantName: string | undefined;
    affiliateApplicantType: UserType;
    isVerified: boolean;
}

export class AffiliateApplicantDtoPagedResultDto implements IAffiliateApplicantDtoPagedResultDto {
    items: AffiliateApplicantDto[] | undefined;
    totalCount: number;

    constructor(data?: IAffiliateApplicantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AffiliateApplicantDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AffiliateApplicantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AffiliateApplicantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AffiliateApplicantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AffiliateApplicantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAffiliateApplicantDtoPagedResultDto {
    items: AffiliateApplicantDto[] | undefined;
    totalCount: number;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)[key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;
}

export class AuthenticateCompanyOrEmployeeModel implements IAuthenticateCompanyOrEmployeeModel {
    userNameOrEmailAddress: string;
    password: string;
    firebaseToken: string | undefined;

    constructor(data?: IAuthenticateCompanyOrEmployeeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.firebaseToken = _data["firebaseToken"];
        }
    }

    static fromJS(data: any): AuthenticateCompanyOrEmployeeModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateCompanyOrEmployeeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["firebaseToken"] = this.firebaseToken;
        return data;
    }

    clone(): AuthenticateCompanyOrEmployeeModel {
        const json = this.toJSON();
        let result = new AuthenticateCompanyOrEmployeeModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateCompanyOrEmployeeModel {
    userNameOrEmailAddress: string;
    password: string;
    firebaseToken: string | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        return data;
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        return data;
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword: string;
    newPassword: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data;
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class CityByIdDto implements ICityByIdDto {
    id: number;
    name: string | undefined;
    nameAr: string | undefined;
    countryId: number;
    order: number | undefined;

    constructor(data?: ICityByIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameAr = _data["nameAr"];
            this.countryId = _data["countryId"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): CityByIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new CityByIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameAr"] = this.nameAr;
        data["countryId"] = this.countryId;
        data["order"] = this.order;
        return data;
    }

    clone(): CityByIdDto {
        const json = this.toJSON();
        let result = new CityByIdDto();
        result.init(json);
        return result;
    }
}

export interface ICityByIdDto {
    id: number;
    name: string | undefined;
    nameAr: string | undefined;
    countryId: number;
    order: number | undefined;
}

export class CityDto implements ICityDto {
    id: number;
    name: string | undefined;

    constructor(data?: ICityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): CityDto {
        const json = this.toJSON();
        let result = new CityDto();
        result.init(json);
        return result;
    }
}

export interface ICityDto {
    id: number;
    name: string | undefined;
}

export class CityDtoPagedResultDto implements ICityDtoPagedResultDto {
    items: CityDto[] | undefined;
    totalCount: number;

    constructor(data?: ICityDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CityDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CityDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CityDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CityDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CityDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICityDtoPagedResultDto {
    items: CityDto[] | undefined;
    totalCount: number;
}

export class CityForAdminDto implements ICityForAdminDto {
    id: number;
    name: string | undefined;
    order: number | undefined;

    constructor(data?: ICityForAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): CityForAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new CityForAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["order"] = this.order;
        return data;
    }

    clone(): CityForAdminDto {
        const json = this.toJSON();
        let result = new CityForAdminDto();
        result.init(json);
        return result;
    }
}

export interface ICityForAdminDto {
    id: number;
    name: string | undefined;
    order: number | undefined;
}

export class CityForAdminDtoPagedResultDto implements ICityForAdminDtoPagedResultDto {
    items: CityForAdminDto[] | undefined;
    totalCount: number;

    constructor(data?: ICityForAdminDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CityForAdminDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CityForAdminDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CityForAdminDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CityForAdminDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CityForAdminDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICityForAdminDtoPagedResultDto {
    items: CityForAdminDto[] | undefined;
    totalCount: number;
}

export class CompanyByAdminDto implements ICompanyByAdminDto {
    id: number;
    name: string | undefined;
    emailAddress: string | undefined;
    country: string | undefined;
    city: string | undefined;
    address: string | undefined;
    isComplatedProfile: boolean;
    status: CompanyStatus;
    isDeletedAccount: boolean;
    showInHomePage: boolean;
    isVerifiedAccount: boolean;
    emailConfirmationCode: string | undefined;

    constructor(data?: ICompanyByAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.emailAddress = _data["emailAddress"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.address = _data["address"];
            this.isComplatedProfile = _data["isComplatedProfile"];
            this.status = _data["status"];
            this.isDeletedAccount = _data["isDeletedAccount"];
            this.showInHomePage = _data["showInHomePage"];
            this.isVerifiedAccount = _data["isVerifiedAccount"];
            this.emailConfirmationCode = _data["emailConfirmationCode"];
        }
    }

    static fromJS(data: any): CompanyByAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyByAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["emailAddress"] = this.emailAddress;
        data["country"] = this.country;
        data["city"] = this.city;
        data["address"] = this.address;
        data["isComplatedProfile"] = this.isComplatedProfile;
        data["status"] = this.status;
        data["isDeletedAccount"] = this.isDeletedAccount;
        data["showInHomePage"] = this.showInHomePage;
        data["isVerifiedAccount"] = this.isVerifiedAccount;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        return data;
    }

    clone(): CompanyByAdminDto {
        const json = this.toJSON();
        let result = new CompanyByAdminDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyByAdminDto {
    id: number;
    name: string | undefined;
    emailAddress: string | undefined;
    country: string | undefined;
    city: string | undefined;
    address: string | undefined;
    isComplatedProfile: boolean;
    status: CompanyStatus;
    isDeletedAccount: boolean;
    showInHomePage: boolean;
    isVerifiedAccount: boolean;
    emailConfirmationCode: string | undefined;
}

export class CompanyByAdminDtoPagedResultDto implements ICompanyByAdminDtoPagedResultDto {
    items: CompanyByAdminDto[] | undefined;
    totalCount: number;

    constructor(data?: ICompanyByAdminDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CompanyByAdminDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CompanyByAdminDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyByAdminDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CompanyByAdminDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CompanyByAdminDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyByAdminDtoPagedResultDto {
    items: CompanyByAdminDto[] | undefined;
    totalCount: number;
}

export class CompanyDetailsByAdminDto implements ICompanyDetailsByAdminDto {
    name: string | undefined;
    accountEmailAddress: string | undefined;
    companyType: CompanyType;
    companySize: CompanySize;
    country: string | undefined;
    city: string | undefined;
    address: string | undefined;
    webSite: string | undefined;
    phone: string | undefined;
    accountPhoneNumber: string | undefined;
    email: string | undefined;
    image: string | undefined;
    establishDate: moment.Moment | undefined;
    numberOfBranchs: number | undefined;
    description: string | undefined;
    managerName: string | undefined;
    order: number | undefined;
    showInHomePage: boolean;
    isComplatedProfile: boolean;
    isDeletedAccount: boolean;
    isVerifiedAccount: boolean;
    status: CompanyStatus;

    constructor(data?: ICompanyDetailsByAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.accountEmailAddress = _data["accountEmailAddress"];
            this.companyType = _data["companyType"];
            this.companySize = _data["companySize"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.address = _data["address"];
            this.webSite = _data["webSite"];
            this.phone = _data["phone"];
            this.accountPhoneNumber = _data["accountPhoneNumber"];
            this.email = _data["email"];
            this.image = _data["image"];
            this.establishDate = _data["establishDate"] ? moment(_data["establishDate"].toString()) : <any>undefined;
            this.numberOfBranchs = _data["numberOfBranchs"];
            this.description = _data["description"];
            this.managerName = _data["managerName"];
            this.order = _data["order"];
            this.showInHomePage = _data["showInHomePage"];
            this.isComplatedProfile = _data["isComplatedProfile"];
            this.isDeletedAccount = _data["isDeletedAccount"];
            this.isVerifiedAccount = _data["isVerifiedAccount"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CompanyDetailsByAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDetailsByAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["accountEmailAddress"] = this.accountEmailAddress;
        data["companyType"] = this.companyType;
        data["companySize"] = this.companySize;
        data["country"] = this.country;
        data["city"] = this.city;
        data["address"] = this.address;
        data["webSite"] = this.webSite;
        data["phone"] = this.phone;
        data["accountPhoneNumber"] = this.accountPhoneNumber;
        data["email"] = this.email;
        data["image"] = this.image;
        data["establishDate"] = this.establishDate ? this.establishDate.toISOString() : <any>undefined;
        data["numberOfBranchs"] = this.numberOfBranchs;
        data["description"] = this.description;
        data["managerName"] = this.managerName;
        data["order"] = this.order;
        data["showInHomePage"] = this.showInHomePage;
        data["isComplatedProfile"] = this.isComplatedProfile;
        data["isDeletedAccount"] = this.isDeletedAccount;
        data["isVerifiedAccount"] = this.isVerifiedAccount;
        data["status"] = this.status;
        return data;
    }

    clone(): CompanyDetailsByAdminDto {
        const json = this.toJSON();
        let result = new CompanyDetailsByAdminDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyDetailsByAdminDto {
    name: string | undefined;
    accountEmailAddress: string | undefined;
    companyType: CompanyType;
    companySize: CompanySize;
    country: string | undefined;
    city: string | undefined;
    address: string | undefined;
    webSite: string | undefined;
    phone: string | undefined;
    accountPhoneNumber: string | undefined;
    email: string | undefined;
    image: string | undefined;
    establishDate: moment.Moment | undefined;
    numberOfBranchs: number | undefined;
    description: string | undefined;
    managerName: string | undefined;
    order: number | undefined;
    showInHomePage: boolean;
    isComplatedProfile: boolean;
    isDeletedAccount: boolean;
    isVerifiedAccount: boolean;
    status: CompanyStatus;
}

export class CompanyDetailsDto implements ICompanyDetailsDto {
    name: string | undefined;
    industryName: string | undefined;
    image: string | undefined;
    country: string | undefined;
    city: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    webSite: string | undefined;
    companyType: CompanyType;
    numberOfBranchs: number | undefined;
    companySize: CompanySize;
    establishDate: moment.Moment | undefined;
    description: string | undefined;
    address: string | undefined;
    isVerifiedAccount: boolean;
    companySocialMedia: CompanySocialMediaDto[] | undefined;

    constructor(data?: ICompanyDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.industryName = _data["industryName"];
            this.image = _data["image"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.webSite = _data["webSite"];
            this.companyType = _data["companyType"];
            this.numberOfBranchs = _data["numberOfBranchs"];
            this.companySize = _data["companySize"];
            this.establishDate = _data["establishDate"] ? moment(_data["establishDate"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.address = _data["address"];
            this.isVerifiedAccount = _data["isVerifiedAccount"];
            if (Array.isArray(_data["companySocialMedia"])) {
                this.companySocialMedia = [] as any;
                for (let item of _data["companySocialMedia"])
                    this.companySocialMedia.push(CompanySocialMediaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompanyDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["industryName"] = this.industryName;
        data["image"] = this.image;
        data["country"] = this.country;
        data["city"] = this.city;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["webSite"] = this.webSite;
        data["companyType"] = this.companyType;
        data["numberOfBranchs"] = this.numberOfBranchs;
        data["companySize"] = this.companySize;
        data["establishDate"] = this.establishDate ? this.establishDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["address"] = this.address;
        data["isVerifiedAccount"] = this.isVerifiedAccount;
        if (Array.isArray(this.companySocialMedia)) {
            data["companySocialMedia"] = [];
            for (let item of this.companySocialMedia)
                data["companySocialMedia"].push(item.toJSON());
        }
        return data;
    }

    clone(): CompanyDetailsDto {
        const json = this.toJSON();
        let result = new CompanyDetailsDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyDetailsDto {
    name: string | undefined;
    industryName: string | undefined;
    image: string | undefined;
    country: string | undefined;
    city: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    webSite: string | undefined;
    companyType: CompanyType;
    numberOfBranchs: number | undefined;
    companySize: CompanySize;
    establishDate: moment.Moment | undefined;
    description: string | undefined;
    address: string | undefined;
    isVerifiedAccount: boolean;
    companySocialMedia: CompanySocialMediaDto[] | undefined;
}

export class CompanyGuestUserDto implements ICompanyGuestUserDto {
    id: number;
    industryName: string | undefined;
    name: string | undefined;
    country: string | undefined;
    city: string | undefined;
    image: string | undefined;

    constructor(data?: ICompanyGuestUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.industryName = _data["industryName"];
            this.name = _data["name"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): CompanyGuestUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyGuestUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["industryName"] = this.industryName;
        data["name"] = this.name;
        data["country"] = this.country;
        data["city"] = this.city;
        data["image"] = this.image;
        return data;
    }

    clone(): CompanyGuestUserDto {
        const json = this.toJSON();
        let result = new CompanyGuestUserDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyGuestUserDto {
    id: number;
    industryName: string | undefined;
    name: string | undefined;
    country: string | undefined;
    city: string | undefined;
    image: string | undefined;
}

export class CompanyGuestUserDtoPagedResultDto implements ICompanyGuestUserDtoPagedResultDto {
    items: CompanyGuestUserDto[] | undefined;
    totalCount: number;

    constructor(data?: ICompanyGuestUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CompanyGuestUserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CompanyGuestUserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyGuestUserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CompanyGuestUserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CompanyGuestUserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyGuestUserDtoPagedResultDto {
    items: CompanyGuestUserDto[] | undefined;
    totalCount: number;
}

export class CompanyGuestUserInHomePageDto implements ICompanyGuestUserInHomePageDto {
    id: number;
    name: string | undefined;
    image: string | undefined;

    constructor(data?: ICompanyGuestUserInHomePageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): CompanyGuestUserInHomePageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyGuestUserInHomePageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["image"] = this.image;
        return data;
    }

    clone(): CompanyGuestUserInHomePageDto {
        const json = this.toJSON();
        let result = new CompanyGuestUserInHomePageDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyGuestUserInHomePageDto {
    id: number;
    name: string | undefined;
    image: string | undefined;
}

export class CompanyIndustryDto implements ICompanyIndustryDto {
    id: number;
    industryId: number;
    name: string | undefined;

    constructor(data?: ICompanyIndustryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.industryId = _data["industryId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CompanyIndustryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyIndustryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["industryId"] = this.industryId;
        data["name"] = this.name;
        return data;
    }

    clone(): CompanyIndustryDto {
        const json = this.toJSON();
        let result = new CompanyIndustryDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyIndustryDto {
    id: number;
    industryId: number;
    name: string | undefined;
}

export class CompanyIndustryForGuestUserDto implements ICompanyIndustryForGuestUserDto {
    name: string | undefined;

    constructor(data?: ICompanyIndustryForGuestUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CompanyIndustryForGuestUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyIndustryForGuestUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }

    clone(): CompanyIndustryForGuestUserDto {
        const json = this.toJSON();
        let result = new CompanyIndustryForGuestUserDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyIndustryForGuestUserDto {
    name: string | undefined;
}

export class CompanyIndustryForGuestUserDtoPagedResultDto implements ICompanyIndustryForGuestUserDtoPagedResultDto {
    items: CompanyIndustryForGuestUserDto[] | undefined;
    totalCount: number;

    constructor(data?: ICompanyIndustryForGuestUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CompanyIndustryForGuestUserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CompanyIndustryForGuestUserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyIndustryForGuestUserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CompanyIndustryForGuestUserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CompanyIndustryForGuestUserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyIndustryForGuestUserDtoPagedResultDto {
    items: CompanyIndustryForGuestUserDto[] | undefined;
    totalCount: number;
}

export class CompanyPackageByAdminDto implements ICompanyPackageByAdminDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    openCvCount: number | undefined;
    publishJobsCount: number | undefined;
    durationType: CompanyPackageByAdminDtoDurationType | undefined;
    durationTime: number | undefined;
    jobPublishDurationType: CompanyPackageByAdminDtoJobPublishDurationType | undefined;
    jobPublishDurationTime: number | undefined;
    status: CompanyPackageStatus;
    companyName: string | undefined;
    price: number | undefined;

    constructor(data?: ICompanyPackageByAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.openCvCount = _data["openCvCount"];
            this.publishJobsCount = _data["publishJobsCount"];
            this.durationType = _data["durationType"];
            this.durationTime = _data["durationTime"];
            this.jobPublishDurationType = _data["jobPublishDurationType"];
            this.jobPublishDurationTime = _data["jobPublishDurationTime"];
            this.status = _data["status"];
            this.companyName = _data["companyName"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): CompanyPackageByAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPackageByAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["openCvCount"] = this.openCvCount;
        data["publishJobsCount"] = this.publishJobsCount;
        data["durationType"] = this.durationType;
        data["durationTime"] = this.durationTime;
        data["jobPublishDurationType"] = this.jobPublishDurationType;
        data["jobPublishDurationTime"] = this.jobPublishDurationTime;
        data["status"] = this.status;
        data["companyName"] = this.companyName;
        data["price"] = this.price;
        return data;
    }

    clone(): CompanyPackageByAdminDto {
        const json = this.toJSON();
        let result = new CompanyPackageByAdminDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyPackageByAdminDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    openCvCount: number | undefined;
    publishJobsCount: number | undefined;
    durationType: CompanyPackageByAdminDtoDurationType | undefined;
    durationTime: number | undefined;
    jobPublishDurationType: CompanyPackageByAdminDtoJobPublishDurationType | undefined;
    jobPublishDurationTime: number | undefined;
    status: CompanyPackageStatus;
    companyName: string | undefined;
    price: number | undefined;
}

export class CompanyPackageByAdminDtoPagedResultDto implements ICompanyPackageByAdminDtoPagedResultDto {
    items: CompanyPackageByAdminDto[] | undefined;
    totalCount: number;

    constructor(data?: ICompanyPackageByAdminDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CompanyPackageByAdminDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CompanyPackageByAdminDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPackageByAdminDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CompanyPackageByAdminDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CompanyPackageByAdminDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyPackageByAdminDtoPagedResultDto {
    items: CompanyPackageByAdminDto[] | undefined;
    totalCount: number;
}

export class CompanyPackageDto implements ICompanyPackageDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    openCvRemainCount: number | undefined;
    publishJobsRemainCount: number | undefined;
    packageRemainEndDate: moment.Moment | undefined;
    status: CompanyPackageStatus;
    isFree: boolean;
    packageId: number;
    price: number | undefined;

    constructor(data?: ICompanyPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.openCvRemainCount = _data["openCvRemainCount"];
            this.publishJobsRemainCount = _data["publishJobsRemainCount"];
            this.packageRemainEndDate = _data["packageRemainEndDate"] ? moment(_data["packageRemainEndDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.isFree = _data["isFree"];
            this.packageId = _data["packageId"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): CompanyPackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["openCvRemainCount"] = this.openCvRemainCount;
        data["publishJobsRemainCount"] = this.publishJobsRemainCount;
        data["packageRemainEndDate"] = this.packageRemainEndDate ? this.packageRemainEndDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["isFree"] = this.isFree;
        data["packageId"] = this.packageId;
        data["price"] = this.price;
        return data;
    }

    clone(): CompanyPackageDto {
        const json = this.toJSON();
        let result = new CompanyPackageDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyPackageDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    openCvRemainCount: number | undefined;
    publishJobsRemainCount: number | undefined;
    packageRemainEndDate: moment.Moment | undefined;
    status: CompanyPackageStatus;
    isFree: boolean;
    packageId: number;
    price: number | undefined;
}

export class CompanyPackageDtoPagedResultDto implements ICompanyPackageDtoPagedResultDto {
    items: CompanyPackageDto[] | undefined;
    totalCount: number;

    constructor(data?: ICompanyPackageDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CompanyPackageDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CompanyPackageDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPackageDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CompanyPackageDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CompanyPackageDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyPackageDtoPagedResultDto {
    items: CompanyPackageDto[] | undefined;
    totalCount: number;
}

export class CompanyPackageForSelectDto implements ICompanyPackageForSelectDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    openCvRemainCount: number | undefined;
    publishJobsRemainCount: number | undefined;
    packageRemainEndDate: moment.Moment | undefined;
    status: CompanyPackageStatus;
    isFree: boolean;
    packageId: number;

    constructor(data?: ICompanyPackageForSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.openCvRemainCount = _data["openCvRemainCount"];
            this.publishJobsRemainCount = _data["publishJobsRemainCount"];
            this.packageRemainEndDate = _data["packageRemainEndDate"] ? moment(_data["packageRemainEndDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.isFree = _data["isFree"];
            this.packageId = _data["packageId"];
        }
    }

    static fromJS(data: any): CompanyPackageForSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPackageForSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["openCvRemainCount"] = this.openCvRemainCount;
        data["publishJobsRemainCount"] = this.publishJobsRemainCount;
        data["packageRemainEndDate"] = this.packageRemainEndDate ? this.packageRemainEndDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["isFree"] = this.isFree;
        data["packageId"] = this.packageId;
        return data;
    }

    clone(): CompanyPackageForSelectDto {
        const json = this.toJSON();
        let result = new CompanyPackageForSelectDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyPackageForSelectDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    openCvRemainCount: number | undefined;
    publishJobsRemainCount: number | undefined;
    packageRemainEndDate: moment.Moment | undefined;
    status: CompanyPackageStatus;
    isFree: boolean;
    packageId: number;
}

export class CompanyPackageForSelectDtoPagedResultDto implements ICompanyPackageForSelectDtoPagedResultDto {
    items: CompanyPackageForSelectDto[] | undefined;
    totalCount: number;

    constructor(data?: ICompanyPackageForSelectDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CompanyPackageForSelectDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CompanyPackageForSelectDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPackageForSelectDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CompanyPackageForSelectDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CompanyPackageForSelectDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyPackageForSelectDtoPagedResultDto {
    items: CompanyPackageForSelectDto[] | undefined;
    totalCount: number;
}

export enum CompanyPackageStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum CompanySize {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export class CompanySocialMediaDto implements ICompanySocialMediaDto {
    id: number;
    link: string | undefined;
    icon: string | undefined;
    name: string | undefined;

    constructor(data?: ICompanySocialMediaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.link = _data["link"];
            this.icon = _data["icon"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CompanySocialMediaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanySocialMediaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["link"] = this.link;
        data["icon"] = this.icon;
        data["name"] = this.name;
        return data;
    }

    clone(): CompanySocialMediaDto {
        const json = this.toJSON();
        let result = new CompanySocialMediaDto();
        result.init(json);
        return result;
    }
}

export interface ICompanySocialMediaDto {
    id: number;
    link: string | undefined;
    icon: string | undefined;
    name: string | undefined;
}

export class CompanySocialMediaDtoPagedResultDto implements ICompanySocialMediaDtoPagedResultDto {
    items: CompanySocialMediaDto[] | undefined;
    totalCount: number;

    constructor(data?: ICompanySocialMediaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CompanySocialMediaDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CompanySocialMediaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanySocialMediaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CompanySocialMediaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CompanySocialMediaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICompanySocialMediaDtoPagedResultDto {
    items: CompanySocialMediaDto[] | undefined;
    totalCount: number;
}

export enum CompanyStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum CompanyType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _14 = 14,
    _15 = 15,
    _16 = 16,
}

export class CompanyUserAccountDto implements ICompanyUserAccountDto {
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: ICompanyUserAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CompanyUserAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyUserAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): CompanyUserAccountDto {
        const json = this.toJSON();
        let result = new CompanyUserAccountDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyUserAccountDto {
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    lastModificationTime: moment.Moment | undefined;
}

export class CompletedCompanyProfileDto implements ICompletedCompanyProfileDto {
    isComplatedProfile: boolean;
    image: string | undefined;

    constructor(data?: ICompletedCompanyProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isComplatedProfile = _data["isComplatedProfile"];
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): CompletedCompanyProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompletedCompanyProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isComplatedProfile"] = this.isComplatedProfile;
        data["image"] = this.image;
        return data;
    }

    clone(): CompletedCompanyProfileDto {
        const json = this.toJSON();
        let result = new CompletedCompanyProfileDto();
        result.init(json);
        return result;
    }
}

export interface ICompletedCompanyProfileDto {
    isComplatedProfile: boolean;
    image: string | undefined;
}

export class CompletedEmployeeProfileDto implements ICompletedEmployeeProfileDto {
    isComplatedProfile: boolean;
    image: string | undefined;

    constructor(data?: ICompletedEmployeeProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isComplatedProfile = _data["isComplatedProfile"];
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): CompletedEmployeeProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompletedEmployeeProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isComplatedProfile"] = this.isComplatedProfile;
        data["image"] = this.image;
        return data;
    }

    clone(): CompletedEmployeeProfileDto {
        const json = this.toJSON();
        let result = new CompletedEmployeeProfileDto();
        result.init(json);
        return result;
    }
}

export interface ICompletedEmployeeProfileDto {
    isComplatedProfile: boolean;
    image: string | undefined;
}

export class ContactInfoDto implements IContactInfoDto {
    content: string | undefined;
    icon: string | undefined;
    type: ContactInfoType;

    constructor(data?: IContactInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
            this.icon = _data["icon"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ContactInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["icon"] = this.icon;
        data["type"] = this.type;
        return data;
    }

    clone(): ContactInfoDto {
        const json = this.toJSON();
        let result = new ContactInfoDto();
        result.init(json);
        return result;
    }
}

export interface IContactInfoDto {
    content: string | undefined;
    icon: string | undefined;
    type: ContactInfoType;
}

export enum ContactInfoType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class CountryByIdDto implements ICountryByIdDto {
    id: number;
    name: string | undefined;
    order: number | undefined;
    showInHomePage: boolean;
    nameAr: string | undefined;
    isDisabled: boolean;

    constructor(data?: ICountryByIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.order = _data["order"];
            this.showInHomePage = _data["showInHomePage"];
            this.nameAr = _data["nameAr"];
            this.isDisabled = _data["isDisabled"];
        }
    }

    static fromJS(data: any): CountryByIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryByIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["order"] = this.order;
        data["showInHomePage"] = this.showInHomePage;
        data["nameAr"] = this.nameAr;
        data["isDisabled"] = this.isDisabled;
        return data;
    }

    clone(): CountryByIdDto {
        const json = this.toJSON();
        let result = new CountryByIdDto();
        result.init(json);
        return result;
    }
}

export interface ICountryByIdDto {
    id: number;
    name: string | undefined;
    order: number | undefined;
    showInHomePage: boolean;
    nameAr: string | undefined;
    isDisabled: boolean;
}

export class CountryDto implements ICountryDto {
    id: number;
    name: string | undefined;
    showInHomePage: boolean;
    isDisabled: boolean;

    constructor(data?: ICountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.showInHomePage = _data["showInHomePage"];
            this.isDisabled = _data["isDisabled"];
        }
    }

    static fromJS(data: any): CountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["showInHomePage"] = this.showInHomePage;
        data["isDisabled"] = this.isDisabled;
        return data;
    }

    clone(): CountryDto {
        const json = this.toJSON();
        let result = new CountryDto();
        result.init(json);
        return result;
    }
}

export interface ICountryDto {
    id: number;
    name: string | undefined;
    showInHomePage: boolean;
    isDisabled: boolean;
}

export class CountryDtoPagedResultDto implements ICountryDtoPagedResultDto {
    items: CountryDto[] | undefined;
    totalCount: number;

    constructor(data?: ICountryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CountryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CountryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CountryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CountryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICountryDtoPagedResultDto {
    items: CountryDto[] | undefined;
    totalCount: number;
}

export class CountryForSelectDto implements ICountryForSelectDto {
    id: number;
    name: string | undefined;

    constructor(data?: ICountryForSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CountryForSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryForSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): CountryForSelectDto {
        const json = this.toJSON();
        let result = new CountryForSelectDto();
        result.init(json);
        return result;
    }
}

export interface ICountryForSelectDto {
    id: number;
    name: string | undefined;
}

export class CountryForSelectDtoPagedResultDto implements ICountryForSelectDtoPagedResultDto {
    items: CountryForSelectDto[] | undefined;
    totalCount: number;

    constructor(data?: ICountryForSelectDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CountryForSelectDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CountryForSelectDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryForSelectDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CountryForSelectDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CountryForSelectDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICountryForSelectDtoPagedResultDto {
    items: CountryForSelectDto[] | undefined;
    totalCount: number;
}

export class CountryGuestUserDto implements ICountryGuestUserDto {
    id: number;
    name: string | undefined;
    jobsCount: number;

    constructor(data?: ICountryGuestUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.jobsCount = _data["jobsCount"];
        }
    }

    static fromJS(data: any): CountryGuestUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryGuestUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["jobsCount"] = this.jobsCount;
        return data;
    }

    clone(): CountryGuestUserDto {
        const json = this.toJSON();
        let result = new CountryGuestUserDto();
        result.init(json);
        return result;
    }
}

export interface ICountryGuestUserDto {
    id: number;
    name: string | undefined;
    jobsCount: number;
}

export class CountryGuestUserDtoPagedResultDto implements ICountryGuestUserDtoPagedResultDto {
    items: CountryGuestUserDto[] | undefined;
    totalCount: number;

    constructor(data?: ICountryGuestUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CountryGuestUserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CountryGuestUserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryGuestUserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CountryGuestUserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CountryGuestUserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICountryGuestUserDtoPagedResultDto {
    items: CountryGuestUserDto[] | undefined;
    totalCount: number;
}

export class CreateCityDto implements ICreateCityDto {
    name: string;
    nameAr: string | undefined;
    countryId: number;
    order: number | undefined;

    constructor(data?: ICreateCityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameAr = _data["nameAr"];
            this.countryId = _data["countryId"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): CreateCityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameAr"] = this.nameAr;
        data["countryId"] = this.countryId;
        data["order"] = this.order;
        return data;
    }

    clone(): CreateCityDto {
        const json = this.toJSON();
        let result = new CreateCityDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCityDto {
    name: string;
    nameAr: string | undefined;
    countryId: number;
    order: number | undefined;
}

export class CreateCompanyIndustryDto implements ICreateCompanyIndustryDto {
    industryId: number;

    constructor(data?: ICreateCompanyIndustryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.industryId = _data["industryId"];
        }
    }

    static fromJS(data: any): CreateCompanyIndustryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyIndustryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["industryId"] = this.industryId;
        return data;
    }

    clone(): CreateCompanyIndustryDto {
        const json = this.toJSON();
        let result = new CreateCompanyIndustryDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCompanyIndustryDto {
    industryId: number;
}

export class CreateCompanySocialMediaDto implements ICreateCompanySocialMediaDto {
    link: string;
    name: string;
    icon: string;

    constructor(data?: ICreateCompanySocialMediaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.link = _data["link"];
            this.name = _data["name"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): CreateCompanySocialMediaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanySocialMediaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["link"] = this.link;
        data["name"] = this.name;
        data["icon"] = this.icon;
        return data;
    }

    clone(): CreateCompanySocialMediaDto {
        const json = this.toJSON();
        let result = new CreateCompanySocialMediaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCompanySocialMediaDto {
    link: string;
    name: string;
    icon: string;
}

export class CreateCountryDto implements ICreateCountryDto {
    name: string;
    order: number | undefined;
    showInHomePage: boolean;
    nameAr: string | undefined;
    isDisabled: boolean;

    constructor(data?: ICreateCountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.order = _data["order"];
            this.showInHomePage = _data["showInHomePage"];
            this.nameAr = _data["nameAr"];
            this.isDisabled = _data["isDisabled"];
        }
    }

    static fromJS(data: any): CreateCountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["order"] = this.order;
        data["showInHomePage"] = this.showInHomePage;
        data["nameAr"] = this.nameAr;
        data["isDisabled"] = this.isDisabled;
        return data;
    }

    clone(): CreateCountryDto {
        const json = this.toJSON();
        let result = new CreateCountryDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCountryDto {
    name: string;
    order: number | undefined;
    showInHomePage: boolean;
    nameAr: string | undefined;
    isDisabled: boolean;
}

export class CreateEmployeeCertificateDto implements ICreateEmployeeCertificateDto {
    certificateName: string | undefined;
    educationCertificateType: EducationCertificateType;
    college: string;
    successDegree: number | undefined;
    from: moment.Moment;
    to: moment.Moment | undefined;
    shortDescription: string | undefined;

    constructor(data?: ICreateEmployeeCertificateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.certificateName = _data["certificateName"];
            this.educationCertificateType = _data["educationCertificateType"];
            this.college = _data["college"];
            this.successDegree = _data["successDegree"];
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
            this.shortDescription = _data["shortDescription"];
        }
    }

    static fromJS(data: any): CreateEmployeeCertificateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmployeeCertificateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["certificateName"] = this.certificateName;
        data["educationCertificateType"] = this.educationCertificateType;
        data["college"] = this.college;
        data["successDegree"] = this.successDegree;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["shortDescription"] = this.shortDescription;
        return data;
    }

    clone(): CreateEmployeeCertificateDto {
        const json = this.toJSON();
        let result = new CreateEmployeeCertificateDto();
        result.init(json);
        return result;
    }
}

export interface ICreateEmployeeCertificateDto {
    certificateName: string | undefined;
    educationCertificateType: EducationCertificateType;
    college: string;
    successDegree: number | undefined;
    from: moment.Moment;
    to: moment.Moment | undefined;
    shortDescription: string | undefined;
}

export class CreateEmployeeExperienceDto implements ICreateEmployeeExperienceDto {
    industryId: number;
    jobPositionId: number | undefined;
    otherPositionName: string | undefined;
    companyName: string | undefined;
    country: string | undefined;
    from: moment.Moment;
    to: moment.Moment | undefined;
    shortDescription: string | undefined;

    constructor(data?: ICreateEmployeeExperienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.industryId = _data["industryId"];
            this.jobPositionId = _data["jobPositionId"];
            this.otherPositionName = _data["otherPositionName"];
            this.companyName = _data["companyName"];
            this.country = _data["country"];
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
            this.shortDescription = _data["shortDescription"];
        }
    }

    static fromJS(data: any): CreateEmployeeExperienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmployeeExperienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["industryId"] = this.industryId;
        data["jobPositionId"] = this.jobPositionId;
        data["otherPositionName"] = this.otherPositionName;
        data["companyName"] = this.companyName;
        data["country"] = this.country;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["shortDescription"] = this.shortDescription;
        return data;
    }

    clone(): CreateEmployeeExperienceDto {
        const json = this.toJSON();
        let result = new CreateEmployeeExperienceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateEmployeeExperienceDto {
    industryId: number;
    jobPositionId: number | undefined;
    otherPositionName: string | undefined;
    companyName: string | undefined;
    country: string | undefined;
    from: moment.Moment;
    to: moment.Moment | undefined;
    shortDescription: string | undefined;
}

export class CreateEmployeeLanguageDto implements ICreateEmployeeLanguageDto {
    name: string | undefined;
    flag: string | undefined;

    constructor(data?: ICreateEmployeeLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.flag = _data["flag"];
        }
    }

    static fromJS(data: any): CreateEmployeeLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmployeeLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["flag"] = this.flag;
        return data;
    }

    clone(): CreateEmployeeLanguageDto {
        const json = this.toJSON();
        let result = new CreateEmployeeLanguageDto();
        result.init(json);
        return result;
    }
}

export interface ICreateEmployeeLanguageDto {
    name: string | undefined;
    flag: string | undefined;
}

export class CreateEmployeeSkillDto implements ICreateEmployeeSkillDto {
    skillId: number | undefined;
    name: string | undefined;

    constructor(data?: ICreateEmployeeSkillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skillId = _data["skillId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateEmployeeSkillDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmployeeSkillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skillId"] = this.skillId;
        data["name"] = this.name;
        return data;
    }

    clone(): CreateEmployeeSkillDto {
        const json = this.toJSON();
        let result = new CreateEmployeeSkillDto();
        result.init(json);
        return result;
    }
}

export interface ICreateEmployeeSkillDto {
    skillId: number | undefined;
    name: string | undefined;
}

export class CreateEmployeeSocialMediaDto implements ICreateEmployeeSocialMediaDto {
    link: string;
    name: string;
    icon: string;

    constructor(data?: ICreateEmployeeSocialMediaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.link = _data["link"];
            this.name = _data["name"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): CreateEmployeeSocialMediaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmployeeSocialMediaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["link"] = this.link;
        data["name"] = this.name;
        data["icon"] = this.icon;
        return data;
    }

    clone(): CreateEmployeeSocialMediaDto {
        const json = this.toJSON();
        let result = new CreateEmployeeSocialMediaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateEmployeeSocialMediaDto {
    link: string;
    name: string;
    icon: string;
}

export class CreateJobByCompanyDto implements ICreateJobByCompanyDto {
    industryId: number | undefined;
    jobPositionId: number | undefined;
    educationLevel: EducationLevel;
    positionLevel: PositionLevel;
    gender: Gender;
    jobAgeRange: JobAgeRange;
    jobType: JobType;
    workPlaceType: WorkPlaceType;
    countryId: number | undefined;
    cityId: number | undefined;
    vacanciesNumber: number | undefined;
    isSalaryAfterInterview: boolean;
    salary: number | undefined;
    jobDescription: string | undefined;
    isShowWithCompany: boolean;
    closeDate: moment.Moment | undefined;
    skills: CreateJobSkillDto[] | undefined;
    languages: CreateJobLanguageDto[] | undefined;

    constructor(data?: ICreateJobByCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.industryId = _data["industryId"];
            this.jobPositionId = _data["jobPositionId"];
            this.educationLevel = _data["educationLevel"];
            this.positionLevel = _data["positionLevel"];
            this.gender = _data["gender"];
            this.jobAgeRange = _data["jobAgeRange"];
            this.jobType = _data["jobType"];
            this.workPlaceType = _data["workPlaceType"];
            this.countryId = _data["countryId"];
            this.cityId = _data["cityId"];
            this.vacanciesNumber = _data["vacanciesNumber"];
            this.isSalaryAfterInterview = _data["isSalaryAfterInterview"];
            this.salary = _data["salary"];
            this.jobDescription = _data["jobDescription"];
            this.isShowWithCompany = _data["isShowWithCompany"];
            this.closeDate = _data["closeDate"] ? moment(_data["closeDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["skills"])) {
                this.skills = [] as any;
                for (let item of _data["skills"])
                    this.skills.push(CreateJobSkillDto.fromJS(item));
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages.push(CreateJobLanguageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateJobByCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJobByCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["industryId"] = this.industryId;
        data["jobPositionId"] = this.jobPositionId;
        data["educationLevel"] = this.educationLevel;
        data["positionLevel"] = this.positionLevel;
        data["gender"] = this.gender;
        data["jobAgeRange"] = this.jobAgeRange;
        data["jobType"] = this.jobType;
        data["workPlaceType"] = this.workPlaceType;
        data["countryId"] = this.countryId;
        data["cityId"] = this.cityId;
        data["vacanciesNumber"] = this.vacanciesNumber;
        data["isSalaryAfterInterview"] = this.isSalaryAfterInterview;
        data["salary"] = this.salary;
        data["jobDescription"] = this.jobDescription;
        data["isShowWithCompany"] = this.isShowWithCompany;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : <any>undefined;
        if (Array.isArray(this.skills)) {
            data["skills"] = [];
            for (let item of this.skills)
                data["skills"].push(item.toJSON());
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateJobByCompanyDto {
        const json = this.toJSON();
        let result = new CreateJobByCompanyDto();
        result.init(json);
        return result;
    }
}

export interface ICreateJobByCompanyDto {
    industryId: number | undefined;
    jobPositionId: number | undefined;
    educationLevel: EducationLevel;
    positionLevel: PositionLevel;
    gender: Gender;
    jobAgeRange: JobAgeRange;
    jobType: JobType;
    workPlaceType: WorkPlaceType;
    countryId: number | undefined;
    cityId: number | undefined;
    vacanciesNumber: number | undefined;
    isSalaryAfterInterview: boolean;
    salary: number | undefined;
    jobDescription: string | undefined;
    isShowWithCompany: boolean;
    closeDate: moment.Moment | undefined;
    skills: CreateJobSkillDto[] | undefined;
    languages: CreateJobLanguageDto[] | undefined;
}

export class CreateJobLanguageDto implements ICreateJobLanguageDto {
    name: string;
    flag: string | undefined;

    constructor(data?: ICreateJobLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.flag = _data["flag"];
        }
    }

    static fromJS(data: any): CreateJobLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJobLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["flag"] = this.flag;
        return data;
    }

    clone(): CreateJobLanguageDto {
        const json = this.toJSON();
        let result = new CreateJobLanguageDto();
        result.init(json);
        return result;
    }
}

export interface ICreateJobLanguageDto {
    name: string;
    flag: string | undefined;
}

export class CreateJobPositionDto implements ICreateJobPositionDto {
    name: string;
    showInHomePage: boolean;
    industryId: number | undefined;
    nameAr: string | undefined;

    constructor(data?: ICreateJobPositionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.showInHomePage = _data["showInHomePage"];
            this.industryId = _data["industryId"];
            this.nameAr = _data["nameAr"];
        }
    }

    static fromJS(data: any): CreateJobPositionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJobPositionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["showInHomePage"] = this.showInHomePage;
        data["industryId"] = this.industryId;
        data["nameAr"] = this.nameAr;
        return data;
    }

    clone(): CreateJobPositionDto {
        const json = this.toJSON();
        let result = new CreateJobPositionDto();
        result.init(json);
        return result;
    }
}

export interface ICreateJobPositionDto {
    name: string;
    showInHomePage: boolean;
    industryId: number | undefined;
    nameAr: string | undefined;
}

export class CreateJobSkillDto implements ICreateJobSkillDto {
    skillId: number;

    constructor(data?: ICreateJobSkillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skillId = _data["skillId"];
        }
    }

    static fromJS(data: any): CreateJobSkillDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJobSkillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skillId"] = this.skillId;
        return data;
    }

    clone(): CreateJobSkillDto {
        const json = this.toJSON();
        let result = new CreateJobSkillDto();
        result.init(json);
        return result;
    }
}

export interface ICreateJobSkillDto {
    skillId: number;
}

export class CreateListCompanyIndustryDto implements ICreateListCompanyIndustryDto {
    companyIndustries: CreateCompanyIndustryDto[] | undefined;

    constructor(data?: ICreateListCompanyIndustryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["companyIndustries"])) {
                this.companyIndustries = [] as any;
                for (let item of _data["companyIndustries"])
                    this.companyIndustries.push(CreateCompanyIndustryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateListCompanyIndustryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateListCompanyIndustryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.companyIndustries)) {
            data["companyIndustries"] = [];
            for (let item of this.companyIndustries)
                data["companyIndustries"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateListCompanyIndustryDto {
        const json = this.toJSON();
        let result = new CreateListCompanyIndustryDto();
        result.init(json);
        return result;
    }
}

export interface ICreateListCompanyIndustryDto {
    companyIndustries: CreateCompanyIndustryDto[] | undefined;
}

export class CreateListCompanySocialMediaDto implements ICreateListCompanySocialMediaDto {
    companySocialMedia: CreateCompanySocialMediaDto[] | undefined;

    constructor(data?: ICreateListCompanySocialMediaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["companySocialMedia"])) {
                this.companySocialMedia = [] as any;
                for (let item of _data["companySocialMedia"])
                    this.companySocialMedia.push(CreateCompanySocialMediaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateListCompanySocialMediaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateListCompanySocialMediaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.companySocialMedia)) {
            data["companySocialMedia"] = [];
            for (let item of this.companySocialMedia)
                data["companySocialMedia"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateListCompanySocialMediaDto {
        const json = this.toJSON();
        let result = new CreateListCompanySocialMediaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateListCompanySocialMediaDto {
    companySocialMedia: CreateCompanySocialMediaDto[] | undefined;
}

export class CreateListEmployeeCertificateDto implements ICreateListEmployeeCertificateDto {
    employeeCertificates: UpdateEmployeeCertificateDto[] | undefined;

    constructor(data?: ICreateListEmployeeCertificateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employeeCertificates"])) {
                this.employeeCertificates = [] as any;
                for (let item of _data["employeeCertificates"])
                    this.employeeCertificates.push(UpdateEmployeeCertificateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateListEmployeeCertificateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateListEmployeeCertificateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employeeCertificates)) {
            data["employeeCertificates"] = [];
            for (let item of this.employeeCertificates)
                data["employeeCertificates"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateListEmployeeCertificateDto {
        const json = this.toJSON();
        let result = new CreateListEmployeeCertificateDto();
        result.init(json);
        return result;
    }
}

export interface ICreateListEmployeeCertificateDto {
    employeeCertificates: UpdateEmployeeCertificateDto[] | undefined;
}

export class CreateListEmployeeExperienceDto implements ICreateListEmployeeExperienceDto {
    employeeExperiences: UpdateEmployeeExperienceDto[] | undefined;

    constructor(data?: ICreateListEmployeeExperienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employeeExperiences"])) {
                this.employeeExperiences = [] as any;
                for (let item of _data["employeeExperiences"])
                    this.employeeExperiences.push(UpdateEmployeeExperienceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateListEmployeeExperienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateListEmployeeExperienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employeeExperiences)) {
            data["employeeExperiences"] = [];
            for (let item of this.employeeExperiences)
                data["employeeExperiences"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateListEmployeeExperienceDto {
        const json = this.toJSON();
        let result = new CreateListEmployeeExperienceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateListEmployeeExperienceDto {
    employeeExperiences: UpdateEmployeeExperienceDto[] | undefined;
}

export class CreateListEmployeeLanguageDto implements ICreateListEmployeeLanguageDto {
    employeeLanguages: CreateEmployeeLanguageDto[] | undefined;

    constructor(data?: ICreateListEmployeeLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employeeLanguages"])) {
                this.employeeLanguages = [] as any;
                for (let item of _data["employeeLanguages"])
                    this.employeeLanguages.push(CreateEmployeeLanguageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateListEmployeeLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateListEmployeeLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employeeLanguages)) {
            data["employeeLanguages"] = [];
            for (let item of this.employeeLanguages)
                data["employeeLanguages"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateListEmployeeLanguageDto {
        const json = this.toJSON();
        let result = new CreateListEmployeeLanguageDto();
        result.init(json);
        return result;
    }
}

export interface ICreateListEmployeeLanguageDto {
    employeeLanguages: CreateEmployeeLanguageDto[] | undefined;
}

export class CreateListEmployeeSkillDto implements ICreateListEmployeeSkillDto {
    employeeSkills: CreateEmployeeSkillDto[] | undefined;

    constructor(data?: ICreateListEmployeeSkillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employeeSkills"])) {
                this.employeeSkills = [] as any;
                for (let item of _data["employeeSkills"])
                    this.employeeSkills.push(CreateEmployeeSkillDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateListEmployeeSkillDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateListEmployeeSkillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employeeSkills)) {
            data["employeeSkills"] = [];
            for (let item of this.employeeSkills)
                data["employeeSkills"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateListEmployeeSkillDto {
        const json = this.toJSON();
        let result = new CreateListEmployeeSkillDto();
        result.init(json);
        return result;
    }
}

export interface ICreateListEmployeeSkillDto {
    employeeSkills: CreateEmployeeSkillDto[] | undefined;
}

export class CreateListEmployeeSocialMediaDto implements ICreateListEmployeeSocialMediaDto {
    employeeSocialMedia: CreateEmployeeSocialMediaDto[] | undefined;

    constructor(data?: ICreateListEmployeeSocialMediaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employeeSocialMedia"])) {
                this.employeeSocialMedia = [] as any;
                for (let item of _data["employeeSocialMedia"])
                    this.employeeSocialMedia.push(CreateEmployeeSocialMediaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateListEmployeeSocialMediaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateListEmployeeSocialMediaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employeeSocialMedia)) {
            data["employeeSocialMedia"] = [];
            for (let item of this.employeeSocialMedia)
                data["employeeSocialMedia"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateListEmployeeSocialMediaDto {
        const json = this.toJSON();
        let result = new CreateListEmployeeSocialMediaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateListEmployeeSocialMediaDto {
    employeeSocialMedia: CreateEmployeeSocialMediaDto[] | undefined;
}

export class CreateListJobLanguageDto implements ICreateListJobLanguageDto {
    jobId: number;
    languages: CreateJobLanguageDto[];

    constructor(data?: ICreateListJobLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.languages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages.push(CreateJobLanguageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateListJobLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateListJobLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateListJobLanguageDto {
        const json = this.toJSON();
        let result = new CreateListJobLanguageDto();
        result.init(json);
        return result;
    }
}

export interface ICreateListJobLanguageDto {
    jobId: number;
    languages: CreateJobLanguageDto[];
}

export class CreateListJobSkillDto implements ICreateListJobSkillDto {
    jobId: number;
    skills: CreateJobSkillDto[];

    constructor(data?: ICreateListJobSkillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.skills = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            if (Array.isArray(_data["skills"])) {
                this.skills = [] as any;
                for (let item of _data["skills"])
                    this.skills.push(CreateJobSkillDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateListJobSkillDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateListJobSkillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        if (Array.isArray(this.skills)) {
            data["skills"] = [];
            for (let item of this.skills)
                data["skills"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateListJobSkillDto {
        const json = this.toJSON();
        let result = new CreateListJobSkillDto();
        result.init(json);
        return result;
    }
}

export interface ICreateListJobSkillDto {
    jobId: number;
    skills: CreateJobSkillDto[];
}

export class CreateMessageDto implements ICreateMessageDto {
    fullName: string;
    emailAddress: string | undefined;
    contentMessage: string;

    constructor(data?: ICreateMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.emailAddress = _data["emailAddress"];
            this.contentMessage = _data["contentMessage"];
        }
    }

    static fromJS(data: any): CreateMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["emailAddress"] = this.emailAddress;
        data["contentMessage"] = this.contentMessage;
        return data;
    }

    clone(): CreateMessageDto {
        const json = this.toJSON();
        let result = new CreateMessageDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMessageDto {
    fullName: string;
    emailAddress: string | undefined;
    contentMessage: string;
}

export class CreateNotificationDto implements ICreateNotificationDto {
    title: string;
    body: string;
    relatedToType: NotificationRelatedTo;
    receivers: SelectedReceiversForNotificationDto[] | undefined;

    constructor(data?: ICreateNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.body = _data["body"];
            this.relatedToType = _data["relatedToType"];
            if (Array.isArray(_data["receivers"])) {
                this.receivers = [] as any;
                for (let item of _data["receivers"])
                    this.receivers.push(SelectedReceiversForNotificationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["body"] = this.body;
        data["relatedToType"] = this.relatedToType;
        if (Array.isArray(this.receivers)) {
            data["receivers"] = [];
            for (let item of this.receivers)
                data["receivers"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateNotificationDto {
        const json = this.toJSON();
        let result = new CreateNotificationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateNotificationDto {
    title: string;
    body: string;
    relatedToType: NotificationRelatedTo;
    receivers: SelectedReceiversForNotificationDto[] | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class CreateSkillDto implements ICreateSkillDto {
    name: string;
    industryId: number | undefined;
    nameAr: string | undefined;

    constructor(data?: ICreateSkillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.industryId = _data["industryId"];
            this.nameAr = _data["nameAr"];
        }
    }

    static fromJS(data: any): CreateSkillDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSkillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["industryId"] = this.industryId;
        data["nameAr"] = this.nameAr;
        return data;
    }

    clone(): CreateSkillDto {
        const json = this.toJSON();
        let result = new CreateSkillDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSkillDto {
    name: string;
    industryId: number | undefined;
    nameAr: string | undefined;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;
}

export class CreateUserDto implements ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["password"] = this.password;
        return data;
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string;
}

export enum EducationCertificateType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export enum EducationLevel {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class EmployeeAppliedJobDto implements IEmployeeAppliedJobDto {
    id: number;
    firstName: string | undefined;
    lastName: string | undefined;
    image: string | undefined;
    birthDate: moment.Moment | undefined;
    gender: Gender;
    maritalStatus: MaritalStatus;
    isPurchasedCv: boolean;

    constructor(data?: IEmployeeAppliedJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.image = _data["image"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.maritalStatus = _data["maritalStatus"];
            this.isPurchasedCv = _data["isPurchasedCv"];
        }
    }

    static fromJS(data: any): EmployeeAppliedJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeAppliedJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["image"] = this.image;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["maritalStatus"] = this.maritalStatus;
        data["isPurchasedCv"] = this.isPurchasedCv;
        return data;
    }

    clone(): EmployeeAppliedJobDto {
        const json = this.toJSON();
        let result = new EmployeeAppliedJobDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeAppliedJobDto {
    id: number;
    firstName: string | undefined;
    lastName: string | undefined;
    image: string | undefined;
    birthDate: moment.Moment | undefined;
    gender: Gender;
    maritalStatus: MaritalStatus;
    isPurchasedCv: boolean;
}

export class EmployeeAppliedJobDtoPagedResultDto implements IEmployeeAppliedJobDtoPagedResultDto {
    items: EmployeeAppliedJobDto[] | undefined;
    totalCount: number;

    constructor(data?: IEmployeeAppliedJobDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EmployeeAppliedJobDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): EmployeeAppliedJobDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeAppliedJobDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): EmployeeAppliedJobDtoPagedResultDto {
        const json = this.toJSON();
        let result = new EmployeeAppliedJobDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeAppliedJobDtoPagedResultDto {
    items: EmployeeAppliedJobDto[] | undefined;
    totalCount: number;
}

export class EmployeeAttachmentDto implements IEmployeeAttachmentDto {
    id: number;
    attachementName: string | undefined;
    attachementUrl: string | undefined;
    attachementLength: number | undefined;
    attachementContentType: string | undefined;
    attachementUnitSize: string | undefined;
    creationTime: moment.Moment;

    constructor(data?: IEmployeeAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attachementName = _data["attachementName"];
            this.attachementUrl = _data["attachementUrl"];
            this.attachementLength = _data["attachementLength"];
            this.attachementContentType = _data["attachementContentType"];
            this.attachementUnitSize = _data["attachementUnitSize"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attachementName"] = this.attachementName;
        data["attachementUrl"] = this.attachementUrl;
        data["attachementLength"] = this.attachementLength;
        data["attachementContentType"] = this.attachementContentType;
        data["attachementUnitSize"] = this.attachementUnitSize;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): EmployeeAttachmentDto {
        const json = this.toJSON();
        let result = new EmployeeAttachmentDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeAttachmentDto {
    id: number;
    attachementName: string | undefined;
    attachementUrl: string | undefined;
    attachementLength: number | undefined;
    attachementContentType: string | undefined;
    attachementUnitSize: string | undefined;
    creationTime: moment.Moment;
}

export class EmployeeAttachmentDtoPagedResultDto implements IEmployeeAttachmentDtoPagedResultDto {
    items: EmployeeAttachmentDto[] | undefined;
    totalCount: number;

    constructor(data?: IEmployeeAttachmentDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EmployeeAttachmentDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): EmployeeAttachmentDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeAttachmentDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): EmployeeAttachmentDtoPagedResultDto {
        const json = this.toJSON();
        let result = new EmployeeAttachmentDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeAttachmentDtoPagedResultDto {
    items: EmployeeAttachmentDto[] | undefined;
    totalCount: number;
}

export class EmployeeByAdminDto implements IEmployeeByAdminDto {
    id: number;
    firstName: string | undefined;
    lastName: string | undefined;
    gender: Gender;
    accountEmailAddress: string | undefined;
    phone: string | undefined;
    isDeletedAccount: boolean;
    isComplatedProfile: boolean;
    emailConfirmationCode: string | undefined;

    constructor(data?: IEmployeeByAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gender = _data["gender"];
            this.accountEmailAddress = _data["accountEmailAddress"];
            this.phone = _data["phone"];
            this.isDeletedAccount = _data["isDeletedAccount"];
            this.isComplatedProfile = _data["isComplatedProfile"];
            this.emailConfirmationCode = _data["emailConfirmationCode"];
        }
    }

    static fromJS(data: any): EmployeeByAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeByAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gender"] = this.gender;
        data["accountEmailAddress"] = this.accountEmailAddress;
        data["phone"] = this.phone;
        data["isDeletedAccount"] = this.isDeletedAccount;
        data["isComplatedProfile"] = this.isComplatedProfile;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        return data;
    }

    clone(): EmployeeByAdminDto {
        const json = this.toJSON();
        let result = new EmployeeByAdminDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeByAdminDto {
    id: number;
    firstName: string | undefined;
    lastName: string | undefined;
    gender: Gender;
    accountEmailAddress: string | undefined;
    phone: string | undefined;
    isDeletedAccount: boolean;
    isComplatedProfile: boolean;
    emailConfirmationCode: string | undefined;
}

export class EmployeeByAdminDtoPagedResultDto implements IEmployeeByAdminDtoPagedResultDto {
    items: EmployeeByAdminDto[] | undefined;
    totalCount: number;

    constructor(data?: IEmployeeByAdminDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EmployeeByAdminDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): EmployeeByAdminDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeByAdminDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): EmployeeByAdminDtoPagedResultDto {
        const json = this.toJSON();
        let result = new EmployeeByAdminDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeByAdminDtoPagedResultDto {
    items: EmployeeByAdminDto[] | undefined;
    totalCount: number;
}

export class EmployeeCertificateDto implements IEmployeeCertificateDto {
    id: number;
    certificateName: string | undefined;
    educationCertificateType: EducationCertificateType;
    college: string | undefined;
    successDegree: number | undefined;
    from: moment.Moment | undefined;
    to: moment.Moment | undefined;
    shortDescription: string | undefined;

    constructor(data?: IEmployeeCertificateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.certificateName = _data["certificateName"];
            this.educationCertificateType = _data["educationCertificateType"];
            this.college = _data["college"];
            this.successDegree = _data["successDegree"];
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
            this.shortDescription = _data["shortDescription"];
        }
    }

    static fromJS(data: any): EmployeeCertificateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeCertificateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["certificateName"] = this.certificateName;
        data["educationCertificateType"] = this.educationCertificateType;
        data["college"] = this.college;
        data["successDegree"] = this.successDegree;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["shortDescription"] = this.shortDescription;
        return data;
    }

    clone(): EmployeeCertificateDto {
        const json = this.toJSON();
        let result = new EmployeeCertificateDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeCertificateDto {
    id: number;
    certificateName: string | undefined;
    educationCertificateType: EducationCertificateType;
    college: string | undefined;
    successDegree: number | undefined;
    from: moment.Moment | undefined;
    to: moment.Moment | undefined;
    shortDescription: string | undefined;
}

export class EmployeeCertificateForCompletedCvDto implements IEmployeeCertificateForCompletedCvDto {
    certificateName: string | undefined;
    educationCertificateType: EducationCertificateType;
    college: string | undefined;
    successDegree: number | undefined;
    from: moment.Moment | undefined;
    to: moment.Moment | undefined;
    shortDescription: string | undefined;

    constructor(data?: IEmployeeCertificateForCompletedCvDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.certificateName = _data["certificateName"];
            this.educationCertificateType = _data["educationCertificateType"];
            this.college = _data["college"];
            this.successDegree = _data["successDegree"];
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
            this.shortDescription = _data["shortDescription"];
        }
    }

    static fromJS(data: any): EmployeeCertificateForCompletedCvDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeCertificateForCompletedCvDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["certificateName"] = this.certificateName;
        data["educationCertificateType"] = this.educationCertificateType;
        data["college"] = this.college;
        data["successDegree"] = this.successDegree;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["shortDescription"] = this.shortDescription;
        return data;
    }

    clone(): EmployeeCertificateForCompletedCvDto {
        const json = this.toJSON();
        let result = new EmployeeCertificateForCompletedCvDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeCertificateForCompletedCvDto {
    certificateName: string | undefined;
    educationCertificateType: EducationCertificateType;
    college: string | undefined;
    successDegree: number | undefined;
    from: moment.Moment | undefined;
    to: moment.Moment | undefined;
    shortDescription: string | undefined;
}

export class EmployeeCompletedCVDto implements IEmployeeCompletedCVDto {
    firstName: string | undefined;
    lastName: string | undefined;
    nationality: string | undefined;
    birthDate: moment.Moment | undefined;
    country: string | undefined;
    city: string | undefined;
    maritalStatus: MaritalStatus;
    militaryStatus: MilitaryStatus;
    healthStatus: HealthStatus;
    employmentStatus: EmploymentStatus;
    gender: Gender;
    employeeLanguages: CreateEmployeeLanguageDto[] | undefined;
    employeeSkills: CreateEmployeeSkillDto[] | undefined;
    employeeExperiences: EmployeeExperienceForCompletedCvDto[] | undefined;
    employeeCertificates: EmployeeCertificateForCompletedCvDto[] | undefined;

    constructor(data?: IEmployeeCompletedCVDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.nationality = _data["nationality"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.country = _data["country"];
            this.city = _data["city"];
            this.maritalStatus = _data["maritalStatus"];
            this.militaryStatus = _data["militaryStatus"];
            this.healthStatus = _data["healthStatus"];
            this.employmentStatus = _data["employmentStatus"];
            this.gender = _data["gender"];
            if (Array.isArray(_data["employeeLanguages"])) {
                this.employeeLanguages = [] as any;
                for (let item of _data["employeeLanguages"])
                    this.employeeLanguages.push(CreateEmployeeLanguageDto.fromJS(item));
            }
            if (Array.isArray(_data["employeeSkills"])) {
                this.employeeSkills = [] as any;
                for (let item of _data["employeeSkills"])
                    this.employeeSkills.push(CreateEmployeeSkillDto.fromJS(item));
            }
            if (Array.isArray(_data["employeeExperiences"])) {
                this.employeeExperiences = [] as any;
                for (let item of _data["employeeExperiences"])
                    this.employeeExperiences.push(EmployeeExperienceForCompletedCvDto.fromJS(item));
            }
            if (Array.isArray(_data["employeeCertificates"])) {
                this.employeeCertificates = [] as any;
                for (let item of _data["employeeCertificates"])
                    this.employeeCertificates.push(EmployeeCertificateForCompletedCvDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeCompletedCVDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeCompletedCVDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["nationality"] = this.nationality;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["country"] = this.country;
        data["city"] = this.city;
        data["maritalStatus"] = this.maritalStatus;
        data["militaryStatus"] = this.militaryStatus;
        data["healthStatus"] = this.healthStatus;
        data["employmentStatus"] = this.employmentStatus;
        data["gender"] = this.gender;
        if (Array.isArray(this.employeeLanguages)) {
            data["employeeLanguages"] = [];
            for (let item of this.employeeLanguages)
                data["employeeLanguages"].push(item.toJSON());
        }
        if (Array.isArray(this.employeeSkills)) {
            data["employeeSkills"] = [];
            for (let item of this.employeeSkills)
                data["employeeSkills"].push(item.toJSON());
        }
        if (Array.isArray(this.employeeExperiences)) {
            data["employeeExperiences"] = [];
            for (let item of this.employeeExperiences)
                data["employeeExperiences"].push(item.toJSON());
        }
        if (Array.isArray(this.employeeCertificates)) {
            data["employeeCertificates"] = [];
            for (let item of this.employeeCertificates)
                data["employeeCertificates"].push(item.toJSON());
        }
        return data;
    }

    clone(): EmployeeCompletedCVDto {
        const json = this.toJSON();
        let result = new EmployeeCompletedCVDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeCompletedCVDto {
    firstName: string | undefined;
    lastName: string | undefined;
    nationality: string | undefined;
    birthDate: moment.Moment | undefined;
    country: string | undefined;
    city: string | undefined;
    maritalStatus: MaritalStatus;
    militaryStatus: MilitaryStatus;
    healthStatus: HealthStatus;
    employmentStatus: EmploymentStatus;
    gender: Gender;
    employeeLanguages: CreateEmployeeLanguageDto[] | undefined;
    employeeSkills: CreateEmployeeSkillDto[] | undefined;
    employeeExperiences: EmployeeExperienceForCompletedCvDto[] | undefined;
    employeeCertificates: EmployeeCertificateForCompletedCvDto[] | undefined;
}

export class EmployeeDetailsByAdminDto implements IEmployeeDetailsByAdminDto {
    firstName: string | undefined;
    lastName: string | undefined;
    accountEmailAddress: string | undefined;
    image: string | undefined;
    birthDate: moment.Moment | undefined;
    nationality: string | undefined;
    country: string | undefined;
    city: string | undefined;
    healthStatus: HealthStatus;
    salary: number | undefined;
    employmentStatus: EmploymentStatus;
    gender: Gender;
    phone: string | undefined;
    isComplatedProfile: boolean;
    maritalStatus: MaritalStatus;
    militaryStatus: MilitaryStatus;
    isDeletedAccount: boolean;

    constructor(data?: IEmployeeDetailsByAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.accountEmailAddress = _data["accountEmailAddress"];
            this.image = _data["image"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.nationality = _data["nationality"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.healthStatus = _data["healthStatus"];
            this.salary = _data["salary"];
            this.employmentStatus = _data["employmentStatus"];
            this.gender = _data["gender"];
            this.phone = _data["phone"];
            this.isComplatedProfile = _data["isComplatedProfile"];
            this.maritalStatus = _data["maritalStatus"];
            this.militaryStatus = _data["militaryStatus"];
            this.isDeletedAccount = _data["isDeletedAccount"];
        }
    }

    static fromJS(data: any): EmployeeDetailsByAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDetailsByAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["accountEmailAddress"] = this.accountEmailAddress;
        data["image"] = this.image;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["nationality"] = this.nationality;
        data["country"] = this.country;
        data["city"] = this.city;
        data["healthStatus"] = this.healthStatus;
        data["salary"] = this.salary;
        data["employmentStatus"] = this.employmentStatus;
        data["gender"] = this.gender;
        data["phone"] = this.phone;
        data["isComplatedProfile"] = this.isComplatedProfile;
        data["maritalStatus"] = this.maritalStatus;
        data["militaryStatus"] = this.militaryStatus;
        data["isDeletedAccount"] = this.isDeletedAccount;
        return data;
    }

    clone(): EmployeeDetailsByAdminDto {
        const json = this.toJSON();
        let result = new EmployeeDetailsByAdminDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeDetailsByAdminDto {
    firstName: string | undefined;
    lastName: string | undefined;
    accountEmailAddress: string | undefined;
    image: string | undefined;
    birthDate: moment.Moment | undefined;
    nationality: string | undefined;
    country: string | undefined;
    city: string | undefined;
    healthStatus: HealthStatus;
    salary: number | undefined;
    employmentStatus: EmploymentStatus;
    gender: Gender;
    phone: string | undefined;
    isComplatedProfile: boolean;
    maritalStatus: MaritalStatus;
    militaryStatus: MilitaryStatus;
    isDeletedAccount: boolean;
}

export class EmployeeDetailsDto implements IEmployeeDetailsDto {
    image: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    country: string | undefined;
    city: string | undefined;
    employmentStatus: EmploymentStatus;
    nationality: string | undefined;
    birthDate: moment.Moment | undefined;
    gender: Gender;
    maritalStatus: MaritalStatus;
    militaryStatus: MilitaryStatus;
    healthStatus: HealthStatus;
    salary: number | undefined;
    email: string | undefined;
    phone: string | undefined;
    employeeSocialMedia: EmployeeSocialMediaDto[] | undefined;

    constructor(data?: IEmployeeDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.image = _data["image"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.employmentStatus = _data["employmentStatus"];
            this.nationality = _data["nationality"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.maritalStatus = _data["maritalStatus"];
            this.militaryStatus = _data["militaryStatus"];
            this.healthStatus = _data["healthStatus"];
            this.salary = _data["salary"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            if (Array.isArray(_data["employeeSocialMedia"])) {
                this.employeeSocialMedia = [] as any;
                for (let item of _data["employeeSocialMedia"])
                    this.employeeSocialMedia.push(EmployeeSocialMediaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["country"] = this.country;
        data["city"] = this.city;
        data["employmentStatus"] = this.employmentStatus;
        data["nationality"] = this.nationality;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["maritalStatus"] = this.maritalStatus;
        data["militaryStatus"] = this.militaryStatus;
        data["healthStatus"] = this.healthStatus;
        data["salary"] = this.salary;
        data["email"] = this.email;
        data["phone"] = this.phone;
        if (Array.isArray(this.employeeSocialMedia)) {
            data["employeeSocialMedia"] = [];
            for (let item of this.employeeSocialMedia)
                data["employeeSocialMedia"].push(item.toJSON());
        }
        return data;
    }

    clone(): EmployeeDetailsDto {
        const json = this.toJSON();
        let result = new EmployeeDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeDetailsDto {
    image: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    country: string | undefined;
    city: string | undefined;
    employmentStatus: EmploymentStatus;
    nationality: string | undefined;
    birthDate: moment.Moment | undefined;
    gender: Gender;
    maritalStatus: MaritalStatus;
    militaryStatus: MilitaryStatus;
    healthStatus: HealthStatus;
    salary: number | undefined;
    email: string | undefined;
    phone: string | undefined;
    employeeSocialMedia: EmployeeSocialMediaDto[] | undefined;
}

export class EmployeeDetailsForCompanyDto implements IEmployeeDetailsForCompanyDto {
    image: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    country: string | undefined;
    city: string | undefined;
    employmentStatus: EmploymentStatus;
    nationality: string | undefined;
    birthDate: moment.Moment | undefined;
    gender: Gender;
    maritalStatus: MaritalStatus;
    militaryStatus: MilitaryStatus;
    healthStatus: HealthStatus;
    salary: number | undefined;
    email: string | undefined;
    phone: string | undefined;
    employeeSocialMedia: EmployeeSocialMediaDto[] | undefined;
    isPurchasedByUser: boolean;

    constructor(data?: IEmployeeDetailsForCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.image = _data["image"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.employmentStatus = _data["employmentStatus"];
            this.nationality = _data["nationality"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.maritalStatus = _data["maritalStatus"];
            this.militaryStatus = _data["militaryStatus"];
            this.healthStatus = _data["healthStatus"];
            this.salary = _data["salary"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            if (Array.isArray(_data["employeeSocialMedia"])) {
                this.employeeSocialMedia = [] as any;
                for (let item of _data["employeeSocialMedia"])
                    this.employeeSocialMedia.push(EmployeeSocialMediaDto.fromJS(item));
            }
            this.isPurchasedByUser = _data["isPurchasedByUser"];
        }
    }

    static fromJS(data: any): EmployeeDetailsForCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDetailsForCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["country"] = this.country;
        data["city"] = this.city;
        data["employmentStatus"] = this.employmentStatus;
        data["nationality"] = this.nationality;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["maritalStatus"] = this.maritalStatus;
        data["militaryStatus"] = this.militaryStatus;
        data["healthStatus"] = this.healthStatus;
        data["salary"] = this.salary;
        data["email"] = this.email;
        data["phone"] = this.phone;
        if (Array.isArray(this.employeeSocialMedia)) {
            data["employeeSocialMedia"] = [];
            for (let item of this.employeeSocialMedia)
                data["employeeSocialMedia"].push(item.toJSON());
        }
        data["isPurchasedByUser"] = this.isPurchasedByUser;
        return data;
    }

    clone(): EmployeeDetailsForCompanyDto {
        const json = this.toJSON();
        let result = new EmployeeDetailsForCompanyDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeDetailsForCompanyDto {
    image: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    country: string | undefined;
    city: string | undefined;
    employmentStatus: EmploymentStatus;
    nationality: string | undefined;
    birthDate: moment.Moment | undefined;
    gender: Gender;
    maritalStatus: MaritalStatus;
    militaryStatus: MilitaryStatus;
    healthStatus: HealthStatus;
    salary: number | undefined;
    email: string | undefined;
    phone: string | undefined;
    employeeSocialMedia: EmployeeSocialMediaDto[] | undefined;
    isPurchasedByUser: boolean;
}

export class EmployeeExperienceDto implements IEmployeeExperienceDto {
    id: number;
    companyName: string | undefined;
    country: string | undefined;
    from: moment.Moment | undefined;
    to: moment.Moment | undefined;
    shortDescription: string | undefined;
    industryName: string | undefined;
    jobPosition: string | undefined;
    industryId: number;
    jobPositionId: number | undefined;

    constructor(data?: IEmployeeExperienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyName = _data["companyName"];
            this.country = _data["country"];
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
            this.shortDescription = _data["shortDescription"];
            this.industryName = _data["industryName"];
            this.jobPosition = _data["jobPosition"];
            this.industryId = _data["industryId"];
            this.jobPositionId = _data["jobPositionId"];
        }
    }

    static fromJS(data: any): EmployeeExperienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeExperienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyName"] = this.companyName;
        data["country"] = this.country;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["shortDescription"] = this.shortDescription;
        data["industryName"] = this.industryName;
        data["jobPosition"] = this.jobPosition;
        data["industryId"] = this.industryId;
        data["jobPositionId"] = this.jobPositionId;
        return data;
    }

    clone(): EmployeeExperienceDto {
        const json = this.toJSON();
        let result = new EmployeeExperienceDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeExperienceDto {
    id: number;
    companyName: string | undefined;
    country: string | undefined;
    from: moment.Moment | undefined;
    to: moment.Moment | undefined;
    shortDescription: string | undefined;
    industryName: string | undefined;
    jobPosition: string | undefined;
    industryId: number;
    jobPositionId: number | undefined;
}

export class EmployeeExperienceDtoPagedResultDto implements IEmployeeExperienceDtoPagedResultDto {
    items: EmployeeExperienceDto[] | undefined;
    totalCount: number;

    constructor(data?: IEmployeeExperienceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EmployeeExperienceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): EmployeeExperienceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeExperienceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): EmployeeExperienceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new EmployeeExperienceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeExperienceDtoPagedResultDto {
    items: EmployeeExperienceDto[] | undefined;
    totalCount: number;
}

export class EmployeeExperienceForCompletedCvDto implements IEmployeeExperienceForCompletedCvDto {
    industryId: number | undefined;
    jobPositionId: number | undefined;
    otherPositionName: string | undefined;
    companyName: string | undefined;
    country: string | undefined;
    from: moment.Moment | undefined;
    to: moment.Moment | undefined;
    shortDescription: string | undefined;

    constructor(data?: IEmployeeExperienceForCompletedCvDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.industryId = _data["industryId"];
            this.jobPositionId = _data["jobPositionId"];
            this.otherPositionName = _data["otherPositionName"];
            this.companyName = _data["companyName"];
            this.country = _data["country"];
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
            this.shortDescription = _data["shortDescription"];
        }
    }

    static fromJS(data: any): EmployeeExperienceForCompletedCvDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeExperienceForCompletedCvDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["industryId"] = this.industryId;
        data["jobPositionId"] = this.jobPositionId;
        data["otherPositionName"] = this.otherPositionName;
        data["companyName"] = this.companyName;
        data["country"] = this.country;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["shortDescription"] = this.shortDescription;
        return data;
    }

    clone(): EmployeeExperienceForCompletedCvDto {
        const json = this.toJSON();
        let result = new EmployeeExperienceForCompletedCvDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeExperienceForCompletedCvDto {
    industryId: number | undefined;
    jobPositionId: number | undefined;
    otherPositionName: string | undefined;
    companyName: string | undefined;
    country: string | undefined;
    from: moment.Moment | undefined;
    to: moment.Moment | undefined;
    shortDescription: string | undefined;
}

export class EmployeeExperienceForEmployeeProfileDto implements IEmployeeExperienceForEmployeeProfileDto {
    companyName: string | undefined;
    country: string | undefined;
    from: moment.Moment | undefined;
    to: moment.Moment | undefined;
    shortDescription: string | undefined;
    industryName: string | undefined;
    jobPosition: string | undefined;

    constructor(data?: IEmployeeExperienceForEmployeeProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.country = _data["country"];
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
            this.shortDescription = _data["shortDescription"];
            this.industryName = _data["industryName"];
            this.jobPosition = _data["jobPosition"];
        }
    }

    static fromJS(data: any): EmployeeExperienceForEmployeeProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeExperienceForEmployeeProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["country"] = this.country;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["shortDescription"] = this.shortDescription;
        data["industryName"] = this.industryName;
        data["jobPosition"] = this.jobPosition;
        return data;
    }

    clone(): EmployeeExperienceForEmployeeProfileDto {
        const json = this.toJSON();
        let result = new EmployeeExperienceForEmployeeProfileDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeExperienceForEmployeeProfileDto {
    companyName: string | undefined;
    country: string | undefined;
    from: moment.Moment | undefined;
    to: moment.Moment | undefined;
    shortDescription: string | undefined;
    industryName: string | undefined;
    jobPosition: string | undefined;
}

export class EmployeeLanguageDto implements IEmployeeLanguageDto {
    id: number;
    name: string | undefined;
    flag: string | undefined;

    constructor(data?: IEmployeeLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.flag = _data["flag"];
        }
    }

    static fromJS(data: any): EmployeeLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["flag"] = this.flag;
        return data;
    }

    clone(): EmployeeLanguageDto {
        const json = this.toJSON();
        let result = new EmployeeLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeLanguageDto {
    id: number;
    name: string | undefined;
    flag: string | undefined;
}

export class EmployeeLanguageForEmployeeProfileDto implements IEmployeeLanguageForEmployeeProfileDto {
    name: string | undefined;
    flag: string | undefined;

    constructor(data?: IEmployeeLanguageForEmployeeProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.flag = _data["flag"];
        }
    }

    static fromJS(data: any): EmployeeLanguageForEmployeeProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeLanguageForEmployeeProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["flag"] = this.flag;
        return data;
    }

    clone(): EmployeeLanguageForEmployeeProfileDto {
        const json = this.toJSON();
        let result = new EmployeeLanguageForEmployeeProfileDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeLanguageForEmployeeProfileDto {
    name: string | undefined;
    flag: string | undefined;
}

export class EmployeeSavedJobDto implements IEmployeeSavedJobDto {
    id: number;
    jobPositionName: string | undefined;
    creationTime: moment.Moment;
    companyId: number;
    countryName: string | undefined;
    cityName: string | undefined;
    companyName: string | undefined;
    companyImage: string | undefined;
    status: JobStatus;

    constructor(data?: IEmployeeSavedJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jobPositionName = _data["jobPositionName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.companyId = _data["companyId"];
            this.countryName = _data["countryName"];
            this.cityName = _data["cityName"];
            this.companyName = _data["companyName"];
            this.companyImage = _data["companyImage"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): EmployeeSavedJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeSavedJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jobPositionName"] = this.jobPositionName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["companyId"] = this.companyId;
        data["countryName"] = this.countryName;
        data["cityName"] = this.cityName;
        data["companyName"] = this.companyName;
        data["companyImage"] = this.companyImage;
        data["status"] = this.status;
        return data;
    }

    clone(): EmployeeSavedJobDto {
        const json = this.toJSON();
        let result = new EmployeeSavedJobDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeSavedJobDto {
    id: number;
    jobPositionName: string | undefined;
    creationTime: moment.Moment;
    companyId: number;
    countryName: string | undefined;
    cityName: string | undefined;
    companyName: string | undefined;
    companyImage: string | undefined;
    status: JobStatus;
}

export class EmployeeSavedJobDtoPagedResultDto implements IEmployeeSavedJobDtoPagedResultDto {
    items: EmployeeSavedJobDto[] | undefined;
    totalCount: number;

    constructor(data?: IEmployeeSavedJobDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EmployeeSavedJobDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): EmployeeSavedJobDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeSavedJobDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): EmployeeSavedJobDtoPagedResultDto {
        const json = this.toJSON();
        let result = new EmployeeSavedJobDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeSavedJobDtoPagedResultDto {
    items: EmployeeSavedJobDto[] | undefined;
    totalCount: number;
}

export class EmployeeSkillDto implements IEmployeeSkillDto {
    id: number;
    skillId: number | undefined;
    name: string | undefined;

    constructor(data?: IEmployeeSkillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skillId = _data["skillId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EmployeeSkillDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeSkillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skillId"] = this.skillId;
        data["name"] = this.name;
        return data;
    }

    clone(): EmployeeSkillDto {
        const json = this.toJSON();
        let result = new EmployeeSkillDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeSkillDto {
    id: number;
    skillId: number | undefined;
    name: string | undefined;
}

export class EmployeeSkillForEmployeeProfileDto implements IEmployeeSkillForEmployeeProfileDto {
    name: string | undefined;

    constructor(data?: IEmployeeSkillForEmployeeProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EmployeeSkillForEmployeeProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeSkillForEmployeeProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }

    clone(): EmployeeSkillForEmployeeProfileDto {
        const json = this.toJSON();
        let result = new EmployeeSkillForEmployeeProfileDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeSkillForEmployeeProfileDto {
    name: string | undefined;
}

export class EmployeeSocialMediaDto implements IEmployeeSocialMediaDto {
    id: number;
    link: string | undefined;
    icon: string | undefined;
    name: string | undefined;

    constructor(data?: IEmployeeSocialMediaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.link = _data["link"];
            this.icon = _data["icon"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EmployeeSocialMediaDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeSocialMediaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["link"] = this.link;
        data["icon"] = this.icon;
        data["name"] = this.name;
        return data;
    }

    clone(): EmployeeSocialMediaDto {
        const json = this.toJSON();
        let result = new EmployeeSocialMediaDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeSocialMediaDto {
    id: number;
    link: string | undefined;
    icon: string | undefined;
    name: string | undefined;
}

export class EmployeeSocialMediaDtoPagedResultDto implements IEmployeeSocialMediaDtoPagedResultDto {
    items: EmployeeSocialMediaDto[] | undefined;
    totalCount: number;

    constructor(data?: IEmployeeSocialMediaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EmployeeSocialMediaDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): EmployeeSocialMediaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeSocialMediaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): EmployeeSocialMediaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new EmployeeSocialMediaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeSocialMediaDtoPagedResultDto {
    items: EmployeeSocialMediaDto[] | undefined;
    totalCount: number;
}

export class EmployeeUserAccountDto implements IEmployeeUserAccountDto {
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: IEmployeeUserAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeUserAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeUserAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): EmployeeUserAccountDto {
        const json = this.toJSON();
        let result = new EmployeeUserAccountDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeUserAccountDto {
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    lastModificationTime: moment.Moment | undefined;
}

export enum EmploymentStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class FlatPermissionDto implements IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export enum Gender {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class GetAboutUsForUpdateDto implements IGetAboutUsForUpdateDto {
    id: number;
    primaryTitle: string | undefined;
    primaryTitleAr: string | undefined;
    secondaryTitle: string | undefined;
    secondaryTitleAr: string | undefined;
    description: string | undefined;
    descriptionAr: string | undefined;
    image: string | undefined;

    constructor(data?: IGetAboutUsForUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.primaryTitle = _data["primaryTitle"];
            this.primaryTitleAr = _data["primaryTitleAr"];
            this.secondaryTitle = _data["secondaryTitle"];
            this.secondaryTitleAr = _data["secondaryTitleAr"];
            this.description = _data["description"];
            this.descriptionAr = _data["descriptionAr"];
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): GetAboutUsForUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAboutUsForUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["primaryTitle"] = this.primaryTitle;
        data["primaryTitleAr"] = this.primaryTitleAr;
        data["secondaryTitle"] = this.secondaryTitle;
        data["secondaryTitleAr"] = this.secondaryTitleAr;
        data["description"] = this.description;
        data["descriptionAr"] = this.descriptionAr;
        data["image"] = this.image;
        return data;
    }

    clone(): GetAboutUsForUpdateDto {
        const json = this.toJSON();
        let result = new GetAboutUsForUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IGetAboutUsForUpdateDto {
    id: number;
    primaryTitle: string | undefined;
    primaryTitleAr: string | undefined;
    secondaryTitle: string | undefined;
    secondaryTitleAr: string | undefined;
    description: string | undefined;
    descriptionAr: string | undefined;
    image: string | undefined;
}

export class GetContactInfoForUpdateDto implements IGetContactInfoForUpdateDto {
    id: number;
    content: string | undefined;
    icon: string | undefined;
    type: ContactInfoType;

    constructor(data?: IGetContactInfoForUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
            this.icon = _data["icon"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): GetContactInfoForUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetContactInfoForUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        data["icon"] = this.icon;
        data["type"] = this.type;
        return data;
    }

    clone(): GetContactInfoForUpdateDto {
        const json = this.toJSON();
        let result = new GetContactInfoForUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IGetContactInfoForUpdateDto {
    id: number;
    content: string | undefined;
    icon: string | undefined;
    type: ContactInfoType;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
}

export class GetJobForUpdateByCompany implements IGetJobForUpdateByCompany {
    id: number;
    industryId: number | undefined;
    jobPositionId: number | undefined;
    educationLevel: EducationLevel;
    positionLevel: PositionLevel;
    gender: Gender;
    jobAgeRange: JobAgeRange;
    jobType: JobType;
    workPlaceType: WorkPlaceType;
    countryId: number | undefined;
    cityId: number | undefined;
    vacanciesNumber: number | undefined;
    isSalaryAfterInterview: boolean;
    salary: number | undefined;
    jobDescription: string | undefined;
    isShowWithCompany: boolean;
    closeDate: moment.Moment | undefined;

    constructor(data?: IGetJobForUpdateByCompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.industryId = _data["industryId"];
            this.jobPositionId = _data["jobPositionId"];
            this.educationLevel = _data["educationLevel"];
            this.positionLevel = _data["positionLevel"];
            this.gender = _data["gender"];
            this.jobAgeRange = _data["jobAgeRange"];
            this.jobType = _data["jobType"];
            this.workPlaceType = _data["workPlaceType"];
            this.countryId = _data["countryId"];
            this.cityId = _data["cityId"];
            this.vacanciesNumber = _data["vacanciesNumber"];
            this.isSalaryAfterInterview = _data["isSalaryAfterInterview"];
            this.salary = _data["salary"];
            this.jobDescription = _data["jobDescription"];
            this.isShowWithCompany = _data["isShowWithCompany"];
            this.closeDate = _data["closeDate"] ? moment(_data["closeDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetJobForUpdateByCompany {
        data = typeof data === 'object' ? data : {};
        let result = new GetJobForUpdateByCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["industryId"] = this.industryId;
        data["jobPositionId"] = this.jobPositionId;
        data["educationLevel"] = this.educationLevel;
        data["positionLevel"] = this.positionLevel;
        data["gender"] = this.gender;
        data["jobAgeRange"] = this.jobAgeRange;
        data["jobType"] = this.jobType;
        data["workPlaceType"] = this.workPlaceType;
        data["countryId"] = this.countryId;
        data["cityId"] = this.cityId;
        data["vacanciesNumber"] = this.vacanciesNumber;
        data["isSalaryAfterInterview"] = this.isSalaryAfterInterview;
        data["salary"] = this.salary;
        data["jobDescription"] = this.jobDescription;
        data["isShowWithCompany"] = this.isShowWithCompany;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): GetJobForUpdateByCompany {
        const json = this.toJSON();
        let result = new GetJobForUpdateByCompany();
        result.init(json);
        return result;
    }
}

export interface IGetJobForUpdateByCompany {
    id: number;
    industryId: number | undefined;
    jobPositionId: number | undefined;
    educationLevel: EducationLevel;
    positionLevel: PositionLevel;
    gender: Gender;
    jobAgeRange: JobAgeRange;
    jobType: JobType;
    workPlaceType: WorkPlaceType;
    countryId: number | undefined;
    cityId: number | undefined;
    vacanciesNumber: number | undefined;
    isSalaryAfterInterview: boolean;
    salary: number | undefined;
    jobDescription: string | undefined;
    isShowWithCompany: boolean;
    closeDate: moment.Moment | undefined;
}

export class GetMainInfoCompanyForUpdateDto implements IGetMainInfoCompanyForUpdateDto {
    id: number;
    image: string | undefined;
    name: string | undefined;
    companyType: CompanyType;
    country: string | undefined;
    city: string | undefined;
    address: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    webSite: string | undefined;
    isComplatedProfile: boolean;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: IGetMainInfoCompanyForUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.image = _data["image"];
            this.name = _data["name"];
            this.companyType = _data["companyType"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.webSite = _data["webSite"];
            this.isComplatedProfile = _data["isComplatedProfile"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMainInfoCompanyForUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMainInfoCompanyForUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["image"] = this.image;
        data["name"] = this.name;
        data["companyType"] = this.companyType;
        data["country"] = this.country;
        data["city"] = this.city;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["webSite"] = this.webSite;
        data["isComplatedProfile"] = this.isComplatedProfile;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): GetMainInfoCompanyForUpdateDto {
        const json = this.toJSON();
        let result = new GetMainInfoCompanyForUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IGetMainInfoCompanyForUpdateDto {
    id: number;
    image: string | undefined;
    name: string | undefined;
    companyType: CompanyType;
    country: string | undefined;
    city: string | undefined;
    address: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    webSite: string | undefined;
    isComplatedProfile: boolean;
    lastModificationTime: moment.Moment | undefined;
}

export class GetMainInfoEmployeeForUpdateDto implements IGetMainInfoEmployeeForUpdateDto {
    id: number;
    image: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    birthDate: moment.Moment | undefined;
    nationality: string | undefined;
    country: string | undefined;
    city: string | undefined;
    isComplatedProfile: boolean;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: IGetMainInfoEmployeeForUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.image = _data["image"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.nationality = _data["nationality"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.isComplatedProfile = _data["isComplatedProfile"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMainInfoEmployeeForUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMainInfoEmployeeForUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["image"] = this.image;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["nationality"] = this.nationality;
        data["country"] = this.country;
        data["city"] = this.city;
        data["isComplatedProfile"] = this.isComplatedProfile;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): GetMainInfoEmployeeForUpdateDto {
        const json = this.toJSON();
        let result = new GetMainInfoEmployeeForUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IGetMainInfoEmployeeForUpdateDto {
    id: number;
    image: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    birthDate: moment.Moment | undefined;
    nationality: string | undefined;
    country: string | undefined;
    city: string | undefined;
    isComplatedProfile: boolean;
    lastModificationTime: moment.Moment | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GetSecondInfoCompanyForUpdateDto implements IGetSecondInfoCompanyForUpdateDto {
    id: number;
    establishDate: moment.Moment | undefined;
    companySize: CompanySize;
    numberOfBranchs: number | undefined;
    description: string | undefined;
    isComplatedProfile: boolean;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: IGetSecondInfoCompanyForUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.establishDate = _data["establishDate"] ? moment(_data["establishDate"].toString()) : <any>undefined;
            this.companySize = _data["companySize"];
            this.numberOfBranchs = _data["numberOfBranchs"];
            this.description = _data["description"];
            this.isComplatedProfile = _data["isComplatedProfile"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSecondInfoCompanyForUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSecondInfoCompanyForUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["establishDate"] = this.establishDate ? this.establishDate.toISOString() : <any>undefined;
        data["companySize"] = this.companySize;
        data["numberOfBranchs"] = this.numberOfBranchs;
        data["description"] = this.description;
        data["isComplatedProfile"] = this.isComplatedProfile;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): GetSecondInfoCompanyForUpdateDto {
        const json = this.toJSON();
        let result = new GetSecondInfoCompanyForUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IGetSecondInfoCompanyForUpdateDto {
    id: number;
    establishDate: moment.Moment | undefined;
    companySize: CompanySize;
    numberOfBranchs: number | undefined;
    description: string | undefined;
    isComplatedProfile: boolean;
    lastModificationTime: moment.Moment | undefined;
}

export class GetSecondInfoEmployeeForUpdateDto implements IGetSecondInfoEmployeeForUpdateDto {
    id: number;
    maritalStatus: MaritalStatus;
    militaryStatus: MilitaryStatus;
    salary: number | undefined;
    healthStatus: HealthStatus;
    employmentStatus: EmploymentStatus;
    gender: Gender;
    isComplatedProfile: boolean;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: IGetSecondInfoEmployeeForUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.maritalStatus = _data["maritalStatus"];
            this.militaryStatus = _data["militaryStatus"];
            this.salary = _data["salary"];
            this.healthStatus = _data["healthStatus"];
            this.employmentStatus = _data["employmentStatus"];
            this.gender = _data["gender"];
            this.isComplatedProfile = _data["isComplatedProfile"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSecondInfoEmployeeForUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSecondInfoEmployeeForUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["maritalStatus"] = this.maritalStatus;
        data["militaryStatus"] = this.militaryStatus;
        data["salary"] = this.salary;
        data["healthStatus"] = this.healthStatus;
        data["employmentStatus"] = this.employmentStatus;
        data["gender"] = this.gender;
        data["isComplatedProfile"] = this.isComplatedProfile;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): GetSecondInfoEmployeeForUpdateDto {
        const json = this.toJSON();
        let result = new GetSecondInfoEmployeeForUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IGetSecondInfoEmployeeForUpdateDto {
    id: number;
    maritalStatus: MaritalStatus;
    militaryStatus: MilitaryStatus;
    salary: number | undefined;
    healthStatus: HealthStatus;
    employmentStatus: EmploymentStatus;
    gender: Gender;
    isComplatedProfile: boolean;
    lastModificationTime: moment.Moment | undefined;
}

export enum HealthStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class HomeSliderByIdDto implements IHomeSliderByIdDto {
    id: number;
    title: string | undefined;
    titleAr: string | undefined;
    description: string | undefined;
    descriptionAr: string | undefined;
    image: string | undefined;

    constructor(data?: IHomeSliderByIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.titleAr = _data["titleAr"];
            this.description = _data["description"];
            this.descriptionAr = _data["descriptionAr"];
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): HomeSliderByIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new HomeSliderByIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["titleAr"] = this.titleAr;
        data["description"] = this.description;
        data["descriptionAr"] = this.descriptionAr;
        data["image"] = this.image;
        return data;
    }

    clone(): HomeSliderByIdDto {
        const json = this.toJSON();
        let result = new HomeSliderByIdDto();
        result.init(json);
        return result;
    }
}

export interface IHomeSliderByIdDto {
    id: number;
    title: string | undefined;
    titleAr: string | undefined;
    description: string | undefined;
    descriptionAr: string | undefined;
    image: string | undefined;
}

export class HomeSliderDto implements IHomeSliderDto {
    title: string | undefined;
    description: string | undefined;
    image: string | undefined;

    constructor(data?: IHomeSliderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): HomeSliderDto {
        data = typeof data === 'object' ? data : {};
        let result = new HomeSliderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["image"] = this.image;
        return data;
    }

    clone(): HomeSliderDto {
        const json = this.toJSON();
        let result = new HomeSliderDto();
        result.init(json);
        return result;
    }
}

export interface IHomeSliderDto {
    title: string | undefined;
    description: string | undefined;
    image: string | undefined;
}

export class HomeSliderForAdminDto implements IHomeSliderForAdminDto {
    id: number;
    title: string | undefined;
    description: string | undefined;
    image: string | undefined;
    type: HomeSliderType;

    constructor(data?: IHomeSliderForAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.image = _data["image"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): HomeSliderForAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new HomeSliderForAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["image"] = this.image;
        data["type"] = this.type;
        return data;
    }

    clone(): HomeSliderForAdminDto {
        const json = this.toJSON();
        let result = new HomeSliderForAdminDto();
        result.init(json);
        return result;
    }
}

export interface IHomeSliderForAdminDto {
    id: number;
    title: string | undefined;
    description: string | undefined;
    image: string | undefined;
    type: HomeSliderType;
}

export enum HomeSliderType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export class IndustryByIdDto implements IIndustryByIdDto {
    id: number;
    name: string | undefined;
    nameAr: string | undefined;
    image: string | undefined;
    order: number | undefined;
    showInHomePage: boolean;

    constructor(data?: IIndustryByIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameAr = _data["nameAr"];
            this.image = _data["image"];
            this.order = _data["order"];
            this.showInHomePage = _data["showInHomePage"];
        }
    }

    static fromJS(data: any): IndustryByIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new IndustryByIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameAr"] = this.nameAr;
        data["image"] = this.image;
        data["order"] = this.order;
        data["showInHomePage"] = this.showInHomePage;
        return data;
    }

    clone(): IndustryByIdDto {
        const json = this.toJSON();
        let result = new IndustryByIdDto();
        result.init(json);
        return result;
    }
}

export interface IIndustryByIdDto {
    id: number;
    name: string | undefined;
    nameAr: string | undefined;
    image: string | undefined;
    order: number | undefined;
    showInHomePage: boolean;
}

export class IndustryDto implements IIndustryDto {
    id: number;
    name: string | undefined;

    constructor(data?: IIndustryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): IndustryDto {
        data = typeof data === 'object' ? data : {};
        let result = new IndustryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): IndustryDto {
        const json = this.toJSON();
        let result = new IndustryDto();
        result.init(json);
        return result;
    }
}

export interface IIndustryDto {
    id: number;
    name: string | undefined;
}

export class IndustryDtoPagedResultDto implements IIndustryDtoPagedResultDto {
    items: IndustryDto[] | undefined;
    totalCount: number;

    constructor(data?: IIndustryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(IndustryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): IndustryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new IndustryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): IndustryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new IndustryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IIndustryDtoPagedResultDto {
    items: IndustryDto[] | undefined;
    totalCount: number;
}

export class IndustryForAdminDto implements IIndustryForAdminDto {
    id: number;
    name: string | undefined;
    order: number | undefined;
    showInHomePage: boolean;
    countOfPublishedJobs: number;

    constructor(data?: IIndustryForAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.order = _data["order"];
            this.showInHomePage = _data["showInHomePage"];
            this.countOfPublishedJobs = _data["countOfPublishedJobs"];
        }
    }

    static fromJS(data: any): IndustryForAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new IndustryForAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["order"] = this.order;
        data["showInHomePage"] = this.showInHomePage;
        data["countOfPublishedJobs"] = this.countOfPublishedJobs;
        return data;
    }

    clone(): IndustryForAdminDto {
        const json = this.toJSON();
        let result = new IndustryForAdminDto();
        result.init(json);
        return result;
    }
}

export interface IIndustryForAdminDto {
    id: number;
    name: string | undefined;
    order: number | undefined;
    showInHomePage: boolean;
    countOfPublishedJobs: number;
}

export class IndustryForAdminDtoPagedResultDto implements IIndustryForAdminDtoPagedResultDto {
    items: IndustryForAdminDto[] | undefined;
    totalCount: number;

    constructor(data?: IIndustryForAdminDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(IndustryForAdminDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): IndustryForAdminDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new IndustryForAdminDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): IndustryForAdminDtoPagedResultDto {
        const json = this.toJSON();
        let result = new IndustryForAdminDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IIndustryForAdminDtoPagedResultDto {
    items: IndustryForAdminDto[] | undefined;
    totalCount: number;
}

export class IndustryGuestUserDto implements IIndustryGuestUserDto {
    id: number;
    name: string | undefined;
    image: string | undefined;
    jobsCount: number;

    constructor(data?: IIndustryGuestUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.image = _data["image"];
            this.jobsCount = _data["jobsCount"];
        }
    }

    static fromJS(data: any): IndustryGuestUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new IndustryGuestUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["image"] = this.image;
        data["jobsCount"] = this.jobsCount;
        return data;
    }

    clone(): IndustryGuestUserDto {
        const json = this.toJSON();
        let result = new IndustryGuestUserDto();
        result.init(json);
        return result;
    }
}

export interface IIndustryGuestUserDto {
    id: number;
    name: string | undefined;
    image: string | undefined;
    jobsCount: number;
}

export class IndustryGuestUserDtoPagedResultDto implements IIndustryGuestUserDtoPagedResultDto {
    items: IndustryGuestUserDto[] | undefined;
    totalCount: number;

    constructor(data?: IIndustryGuestUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(IndustryGuestUserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): IndustryGuestUserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new IndustryGuestUserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): IndustryGuestUserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new IndustryGuestUserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IIndustryGuestUserDtoPagedResultDto {
    items: IndustryGuestUserDto[] | undefined;
    totalCount: number;
}

export class Int64EntityDto implements IInt64EntityDto {
    id: number;

    constructor(data?: IInt64EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Int64EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int64EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): Int64EntityDto {
        const json = this.toJSON();
        let result = new Int64EntityDto();
        result.init(json);
        return result;
    }
}

export interface IInt64EntityDto {
    id: number;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
}

export enum JobAgeRange {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class JobAppliedByEmployeeDto implements IJobAppliedByEmployeeDto {
    id: number;
    jobPositionName: string | undefined;
    creationTime: moment.Moment;
    companyId: number;
    countryName: string | undefined;
    cityName: string | undefined;
    companyName: string | undefined;
    companyImage: string | undefined;
    status: JobStatus;

    constructor(data?: IJobAppliedByEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jobPositionName = _data["jobPositionName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.companyId = _data["companyId"];
            this.countryName = _data["countryName"];
            this.cityName = _data["cityName"];
            this.companyName = _data["companyName"];
            this.companyImage = _data["companyImage"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): JobAppliedByEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobAppliedByEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jobPositionName"] = this.jobPositionName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["companyId"] = this.companyId;
        data["countryName"] = this.countryName;
        data["cityName"] = this.cityName;
        data["companyName"] = this.companyName;
        data["companyImage"] = this.companyImage;
        data["status"] = this.status;
        return data;
    }

    clone(): JobAppliedByEmployeeDto {
        const json = this.toJSON();
        let result = new JobAppliedByEmployeeDto();
        result.init(json);
        return result;
    }
}

export interface IJobAppliedByEmployeeDto {
    id: number;
    jobPositionName: string | undefined;
    creationTime: moment.Moment;
    companyId: number;
    countryName: string | undefined;
    cityName: string | undefined;
    companyName: string | undefined;
    companyImage: string | undefined;
    status: JobStatus;
}

export class JobAppliedByEmployeeDtoPagedResultDto implements IJobAppliedByEmployeeDtoPagedResultDto {
    items: JobAppliedByEmployeeDto[] | undefined;
    totalCount: number;

    constructor(data?: IJobAppliedByEmployeeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(JobAppliedByEmployeeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): JobAppliedByEmployeeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobAppliedByEmployeeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): JobAppliedByEmployeeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new JobAppliedByEmployeeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IJobAppliedByEmployeeDtoPagedResultDto {
    items: JobAppliedByEmployeeDto[] | undefined;
    totalCount: number;
}

export class JobDetailsForAdminDto implements IJobDetailsForAdminDto {
    industryName: string | undefined;
    jobPositionName: string | undefined;
    educationLevel: EducationLevel;
    positionLevel: PositionLevel;
    gender: Gender;
    jobAgeRange: JobAgeRange;
    jobType: JobType;
    countryName: string | undefined;
    cityName: string | undefined;
    salary: number | undefined;
    vacanciesNumber: number | undefined;
    jobDescription: string | undefined;
    isShowWithCompany: boolean;
    companyName: string | undefined;
    openCvRemainCount: number | undefined;
    publishDate: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    showInHomePage: boolean;
    recommended: boolean;
    workPlaceType: WorkPlaceType;
    isSalaryAfterInterview: boolean;
    status: JobStatus;
    closeDate: moment.Moment | undefined;

    constructor(data?: IJobDetailsForAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.industryName = _data["industryName"];
            this.jobPositionName = _data["jobPositionName"];
            this.educationLevel = _data["educationLevel"];
            this.positionLevel = _data["positionLevel"];
            this.gender = _data["gender"];
            this.jobAgeRange = _data["jobAgeRange"];
            this.jobType = _data["jobType"];
            this.countryName = _data["countryName"];
            this.cityName = _data["cityName"];
            this.salary = _data["salary"];
            this.vacanciesNumber = _data["vacanciesNumber"];
            this.jobDescription = _data["jobDescription"];
            this.isShowWithCompany = _data["isShowWithCompany"];
            this.companyName = _data["companyName"];
            this.openCvRemainCount = _data["openCvRemainCount"];
            this.publishDate = _data["publishDate"] ? moment(_data["publishDate"].toString()) : <any>undefined;
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
            this.showInHomePage = _data["showInHomePage"];
            this.recommended = _data["recommended"];
            this.workPlaceType = _data["workPlaceType"];
            this.isSalaryAfterInterview = _data["isSalaryAfterInterview"];
            this.status = _data["status"];
            this.closeDate = _data["closeDate"] ? moment(_data["closeDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): JobDetailsForAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobDetailsForAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["industryName"] = this.industryName;
        data["jobPositionName"] = this.jobPositionName;
        data["educationLevel"] = this.educationLevel;
        data["positionLevel"] = this.positionLevel;
        data["gender"] = this.gender;
        data["jobAgeRange"] = this.jobAgeRange;
        data["jobType"] = this.jobType;
        data["countryName"] = this.countryName;
        data["cityName"] = this.cityName;
        data["salary"] = this.salary;
        data["vacanciesNumber"] = this.vacanciesNumber;
        data["jobDescription"] = this.jobDescription;
        data["isShowWithCompany"] = this.isShowWithCompany;
        data["companyName"] = this.companyName;
        data["openCvRemainCount"] = this.openCvRemainCount;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["showInHomePage"] = this.showInHomePage;
        data["recommended"] = this.recommended;
        data["workPlaceType"] = this.workPlaceType;
        data["isSalaryAfterInterview"] = this.isSalaryAfterInterview;
        data["status"] = this.status;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): JobDetailsForAdminDto {
        const json = this.toJSON();
        let result = new JobDetailsForAdminDto();
        result.init(json);
        return result;
    }
}

export interface IJobDetailsForAdminDto {
    industryName: string | undefined;
    jobPositionName: string | undefined;
    educationLevel: EducationLevel;
    positionLevel: PositionLevel;
    gender: Gender;
    jobAgeRange: JobAgeRange;
    jobType: JobType;
    countryName: string | undefined;
    cityName: string | undefined;
    salary: number | undefined;
    vacanciesNumber: number | undefined;
    jobDescription: string | undefined;
    isShowWithCompany: boolean;
    companyName: string | undefined;
    openCvRemainCount: number | undefined;
    publishDate: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    showInHomePage: boolean;
    recommended: boolean;
    workPlaceType: WorkPlaceType;
    isSalaryAfterInterview: boolean;
    status: JobStatus;
    closeDate: moment.Moment | undefined;
}

export class JobDetailsForCompanyDto implements IJobDetailsForCompanyDto {
    id: number;
    industryName: string | undefined;
    jobPositionName: string | undefined;
    creationTime: moment.Moment;
    educationLevel: EducationLevel;
    positionLevel: PositionLevel;
    gender: Gender;
    jobAgeRange: JobAgeRange;
    jobType: JobType;
    workPlaceType: WorkPlaceType;
    vacanciesNumber: number | undefined;
    isSalaryAfterInterview: boolean;
    salary: number | undefined;
    countryName: string | undefined;
    cityName: string | undefined;
    jobDescription: string | undefined;
    status: JobStatus;
    isUpdatedByCompany: boolean;
    closeDate: moment.Moment | undefined;
    packageName: string | undefined;

    constructor(data?: IJobDetailsForCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.industryName = _data["industryName"];
            this.jobPositionName = _data["jobPositionName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.educationLevel = _data["educationLevel"];
            this.positionLevel = _data["positionLevel"];
            this.gender = _data["gender"];
            this.jobAgeRange = _data["jobAgeRange"];
            this.jobType = _data["jobType"];
            this.workPlaceType = _data["workPlaceType"];
            this.vacanciesNumber = _data["vacanciesNumber"];
            this.isSalaryAfterInterview = _data["isSalaryAfterInterview"];
            this.salary = _data["salary"];
            this.countryName = _data["countryName"];
            this.cityName = _data["cityName"];
            this.jobDescription = _data["jobDescription"];
            this.status = _data["status"];
            this.isUpdatedByCompany = _data["isUpdatedByCompany"];
            this.closeDate = _data["closeDate"] ? moment(_data["closeDate"].toString()) : <any>undefined;
            this.packageName = _data["packageName"];
        }
    }

    static fromJS(data: any): JobDetailsForCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobDetailsForCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["industryName"] = this.industryName;
        data["jobPositionName"] = this.jobPositionName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["educationLevel"] = this.educationLevel;
        data["positionLevel"] = this.positionLevel;
        data["gender"] = this.gender;
        data["jobAgeRange"] = this.jobAgeRange;
        data["jobType"] = this.jobType;
        data["workPlaceType"] = this.workPlaceType;
        data["vacanciesNumber"] = this.vacanciesNumber;
        data["isSalaryAfterInterview"] = this.isSalaryAfterInterview;
        data["salary"] = this.salary;
        data["countryName"] = this.countryName;
        data["cityName"] = this.cityName;
        data["jobDescription"] = this.jobDescription;
        data["status"] = this.status;
        data["isUpdatedByCompany"] = this.isUpdatedByCompany;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : <any>undefined;
        data["packageName"] = this.packageName;
        return data;
    }

    clone(): JobDetailsForCompanyDto {
        const json = this.toJSON();
        let result = new JobDetailsForCompanyDto();
        result.init(json);
        return result;
    }
}

export interface IJobDetailsForCompanyDto {
    id: number;
    industryName: string | undefined;
    jobPositionName: string | undefined;
    creationTime: moment.Moment;
    educationLevel: EducationLevel;
    positionLevel: PositionLevel;
    gender: Gender;
    jobAgeRange: JobAgeRange;
    jobType: JobType;
    workPlaceType: WorkPlaceType;
    vacanciesNumber: number | undefined;
    isSalaryAfterInterview: boolean;
    salary: number | undefined;
    countryName: string | undefined;
    cityName: string | undefined;
    jobDescription: string | undefined;
    status: JobStatus;
    isUpdatedByCompany: boolean;
    closeDate: moment.Moment | undefined;
    packageName: string | undefined;
}

export class JobDetailsForGuestUserDto implements IJobDetailsForGuestUserDto {
    id: number;
    industryName: string | undefined;
    jobPositionName: string | undefined;
    creationTime: moment.Moment;
    educationLevel: EducationLevel;
    positionLevel: PositionLevel;
    gender: Gender;
    jobAgeRange: JobAgeRange;
    jobType: JobType;
    workPlaceType: WorkPlaceType;
    vacanciesNumber: number | undefined;
    isSalaryAfterInterview: boolean;
    salary: number | undefined;
    countryName: string | undefined;
    cityName: string | undefined;
    jobDescription: string | undefined;
    companyId: number | undefined;
    isShowWithCompany: boolean | undefined;
    closeDate: moment.Moment | undefined;

    constructor(data?: IJobDetailsForGuestUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.industryName = _data["industryName"];
            this.jobPositionName = _data["jobPositionName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.educationLevel = _data["educationLevel"];
            this.positionLevel = _data["positionLevel"];
            this.gender = _data["gender"];
            this.jobAgeRange = _data["jobAgeRange"];
            this.jobType = _data["jobType"];
            this.workPlaceType = _data["workPlaceType"];
            this.vacanciesNumber = _data["vacanciesNumber"];
            this.isSalaryAfterInterview = _data["isSalaryAfterInterview"];
            this.salary = _data["salary"];
            this.countryName = _data["countryName"];
            this.cityName = _data["cityName"];
            this.jobDescription = _data["jobDescription"];
            this.companyId = _data["companyId"];
            this.isShowWithCompany = _data["isShowWithCompany"];
            this.closeDate = _data["closeDate"] ? moment(_data["closeDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): JobDetailsForGuestUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobDetailsForGuestUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["industryName"] = this.industryName;
        data["jobPositionName"] = this.jobPositionName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["educationLevel"] = this.educationLevel;
        data["positionLevel"] = this.positionLevel;
        data["gender"] = this.gender;
        data["jobAgeRange"] = this.jobAgeRange;
        data["jobType"] = this.jobType;
        data["workPlaceType"] = this.workPlaceType;
        data["vacanciesNumber"] = this.vacanciesNumber;
        data["isSalaryAfterInterview"] = this.isSalaryAfterInterview;
        data["salary"] = this.salary;
        data["countryName"] = this.countryName;
        data["cityName"] = this.cityName;
        data["jobDescription"] = this.jobDescription;
        data["companyId"] = this.companyId;
        data["isShowWithCompany"] = this.isShowWithCompany;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): JobDetailsForGuestUserDto {
        const json = this.toJSON();
        let result = new JobDetailsForGuestUserDto();
        result.init(json);
        return result;
    }
}

export interface IJobDetailsForGuestUserDto {
    id: number;
    industryName: string | undefined;
    jobPositionName: string | undefined;
    creationTime: moment.Moment;
    educationLevel: EducationLevel;
    positionLevel: PositionLevel;
    gender: Gender;
    jobAgeRange: JobAgeRange;
    jobType: JobType;
    workPlaceType: WorkPlaceType;
    vacanciesNumber: number | undefined;
    isSalaryAfterInterview: boolean;
    salary: number | undefined;
    countryName: string | undefined;
    cityName: string | undefined;
    jobDescription: string | undefined;
    companyId: number | undefined;
    isShowWithCompany: boolean | undefined;
    closeDate: moment.Moment | undefined;
}

export class JobForAdminDto implements IJobForAdminDto {
    id: number;
    educationLevel: EducationLevel;
    positionLevel: PositionLevel;
    gender: Gender;
    jobAgeRange: JobAgeRange;
    jobType: JobType;
    companyName: string | undefined;
    salary: number | undefined;
    jobDescription: string | undefined;
    isShowWithCompany: boolean;
    recommended: boolean;
    isSalaryAfterInterview: boolean;
    workPlaceType: WorkPlaceType;
    status: JobStatus;

    constructor(data?: IJobForAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.educationLevel = _data["educationLevel"];
            this.positionLevel = _data["positionLevel"];
            this.gender = _data["gender"];
            this.jobAgeRange = _data["jobAgeRange"];
            this.jobType = _data["jobType"];
            this.companyName = _data["companyName"];
            this.salary = _data["salary"];
            this.jobDescription = _data["jobDescription"];
            this.isShowWithCompany = _data["isShowWithCompany"];
            this.recommended = _data["recommended"];
            this.isSalaryAfterInterview = _data["isSalaryAfterInterview"];
            this.workPlaceType = _data["workPlaceType"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): JobForAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobForAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["educationLevel"] = this.educationLevel;
        data["positionLevel"] = this.positionLevel;
        data["gender"] = this.gender;
        data["jobAgeRange"] = this.jobAgeRange;
        data["jobType"] = this.jobType;
        data["companyName"] = this.companyName;
        data["salary"] = this.salary;
        data["jobDescription"] = this.jobDescription;
        data["isShowWithCompany"] = this.isShowWithCompany;
        data["recommended"] = this.recommended;
        data["isSalaryAfterInterview"] = this.isSalaryAfterInterview;
        data["workPlaceType"] = this.workPlaceType;
        data["status"] = this.status;
        return data;
    }

    clone(): JobForAdminDto {
        const json = this.toJSON();
        let result = new JobForAdminDto();
        result.init(json);
        return result;
    }
}

export interface IJobForAdminDto {
    id: number;
    educationLevel: EducationLevel;
    positionLevel: PositionLevel;
    gender: Gender;
    jobAgeRange: JobAgeRange;
    jobType: JobType;
    companyName: string | undefined;
    salary: number | undefined;
    jobDescription: string | undefined;
    isShowWithCompany: boolean;
    recommended: boolean;
    isSalaryAfterInterview: boolean;
    workPlaceType: WorkPlaceType;
    status: JobStatus;
}

export class JobForAdminDtoPagedResultDto implements IJobForAdminDtoPagedResultDto {
    items: JobForAdminDto[] | undefined;
    totalCount: number;

    constructor(data?: IJobForAdminDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(JobForAdminDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): JobForAdminDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobForAdminDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): JobForAdminDtoPagedResultDto {
        const json = this.toJSON();
        let result = new JobForAdminDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IJobForAdminDtoPagedResultDto {
    items: JobForAdminDto[] | undefined;
    totalCount: number;
}

export class JobForCompanyDto implements IJobForCompanyDto {
    id: number;
    industryName: string | undefined;
    jobPositionName: string | undefined;
    applicantsCount: number;
    creationTime: moment.Moment;
    status: JobStatus;
    isUpdatedByCompany: boolean;

    constructor(data?: IJobForCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.industryName = _data["industryName"];
            this.jobPositionName = _data["jobPositionName"];
            this.applicantsCount = _data["applicantsCount"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.isUpdatedByCompany = _data["isUpdatedByCompany"];
        }
    }

    static fromJS(data: any): JobForCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobForCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["industryName"] = this.industryName;
        data["jobPositionName"] = this.jobPositionName;
        data["applicantsCount"] = this.applicantsCount;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["isUpdatedByCompany"] = this.isUpdatedByCompany;
        return data;
    }

    clone(): JobForCompanyDto {
        const json = this.toJSON();
        let result = new JobForCompanyDto();
        result.init(json);
        return result;
    }
}

export interface IJobForCompanyDto {
    id: number;
    industryName: string | undefined;
    jobPositionName: string | undefined;
    applicantsCount: number;
    creationTime: moment.Moment;
    status: JobStatus;
    isUpdatedByCompany: boolean;
}

export class JobForCompanyDtoPagedResultDto implements IJobForCompanyDtoPagedResultDto {
    items: JobForCompanyDto[] | undefined;
    totalCount: number;

    constructor(data?: IJobForCompanyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(JobForCompanyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): JobForCompanyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobForCompanyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): JobForCompanyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new JobForCompanyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IJobForCompanyDtoPagedResultDto {
    items: JobForCompanyDto[] | undefined;
    totalCount: number;
}

export class JobGuestUserDto implements IJobGuestUserDto {
    id: number;
    jobPositionName: string | undefined;
    creationTime: moment.Moment;
    companyId: number;
    countryName: string | undefined;
    cityName: string | undefined;
    companyName: string | undefined;
    companyImage: string | undefined;

    constructor(data?: IJobGuestUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jobPositionName = _data["jobPositionName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.companyId = _data["companyId"];
            this.countryName = _data["countryName"];
            this.cityName = _data["cityName"];
            this.companyName = _data["companyName"];
            this.companyImage = _data["companyImage"];
        }
    }

    static fromJS(data: any): JobGuestUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobGuestUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jobPositionName"] = this.jobPositionName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["companyId"] = this.companyId;
        data["countryName"] = this.countryName;
        data["cityName"] = this.cityName;
        data["companyName"] = this.companyName;
        data["companyImage"] = this.companyImage;
        return data;
    }

    clone(): JobGuestUserDto {
        const json = this.toJSON();
        let result = new JobGuestUserDto();
        result.init(json);
        return result;
    }
}

export interface IJobGuestUserDto {
    id: number;
    jobPositionName: string | undefined;
    creationTime: moment.Moment;
    companyId: number;
    countryName: string | undefined;
    cityName: string | undefined;
    companyName: string | undefined;
    companyImage: string | undefined;
}

export class JobGuestUserDtoPagedResultDto implements IJobGuestUserDtoPagedResultDto {
    items: JobGuestUserDto[] | undefined;
    totalCount: number;

    constructor(data?: IJobGuestUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(JobGuestUserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): JobGuestUserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobGuestUserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): JobGuestUserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new JobGuestUserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IJobGuestUserDtoPagedResultDto {
    items: JobGuestUserDto[] | undefined;
    totalCount: number;
}

export class JobLanguageDto implements IJobLanguageDto {
    id: number;
    name: string | undefined;
    flag: string | undefined;

    constructor(data?: IJobLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.flag = _data["flag"];
        }
    }

    static fromJS(data: any): JobLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["flag"] = this.flag;
        return data;
    }

    clone(): JobLanguageDto {
        const json = this.toJSON();
        let result = new JobLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IJobLanguageDto {
    id: number;
    name: string | undefined;
    flag: string | undefined;
}

export class JobLanguageDtoPagedResultDto implements IJobLanguageDtoPagedResultDto {
    items: JobLanguageDto[] | undefined;
    totalCount: number;

    constructor(data?: IJobLanguageDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(JobLanguageDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): JobLanguageDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobLanguageDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): JobLanguageDtoPagedResultDto {
        const json = this.toJSON();
        let result = new JobLanguageDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IJobLanguageDtoPagedResultDto {
    items: JobLanguageDto[] | undefined;
    totalCount: number;
}

export class JobLanguageForGuestUserDto implements IJobLanguageForGuestUserDto {
    name: string | undefined;
    flag: string | undefined;

    constructor(data?: IJobLanguageForGuestUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.flag = _data["flag"];
        }
    }

    static fromJS(data: any): JobLanguageForGuestUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobLanguageForGuestUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["flag"] = this.flag;
        return data;
    }

    clone(): JobLanguageForGuestUserDto {
        const json = this.toJSON();
        let result = new JobLanguageForGuestUserDto();
        result.init(json);
        return result;
    }
}

export interface IJobLanguageForGuestUserDto {
    name: string | undefined;
    flag: string | undefined;
}

export class JobLanguageForGuestUserDtoPagedResultDto implements IJobLanguageForGuestUserDtoPagedResultDto {
    items: JobLanguageForGuestUserDto[] | undefined;
    totalCount: number;

    constructor(data?: IJobLanguageForGuestUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(JobLanguageForGuestUserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): JobLanguageForGuestUserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobLanguageForGuestUserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): JobLanguageForGuestUserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new JobLanguageForGuestUserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IJobLanguageForGuestUserDtoPagedResultDto {
    items: JobLanguageForGuestUserDto[] | undefined;
    totalCount: number;
}

export class JobPositionByIdDto implements IJobPositionByIdDto {
    id: number;
    name: string | undefined;
    showInHomePage: boolean;
    industryId: number | undefined;
    nameAr: string | undefined;

    constructor(data?: IJobPositionByIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.showInHomePage = _data["showInHomePage"];
            this.industryId = _data["industryId"];
            this.nameAr = _data["nameAr"];
        }
    }

    static fromJS(data: any): JobPositionByIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobPositionByIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["showInHomePage"] = this.showInHomePage;
        data["industryId"] = this.industryId;
        data["nameAr"] = this.nameAr;
        return data;
    }

    clone(): JobPositionByIdDto {
        const json = this.toJSON();
        let result = new JobPositionByIdDto();
        result.init(json);
        return result;
    }
}

export interface IJobPositionByIdDto {
    id: number;
    name: string | undefined;
    showInHomePage: boolean;
    industryId: number | undefined;
    nameAr: string | undefined;
}

export class JobPositionDto implements IJobPositionDto {
    id: number;
    name: string | undefined;

    constructor(data?: IJobPositionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): JobPositionDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobPositionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): JobPositionDto {
        const json = this.toJSON();
        let result = new JobPositionDto();
        result.init(json);
        return result;
    }
}

export interface IJobPositionDto {
    id: number;
    name: string | undefined;
}

export class JobPositionDtoPagedResultDto implements IJobPositionDtoPagedResultDto {
    items: JobPositionDto[] | undefined;
    totalCount: number;

    constructor(data?: IJobPositionDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(JobPositionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): JobPositionDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobPositionDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): JobPositionDtoPagedResultDto {
        const json = this.toJSON();
        let result = new JobPositionDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IJobPositionDtoPagedResultDto {
    items: JobPositionDto[] | undefined;
    totalCount: number;
}

export class JobPositionForAdminDto implements IJobPositionForAdminDto {
    id: number;
    name: string | undefined;
    showInHomePage: boolean;

    constructor(data?: IJobPositionForAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.showInHomePage = _data["showInHomePage"];
        }
    }

    static fromJS(data: any): JobPositionForAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobPositionForAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["showInHomePage"] = this.showInHomePage;
        return data;
    }

    clone(): JobPositionForAdminDto {
        const json = this.toJSON();
        let result = new JobPositionForAdminDto();
        result.init(json);
        return result;
    }
}

export interface IJobPositionForAdminDto {
    id: number;
    name: string | undefined;
    showInHomePage: boolean;
}

export class JobPositionForAdminDtoPagedResultDto implements IJobPositionForAdminDtoPagedResultDto {
    items: JobPositionForAdminDto[] | undefined;
    totalCount: number;

    constructor(data?: IJobPositionForAdminDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(JobPositionForAdminDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): JobPositionForAdminDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobPositionForAdminDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): JobPositionForAdminDtoPagedResultDto {
        const json = this.toJSON();
        let result = new JobPositionForAdminDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IJobPositionForAdminDtoPagedResultDto {
    items: JobPositionForAdminDto[] | undefined;
    totalCount: number;
}

export class JobSkillDto implements IJobSkillDto {
    id: number;
    skillId: number;
    name: string | undefined;

    constructor(data?: IJobSkillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.skillId = _data["skillId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): JobSkillDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobSkillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["skillId"] = this.skillId;
        data["name"] = this.name;
        return data;
    }

    clone(): JobSkillDto {
        const json = this.toJSON();
        let result = new JobSkillDto();
        result.init(json);
        return result;
    }
}

export interface IJobSkillDto {
    id: number;
    skillId: number;
    name: string | undefined;
}

export class JobSkillDtoPagedResultDto implements IJobSkillDtoPagedResultDto {
    items: JobSkillDto[] | undefined;
    totalCount: number;

    constructor(data?: IJobSkillDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(JobSkillDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): JobSkillDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobSkillDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): JobSkillDtoPagedResultDto {
        const json = this.toJSON();
        let result = new JobSkillDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IJobSkillDtoPagedResultDto {
    items: JobSkillDto[] | undefined;
    totalCount: number;
}

export class JobSkillForGuestUserDto implements IJobSkillForGuestUserDto {
    name: string | undefined;

    constructor(data?: IJobSkillForGuestUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): JobSkillForGuestUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobSkillForGuestUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }

    clone(): JobSkillForGuestUserDto {
        const json = this.toJSON();
        let result = new JobSkillForGuestUserDto();
        result.init(json);
        return result;
    }
}

export interface IJobSkillForGuestUserDto {
    name: string | undefined;
}

export class JobSkillForGuestUserDtoPagedResultDto implements IJobSkillForGuestUserDtoPagedResultDto {
    items: JobSkillForGuestUserDto[] | undefined;
    totalCount: number;

    constructor(data?: IJobSkillForGuestUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(JobSkillForGuestUserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): JobSkillForGuestUserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobSkillForGuestUserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): JobSkillForGuestUserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new JobSkillForGuestUserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IJobSkillForGuestUserDtoPagedResultDto {
    items: JobSkillForGuestUserDto[] | undefined;
    totalCount: number;
}

export enum JobStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export enum JobType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum LastPublishJob {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum MaritalStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum MilitaryStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class NotificationDto implements INotificationDto {
    id: number;
    title: string | undefined;
    body: string | undefined;
    creationTime: moment.Moment;
    relatedToType: NotificationRelatedTo;
    isReaded: boolean;

    constructor(data?: INotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.body = _data["body"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.relatedToType = _data["relatedToType"];
            this.isReaded = _data["isReaded"];
        }
    }

    static fromJS(data: any): NotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["body"] = this.body;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["relatedToType"] = this.relatedToType;
        data["isReaded"] = this.isReaded;
        return data;
    }

    clone(): NotificationDto {
        const json = this.toJSON();
        let result = new NotificationDto();
        result.init(json);
        return result;
    }
}

export interface INotificationDto {
    id: number;
    title: string | undefined;
    body: string | undefined;
    creationTime: moment.Moment;
    relatedToType: NotificationRelatedTo;
    isReaded: boolean;
}

export class NotificationDtoPagedResultDto implements INotificationDtoPagedResultDto {
    items: NotificationDto[] | undefined;
    totalCount: number;

    constructor(data?: INotificationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(NotificationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): NotificationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): NotificationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new NotificationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface INotificationDtoPagedResultDto {
    items: NotificationDto[] | undefined;
    totalCount: number;
}

export enum NotificationReceiverType {
    _0 = 0,
    _1 = 1,
}

export class NotificationReceiversDto implements INotificationReceiversDto {
    id: number;
    name: string | undefined;
    firebaseToken: string | undefined;

    constructor(data?: INotificationReceiversDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.firebaseToken = _data["firebaseToken"];
        }
    }

    static fromJS(data: any): NotificationReceiversDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationReceiversDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["firebaseToken"] = this.firebaseToken;
        return data;
    }

    clone(): NotificationReceiversDto {
        const json = this.toJSON();
        let result = new NotificationReceiversDto();
        result.init(json);
        return result;
    }
}

export interface INotificationReceiversDto {
    id: number;
    name: string | undefined;
    firebaseToken: string | undefined;
}

export class NotificationReceiversDtoPagedResultDto implements INotificationReceiversDtoPagedResultDto {
    items: NotificationReceiversDto[] | undefined;
    totalCount: number;

    constructor(data?: INotificationReceiversDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(NotificationReceiversDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): NotificationReceiversDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationReceiversDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): NotificationReceiversDtoPagedResultDto {
        const json = this.toJSON();
        let result = new NotificationReceiversDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface INotificationReceiversDtoPagedResultDto {
    items: NotificationReceiversDto[] | undefined;
    totalCount: number;
}

export enum NotificationRelatedTo {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class PackageByCompanyDto implements IPackageByCompanyDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    price: number;
    isFree: boolean;
    openCvCount: number | undefined;
    publishJobsCount: number | undefined;
    durationType: PackageByCompanyDtoDurationType;
    durationTime: number;

    constructor(data?: IPackageByCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.isFree = _data["isFree"];
            this.openCvCount = _data["openCvCount"];
            this.publishJobsCount = _data["publishJobsCount"];
            this.durationType = _data["durationType"];
            this.durationTime = _data["durationTime"];
        }
    }

    static fromJS(data: any): PackageByCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageByCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["price"] = this.price;
        data["isFree"] = this.isFree;
        data["openCvCount"] = this.openCvCount;
        data["publishJobsCount"] = this.publishJobsCount;
        data["durationType"] = this.durationType;
        data["durationTime"] = this.durationTime;
        return data;
    }

    clone(): PackageByCompanyDto {
        const json = this.toJSON();
        let result = new PackageByCompanyDto();
        result.init(json);
        return result;
    }
}

export interface IPackageByCompanyDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    price: number;
    isFree: boolean;
    openCvCount: number | undefined;
    publishJobsCount: number | undefined;
    durationType: PackageByCompanyDtoDurationType;
    durationTime: number;
}

export class PackageByCompanyDtoPagedResultDto implements IPackageByCompanyDtoPagedResultDto {
    items: PackageByCompanyDto[] | undefined;
    totalCount: number;

    constructor(data?: IPackageByCompanyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PackageByCompanyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PackageByCompanyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageByCompanyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PackageByCompanyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PackageByCompanyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPackageByCompanyDtoPagedResultDto {
    items: PackageByCompanyDto[] | undefined;
    totalCount: number;
}

export class PackageByIdDto implements IPackageByIdDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    nameAr: string | undefined;
    descriptionAr: string | undefined;
    image: string | undefined;
    price: number;
    isFree: boolean | undefined;
    durationType: PackageByIdDtoDurationType;
    durationTime: number;
    jobPublishDurationType: PackageByIdDtoJobPublishDurationType | undefined;
    jobPublishDurationTime: number | undefined;
    openCvCount: number | undefined;
    publishJobsCount: number | undefined;

    constructor(data?: IPackageByIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.nameAr = _data["nameAr"];
            this.descriptionAr = _data["descriptionAr"];
            this.image = _data["image"];
            this.price = _data["price"];
            this.isFree = _data["isFree"];
            this.durationType = _data["durationType"];
            this.durationTime = _data["durationTime"];
            this.jobPublishDurationType = _data["jobPublishDurationType"];
            this.jobPublishDurationTime = _data["jobPublishDurationTime"];
            this.openCvCount = _data["openCvCount"];
            this.publishJobsCount = _data["publishJobsCount"];
        }
    }

    static fromJS(data: any): PackageByIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageByIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["nameAr"] = this.nameAr;
        data["descriptionAr"] = this.descriptionAr;
        data["image"] = this.image;
        data["price"] = this.price;
        data["isFree"] = this.isFree;
        data["durationType"] = this.durationType;
        data["durationTime"] = this.durationTime;
        data["jobPublishDurationType"] = this.jobPublishDurationType;
        data["jobPublishDurationTime"] = this.jobPublishDurationTime;
        data["openCvCount"] = this.openCvCount;
        data["publishJobsCount"] = this.publishJobsCount;
        return data;
    }

    clone(): PackageByIdDto {
        const json = this.toJSON();
        let result = new PackageByIdDto();
        result.init(json);
        return result;
    }
}

export interface IPackageByIdDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    nameAr: string | undefined;
    descriptionAr: string | undefined;
    image: string | undefined;
    price: number;
    isFree: boolean | undefined;
    durationType: PackageByIdDtoDurationType;
    durationTime: number;
    jobPublishDurationType: PackageByIdDtoJobPublishDurationType | undefined;
    jobPublishDurationTime: number | undefined;
    openCvCount: number | undefined;
    publishJobsCount: number | undefined;
}

export class PackageDto implements IPackageDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    price: number;
    isFree: boolean;
    durationType: PackageDtoDurationType;
    durationTime: number;
    jobPublishDurationType: PackageDtoJobPublishDurationType | undefined;
    jobPublishDurationTime: number | undefined;
    openCvCount: number | undefined;
    publishJobsCount: number | undefined;

    constructor(data?: IPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.isFree = _data["isFree"];
            this.durationType = _data["durationType"];
            this.durationTime = _data["durationTime"];
            this.jobPublishDurationType = _data["jobPublishDurationType"];
            this.jobPublishDurationTime = _data["jobPublishDurationTime"];
            this.openCvCount = _data["openCvCount"];
            this.publishJobsCount = _data["publishJobsCount"];
        }
    }

    static fromJS(data: any): PackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["price"] = this.price;
        data["isFree"] = this.isFree;
        data["durationType"] = this.durationType;
        data["durationTime"] = this.durationTime;
        data["jobPublishDurationType"] = this.jobPublishDurationType;
        data["jobPublishDurationTime"] = this.jobPublishDurationTime;
        data["openCvCount"] = this.openCvCount;
        data["publishJobsCount"] = this.publishJobsCount;
        return data;
    }

    clone(): PackageDto {
        const json = this.toJSON();
        let result = new PackageDto();
        result.init(json);
        return result;
    }
}

export interface IPackageDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    price: number;
    isFree: boolean;
    durationType: PackageDtoDurationType;
    durationTime: number;
    jobPublishDurationType: PackageDtoJobPublishDurationType | undefined;
    jobPublishDurationTime: number | undefined;
    openCvCount: number | undefined;
    publishJobsCount: number | undefined;
}

export class PackageDtoPagedResultDto implements IPackageDtoPagedResultDto {
    items: PackageDto[] | undefined;
    totalCount: number;

    constructor(data?: IPackageDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PackageDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PackageDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PackageDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PackageDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPackageDtoPagedResultDto {
    items: PackageDto[] | undefined;
    totalCount: number;
}

export enum PageSortingType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class PagedResultCompanyIndustryDto implements IPagedResultCompanyIndustryDto {
    items: CompanyIndustryDto[] | undefined;
    totalCount: number;
    isComplatedProfile: boolean;

    constructor(data?: IPagedResultCompanyIndustryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CompanyIndustryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.isComplatedProfile = _data["isComplatedProfile"];
        }
    }

    static fromJS(data: any): PagedResultCompanyIndustryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultCompanyIndustryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["isComplatedProfile"] = this.isComplatedProfile;
        return data;
    }

    clone(): PagedResultCompanyIndustryDto {
        const json = this.toJSON();
        let result = new PagedResultCompanyIndustryDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultCompanyIndustryDto {
    items: CompanyIndustryDto[] | undefined;
    totalCount: number;
    isComplatedProfile: boolean;
}

export class PagedResultEmployeeCertificateDto implements IPagedResultEmployeeCertificateDto {
    items: EmployeeCertificateDto[] | undefined;
    totalCount: number;
    isComplatedProfile: boolean;

    constructor(data?: IPagedResultEmployeeCertificateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EmployeeCertificateDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.isComplatedProfile = _data["isComplatedProfile"];
        }
    }

    static fromJS(data: any): PagedResultEmployeeCertificateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultEmployeeCertificateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["isComplatedProfile"] = this.isComplatedProfile;
        return data;
    }

    clone(): PagedResultEmployeeCertificateDto {
        const json = this.toJSON();
        let result = new PagedResultEmployeeCertificateDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultEmployeeCertificateDto {
    items: EmployeeCertificateDto[] | undefined;
    totalCount: number;
    isComplatedProfile: boolean;
}

export class PagedResultEmployeeLanguageDto implements IPagedResultEmployeeLanguageDto {
    items: EmployeeLanguageDto[] | undefined;
    totalCount: number;
    isComplatedProfile: boolean;

    constructor(data?: IPagedResultEmployeeLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EmployeeLanguageDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.isComplatedProfile = _data["isComplatedProfile"];
        }
    }

    static fromJS(data: any): PagedResultEmployeeLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultEmployeeLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["isComplatedProfile"] = this.isComplatedProfile;
        return data;
    }

    clone(): PagedResultEmployeeLanguageDto {
        const json = this.toJSON();
        let result = new PagedResultEmployeeLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultEmployeeLanguageDto {
    items: EmployeeLanguageDto[] | undefined;
    totalCount: number;
    isComplatedProfile: boolean;
}

export class PagedResultEmployeeSkillDto implements IPagedResultEmployeeSkillDto {
    items: EmployeeSkillDto[] | undefined;
    totalCount: number;
    isComplatedProfile: boolean;

    constructor(data?: IPagedResultEmployeeSkillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EmployeeSkillDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.isComplatedProfile = _data["isComplatedProfile"];
        }
    }

    static fromJS(data: any): PagedResultEmployeeSkillDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultEmployeeSkillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["isComplatedProfile"] = this.isComplatedProfile;
        return data;
    }

    clone(): PagedResultEmployeeSkillDto {
        const json = this.toJSON();
        let result = new PagedResultEmployeeSkillDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultEmployeeSkillDto {
    items: EmployeeSkillDto[] | undefined;
    totalCount: number;
    isComplatedProfile: boolean;
}

export class PermissionDto implements IPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class PermissionDtoListResultDto implements IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;

    constructor(data?: IPermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PermissionDtoListResultDto {
        const json = this.toJSON();
        let result = new PermissionDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;
}

export enum PositionLevel {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
}

export class RecommendedJobDto implements IRecommendedJobDto {
    id: number;
    jobPositionName: string | undefined;
    creationTime: moment.Moment;
    companyId: number;
    countryName: string | undefined;
    cityName: string | undefined;
    companyName: string | undefined;
    companyImage: string | undefined;
    jobType: JobType;

    constructor(data?: IRecommendedJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jobPositionName = _data["jobPositionName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.companyId = _data["companyId"];
            this.countryName = _data["countryName"];
            this.cityName = _data["cityName"];
            this.companyName = _data["companyName"];
            this.companyImage = _data["companyImage"];
            this.jobType = _data["jobType"];
        }
    }

    static fromJS(data: any): RecommendedJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecommendedJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jobPositionName"] = this.jobPositionName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["companyId"] = this.companyId;
        data["countryName"] = this.countryName;
        data["cityName"] = this.cityName;
        data["companyName"] = this.companyName;
        data["companyImage"] = this.companyImage;
        data["jobType"] = this.jobType;
        return data;
    }

    clone(): RecommendedJobDto {
        const json = this.toJSON();
        let result = new RecommendedJobDto();
        result.init(json);
        return result;
    }
}

export interface IRecommendedJobDto {
    id: number;
    jobPositionName: string | undefined;
    creationTime: moment.Moment;
    companyId: number;
    countryName: string | undefined;
    cityName: string | undefined;
    companyName: string | undefined;
    companyImage: string | undefined;
    jobType: JobType;
}

export class RecommendedJobDtoPagedResultDto implements IRecommendedJobDtoPagedResultDto {
    items: RecommendedJobDto[] | undefined;
    totalCount: number;

    constructor(data?: IRecommendedJobDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RecommendedJobDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RecommendedJobDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecommendedJobDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): RecommendedJobDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RecommendedJobDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRecommendedJobDtoPagedResultDto {
    items: RecommendedJobDto[] | undefined;
    totalCount: number;
}

export class RegisterInput implements IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }

    clone(): RegisterInput {
        const json = this.toJSON();
        let result = new RegisterInput();
        result.init(json);
        return result;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }

    clone(): RegisterOutput {
        const json = this.toJSON();
        let result = new RegisterOutput();
        result.init(json);
        return result;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class ResetPasswordDto implements IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ResetPasswordDto {
        const json = this.toJSON();
        let result = new ResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;
}

export class ResetPasswordWebsiteDto implements IResetPasswordWebsiteDto {
    email: string;
    newPassword: string;
    code: string;

    constructor(data?: IResetPasswordWebsiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.newPassword = _data["newPassword"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ResetPasswordWebsiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordWebsiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["newPassword"] = this.newPassword;
        data["code"] = this.code;
        return data;
    }

    clone(): ResetPasswordWebsiteDto {
        const json = this.toJSON();
        let result = new ResetPasswordWebsiteDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordWebsiteDto {
    email: string;
    newPassword: string;
    code: string;
}

export class RoleDto implements IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class RoleDtoListResultDto implements IRoleDtoListResultDto {
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoListResultDto {
    items: RoleDto[] | undefined;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;
}

export class RoleEditDto implements IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        return data;
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
}

export class RoleListDto implements IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleListDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export class SelectedReceiversForNotificationDto implements ISelectedReceiversForNotificationDto {
    id: number;
    firebaseToken: string;

    constructor(data?: ISelectedReceiversForNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firebaseToken = _data["firebaseToken"];
        }
    }

    static fromJS(data: any): SelectedReceiversForNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectedReceiversForNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firebaseToken"] = this.firebaseToken;
        return data;
    }

    clone(): SelectedReceiversForNotificationDto {
        const json = this.toJSON();
        let result = new SelectedReceiversForNotificationDto();
        result.init(json);
        return result;
    }
}

export interface ISelectedReceiversForNotificationDto {
    id: number;
    firebaseToken: string;
}

export class SettingDto implements ISettingDto {
    fromEmailAddress: string;
    emailPassword: string;
    port: string;
    host: string;
    receiverEmailAddress: string;
    openRouterApiKey: string | undefined;
    openRouterModel: string | undefined;

    constructor(data?: ISettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromEmailAddress = _data["fromEmailAddress"];
            this.emailPassword = _data["emailPassword"];
            this.port = _data["port"];
            this.host = _data["host"];
            this.receiverEmailAddress = _data["receiverEmailAddress"];
            this.openRouterApiKey = _data["openRouterApiKey"];
            this.openRouterModel = _data["openRouterModel"];
        }
    }

    static fromJS(data: any): SettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromEmailAddress"] = this.fromEmailAddress;
        data["emailPassword"] = this.emailPassword;
        data["port"] = this.port;
        data["host"] = this.host;
        data["receiverEmailAddress"] = this.receiverEmailAddress;
        data["openRouterApiKey"] = this.openRouterApiKey;
        data["openRouterModel"] = this.openRouterModel;
        return data;
    }

    clone(): SettingDto {
        const json = this.toJSON();
        let result = new SettingDto();
        result.init(json);
        return result;
    }
}

export interface ISettingDto {
    fromEmailAddress: string;
    emailPassword: string;
    port: string;
    host: string;
    receiverEmailAddress: string;
    openRouterApiKey: string | undefined;
    openRouterModel: string | undefined;
}

export class SignUpCompanyDto implements ISignUpCompanyDto {
    userName: string | undefined;
    phoneNumber: string | undefined;
    emailAddress: string;
    password: string;
    affiliateId: number | undefined;

    constructor(data?: ISignUpCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.phoneNumber = _data["phoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.affiliateId = _data["affiliateId"];
        }
    }

    static fromJS(data: any): SignUpCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignUpCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["phoneNumber"] = this.phoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["affiliateId"] = this.affiliateId;
        return data;
    }

    clone(): SignUpCompanyDto {
        const json = this.toJSON();
        let result = new SignUpCompanyDto();
        result.init(json);
        return result;
    }
}

export interface ISignUpCompanyDto {
    userName: string | undefined;
    phoneNumber: string | undefined;
    emailAddress: string;
    password: string;
    affiliateId: number | undefined;
}

export class SignUpEmployeeDto implements ISignUpEmployeeDto {
    userName: string | undefined;
    phoneNumber: string | undefined;
    emailAddress: string;
    password: string;
    affiliateId: number | undefined;

    constructor(data?: ISignUpEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.phoneNumber = _data["phoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.affiliateId = _data["affiliateId"];
        }
    }

    static fromJS(data: any): SignUpEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignUpEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["phoneNumber"] = this.phoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["affiliateId"] = this.affiliateId;
        return data;
    }

    clone(): SignUpEmployeeDto {
        const json = this.toJSON();
        let result = new SignUpEmployeeDto();
        result.init(json);
        return result;
    }
}

export interface ISignUpEmployeeDto {
    userName: string | undefined;
    phoneNumber: string | undefined;
    emailAddress: string;
    password: string;
    affiliateId: number | undefined;
}

export class SkillByIdDto implements ISkillByIdDto {
    id: number;
    name: string | undefined;
    industryId: number | undefined;
    nameAr: string | undefined;

    constructor(data?: ISkillByIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.industryId = _data["industryId"];
            this.nameAr = _data["nameAr"];
        }
    }

    static fromJS(data: any): SkillByIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new SkillByIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["industryId"] = this.industryId;
        data["nameAr"] = this.nameAr;
        return data;
    }

    clone(): SkillByIdDto {
        const json = this.toJSON();
        let result = new SkillByIdDto();
        result.init(json);
        return result;
    }
}

export interface ISkillByIdDto {
    id: number;
    name: string | undefined;
    industryId: number | undefined;
    nameAr: string | undefined;
}

export class SkillDto implements ISkillDto {
    id: number;
    name: string | undefined;

    constructor(data?: ISkillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SkillDto {
        data = typeof data === 'object' ? data : {};
        let result = new SkillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): SkillDto {
        const json = this.toJSON();
        let result = new SkillDto();
        result.init(json);
        return result;
    }
}

export interface ISkillDto {
    id: number;
    name: string | undefined;
}

export class SkillDtoPagedResultDto implements ISkillDtoPagedResultDto {
    items: SkillDto[] | undefined;
    totalCount: number;

    constructor(data?: ISkillDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SkillDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SkillDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SkillDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SkillDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SkillDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISkillDtoPagedResultDto {
    items: SkillDto[] | undefined;
    totalCount: number;
}

export enum TenantAvailabilityState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class TenantDto implements ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TenantDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        return data;
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
}

export class UpdateCityDto implements IUpdateCityDto {
    id: number;
    name: string;
    nameAr: string | undefined;
    countryId: number;
    order: number | undefined;

    constructor(data?: IUpdateCityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameAr = _data["nameAr"];
            this.countryId = _data["countryId"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): UpdateCityDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameAr"] = this.nameAr;
        data["countryId"] = this.countryId;
        data["order"] = this.order;
        return data;
    }

    clone(): UpdateCityDto {
        const json = this.toJSON();
        let result = new UpdateCityDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCityDto {
    id: number;
    name: string;
    nameAr: string | undefined;
    countryId: number;
    order: number | undefined;
}

export class UpdateCompanyPasswordDto implements IUpdateCompanyPasswordDto {
    currentPassword: string;
    newPassword: string;

    constructor(data?: IUpdateCompanyPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): UpdateCompanyPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): UpdateCompanyPasswordDto {
        const json = this.toJSON();
        let result = new UpdateCompanyPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCompanyPasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class UpdateCompanyUserAccountDto implements IUpdateCompanyUserAccountDto {
    userName: string | undefined;
    emailAddress: string;
    phoneNumber: string | undefined;
    confirmEmailCode: string | undefined;

    constructor(data?: IUpdateCompanyUserAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.confirmEmailCode = _data["confirmEmailCode"];
        }
    }

    static fromJS(data: any): UpdateCompanyUserAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyUserAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["confirmEmailCode"] = this.confirmEmailCode;
        return data;
    }

    clone(): UpdateCompanyUserAccountDto {
        const json = this.toJSON();
        let result = new UpdateCompanyUserAccountDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCompanyUserAccountDto {
    userName: string | undefined;
    emailAddress: string;
    phoneNumber: string | undefined;
    confirmEmailCode: string | undefined;
}

export class UpdateContactInfoDto implements IUpdateContactInfoDto {
    id: number;
    content: string | undefined;
    iconFile: string | undefined;

    constructor(data?: IUpdateContactInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
            this.iconFile = _data["iconFile"];
        }
    }

    static fromJS(data: any): UpdateContactInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContactInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        data["iconFile"] = this.iconFile;
        return data;
    }

    clone(): UpdateContactInfoDto {
        const json = this.toJSON();
        let result = new UpdateContactInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateContactInfoDto {
    id: number;
    content: string | undefined;
    iconFile: string | undefined;
}

export class UpdateCountryDto implements IUpdateCountryDto {
    id: number;
    name: string;
    order: number | undefined;
    showInHomePage: boolean;
    nameAr: string | undefined;
    isDisabled: boolean;

    constructor(data?: IUpdateCountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.order = _data["order"];
            this.showInHomePage = _data["showInHomePage"];
            this.nameAr = _data["nameAr"];
            this.isDisabled = _data["isDisabled"];
        }
    }

    static fromJS(data: any): UpdateCountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["order"] = this.order;
        data["showInHomePage"] = this.showInHomePage;
        data["nameAr"] = this.nameAr;
        data["isDisabled"] = this.isDisabled;
        return data;
    }

    clone(): UpdateCountryDto {
        const json = this.toJSON();
        let result = new UpdateCountryDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCountryDto {
    id: number;
    name: string;
    order: number | undefined;
    showInHomePage: boolean;
    nameAr: string | undefined;
    isDisabled: boolean;
}

export class UpdateEmployeeCertificateDto implements IUpdateEmployeeCertificateDto {
    id: number;
    certificateName: string | undefined;
    educationCertificateType: EducationCertificateType;
    college: string;
    successDegree: number | undefined;
    from: moment.Moment;
    to: moment.Moment | undefined;
    shortDescription: string | undefined;

    constructor(data?: IUpdateEmployeeCertificateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.certificateName = _data["certificateName"];
            this.educationCertificateType = _data["educationCertificateType"];
            this.college = _data["college"];
            this.successDegree = _data["successDegree"];
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
            this.shortDescription = _data["shortDescription"];
        }
    }

    static fromJS(data: any): UpdateEmployeeCertificateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmployeeCertificateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["certificateName"] = this.certificateName;
        data["educationCertificateType"] = this.educationCertificateType;
        data["college"] = this.college;
        data["successDegree"] = this.successDegree;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["shortDescription"] = this.shortDescription;
        return data;
    }

    clone(): UpdateEmployeeCertificateDto {
        const json = this.toJSON();
        let result = new UpdateEmployeeCertificateDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateEmployeeCertificateDto {
    id: number;
    certificateName: string | undefined;
    educationCertificateType: EducationCertificateType;
    college: string;
    successDegree: number | undefined;
    from: moment.Moment;
    to: moment.Moment | undefined;
    shortDescription: string | undefined;
}

export class UpdateEmployeeExperienceDto implements IUpdateEmployeeExperienceDto {
    id: number;
    industryId: number;
    jobPositionId: number | undefined;
    otherPositionName: string | undefined;
    companyName: string | undefined;
    country: string | undefined;
    from: moment.Moment | undefined;
    to: moment.Moment | undefined;
    shortDescription: string | undefined;

    constructor(data?: IUpdateEmployeeExperienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.industryId = _data["industryId"];
            this.jobPositionId = _data["jobPositionId"];
            this.otherPositionName = _data["otherPositionName"];
            this.companyName = _data["companyName"];
            this.country = _data["country"];
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
            this.shortDescription = _data["shortDescription"];
        }
    }

    static fromJS(data: any): UpdateEmployeeExperienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmployeeExperienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["industryId"] = this.industryId;
        data["jobPositionId"] = this.jobPositionId;
        data["otherPositionName"] = this.otherPositionName;
        data["companyName"] = this.companyName;
        data["country"] = this.country;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["shortDescription"] = this.shortDescription;
        return data;
    }

    clone(): UpdateEmployeeExperienceDto {
        const json = this.toJSON();
        let result = new UpdateEmployeeExperienceDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateEmployeeExperienceDto {
    id: number;
    industryId: number;
    jobPositionId: number | undefined;
    otherPositionName: string | undefined;
    companyName: string | undefined;
    country: string | undefined;
    from: moment.Moment | undefined;
    to: moment.Moment | undefined;
    shortDescription: string | undefined;
}

export class UpdateEmployeePasswordDto implements IUpdateEmployeePasswordDto {
    currentPassword: string;
    newPassword: string;

    constructor(data?: IUpdateEmployeePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): UpdateEmployeePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmployeePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): UpdateEmployeePasswordDto {
        const json = this.toJSON();
        let result = new UpdateEmployeePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateEmployeePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class UpdateEmployeeUserAccountDto implements IUpdateEmployeeUserAccountDto {
    userName: string | undefined;
    emailAddress: string;
    phoneNumber: string | undefined;
    confirmEmailCode: string | undefined;

    constructor(data?: IUpdateEmployeeUserAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.confirmEmailCode = _data["confirmEmailCode"];
        }
    }

    static fromJS(data: any): UpdateEmployeeUserAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmployeeUserAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["confirmEmailCode"] = this.confirmEmailCode;
        return data;
    }

    clone(): UpdateEmployeeUserAccountDto {
        const json = this.toJSON();
        let result = new UpdateEmployeeUserAccountDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateEmployeeUserAccountDto {
    userName: string | undefined;
    emailAddress: string;
    phoneNumber: string | undefined;
    confirmEmailCode: string | undefined;
}

export class UpdateJobByCompanyDto implements IUpdateJobByCompanyDto {
    id: number;
    industryId: number | undefined;
    jobPositionId: number | undefined;
    educationLevel: EducationLevel;
    positionLevel: PositionLevel;
    gender: Gender;
    jobAgeRange: JobAgeRange;
    jobType: JobType;
    workPlaceType: WorkPlaceType;
    countryId: number | undefined;
    cityId: number | undefined;
    vacanciesNumber: number | undefined;
    isSalaryAfterInterview: boolean;
    salary: number | undefined;
    jobDescription: string | undefined;
    isShowWithCompany: boolean;
    closeDate: moment.Moment | undefined;

    constructor(data?: IUpdateJobByCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.industryId = _data["industryId"];
            this.jobPositionId = _data["jobPositionId"];
            this.educationLevel = _data["educationLevel"];
            this.positionLevel = _data["positionLevel"];
            this.gender = _data["gender"];
            this.jobAgeRange = _data["jobAgeRange"];
            this.jobType = _data["jobType"];
            this.workPlaceType = _data["workPlaceType"];
            this.countryId = _data["countryId"];
            this.cityId = _data["cityId"];
            this.vacanciesNumber = _data["vacanciesNumber"];
            this.isSalaryAfterInterview = _data["isSalaryAfterInterview"];
            this.salary = _data["salary"];
            this.jobDescription = _data["jobDescription"];
            this.isShowWithCompany = _data["isShowWithCompany"];
            this.closeDate = _data["closeDate"] ? moment(_data["closeDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateJobByCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJobByCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["industryId"] = this.industryId;
        data["jobPositionId"] = this.jobPositionId;
        data["educationLevel"] = this.educationLevel;
        data["positionLevel"] = this.positionLevel;
        data["gender"] = this.gender;
        data["jobAgeRange"] = this.jobAgeRange;
        data["jobType"] = this.jobType;
        data["workPlaceType"] = this.workPlaceType;
        data["countryId"] = this.countryId;
        data["cityId"] = this.cityId;
        data["vacanciesNumber"] = this.vacanciesNumber;
        data["isSalaryAfterInterview"] = this.isSalaryAfterInterview;
        data["salary"] = this.salary;
        data["jobDescription"] = this.jobDescription;
        data["isShowWithCompany"] = this.isShowWithCompany;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): UpdateJobByCompanyDto {
        const json = this.toJSON();
        let result = new UpdateJobByCompanyDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateJobByCompanyDto {
    id: number;
    industryId: number | undefined;
    jobPositionId: number | undefined;
    educationLevel: EducationLevel;
    positionLevel: PositionLevel;
    gender: Gender;
    jobAgeRange: JobAgeRange;
    jobType: JobType;
    workPlaceType: WorkPlaceType;
    countryId: number | undefined;
    cityId: number | undefined;
    vacanciesNumber: number | undefined;
    isSalaryAfterInterview: boolean;
    salary: number | undefined;
    jobDescription: string | undefined;
    isShowWithCompany: boolean;
    closeDate: moment.Moment | undefined;
}

export class UpdateJobPositionDto implements IUpdateJobPositionDto {
    id: number;
    name: string;
    showInHomePage: boolean;
    industryId: number | undefined;
    nameAr: string | undefined;

    constructor(data?: IUpdateJobPositionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.showInHomePage = _data["showInHomePage"];
            this.industryId = _data["industryId"];
            this.nameAr = _data["nameAr"];
        }
    }

    static fromJS(data: any): UpdateJobPositionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJobPositionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["showInHomePage"] = this.showInHomePage;
        data["industryId"] = this.industryId;
        data["nameAr"] = this.nameAr;
        return data;
    }

    clone(): UpdateJobPositionDto {
        const json = this.toJSON();
        let result = new UpdateJobPositionDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateJobPositionDto {
    id: number;
    name: string;
    showInHomePage: boolean;
    industryId: number | undefined;
    nameAr: string | undefined;
}

export class UpdateSecondInfoCompanyDto implements IUpdateSecondInfoCompanyDto {
    establishDate: moment.Moment | undefined;
    companySize: CompanySize;
    numberOfBranchs: number | undefined;
    description: string | undefined;

    constructor(data?: IUpdateSecondInfoCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.establishDate = _data["establishDate"] ? moment(_data["establishDate"].toString()) : <any>undefined;
            this.companySize = _data["companySize"];
            this.numberOfBranchs = _data["numberOfBranchs"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateSecondInfoCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSecondInfoCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["establishDate"] = this.establishDate ? this.establishDate.toISOString() : <any>undefined;
        data["companySize"] = this.companySize;
        data["numberOfBranchs"] = this.numberOfBranchs;
        data["description"] = this.description;
        return data;
    }

    clone(): UpdateSecondInfoCompanyDto {
        const json = this.toJSON();
        let result = new UpdateSecondInfoCompanyDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSecondInfoCompanyDto {
    establishDate: moment.Moment | undefined;
    companySize: CompanySize;
    numberOfBranchs: number | undefined;
    description: string | undefined;
}

export class UpdateSecondInfoEmployeeDto implements IUpdateSecondInfoEmployeeDto {
    maritalStatus: MaritalStatus;
    militaryStatus: MilitaryStatus;
    salary: number | undefined;
    healthStatus: HealthStatus;
    employmentStatus: EmploymentStatus;
    gender: Gender;

    constructor(data?: IUpdateSecondInfoEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maritalStatus = _data["maritalStatus"];
            this.militaryStatus = _data["militaryStatus"];
            this.salary = _data["salary"];
            this.healthStatus = _data["healthStatus"];
            this.employmentStatus = _data["employmentStatus"];
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): UpdateSecondInfoEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSecondInfoEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maritalStatus"] = this.maritalStatus;
        data["militaryStatus"] = this.militaryStatus;
        data["salary"] = this.salary;
        data["healthStatus"] = this.healthStatus;
        data["employmentStatus"] = this.employmentStatus;
        data["gender"] = this.gender;
        return data;
    }

    clone(): UpdateSecondInfoEmployeeDto {
        const json = this.toJSON();
        let result = new UpdateSecondInfoEmployeeDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSecondInfoEmployeeDto {
    maritalStatus: MaritalStatus;
    militaryStatus: MilitaryStatus;
    salary: number | undefined;
    healthStatus: HealthStatus;
    employmentStatus: EmploymentStatus;
    gender: Gender;
}

export class UpdateSkillDto implements IUpdateSkillDto {
    id: number;
    name: string;
    industryId: number | undefined;
    nameAr: string | undefined;

    constructor(data?: IUpdateSkillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.industryId = _data["industryId"];
            this.nameAr = _data["nameAr"];
        }
    }

    static fromJS(data: any): UpdateSkillDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSkillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["industryId"] = this.industryId;
        data["nameAr"] = this.nameAr;
        return data;
    }

    clone(): UpdateSkillDto {
        const json = this.toJSON();
        let result = new UpdateSkillDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSkillDto {
    id: number;
    name: string;
    industryId: number | undefined;
    nameAr: string | undefined;
}

export class UserDto implements IUserDto {
    id: number;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.fullName = _data["fullName"];
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    id: number;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    userType: UserType;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.userType = _data["userType"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["userType"] = this.userType;
        return data;
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    userType: UserType;
}

export enum UserType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum WorkPlaceType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum DurationType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum JobPublishDurationType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum DurationType2 {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum JobPublishDurationType2 {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum CompanyPackageByAdminDtoDurationType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum CompanyPackageByAdminDtoJobPublishDurationType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum PackageByCompanyDtoDurationType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum PackageByIdDtoDurationType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum PackageByIdDtoJobPublishDurationType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum PackageDtoDurationType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum PackageDtoJobPublishDurationType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}